export default {
  seleccionaNegocio: "Select business...",
  filtraPorEtiqueta: "Filter by tag",
  noEncontramosResultadosPara: "We couldn't find results for ",
  mostrando: "Showing",
  resultado: "result",
  resultados: "results",

  // ALMACEN
  totalAlmacen: "Warehouse Total",
  totalAlmacenDto: "Warehouse Total Discount",
  existenciasTeoricas: "Theoretical Stock",
  diferencia: "Difference",
  noContabilizado: "Not posted",
  seleccioneUnaFechaDeInicioYUnaFechaDeFin:
    "Select a start date and an end date",

  // INFORMES
  inicio: "Home",
  informes: "Reports",
  productos: "Products",
  ventasPorNegocio: "Sales by business",
  casas: "Houses",
  facturasSimplificadas: "Simplified invoices",
  comprasPorNegocio: "Purchases by business",
  comprasPorCasas: "Purchases by houses",
  gastosPorProveedor: "Expenses by supplier",
  gastosPorSubproductos: "Expenses by raw materials",
  sage: "SAGE",
  sageplancuentas: "Chart of Accounts",
  sageclientes: "Customers",
  sageefectos: "Bills of exchange",
  sageasientos: "Journal Entry",

  // CASAS
  nuevaCasa: "New house",
  casa: "House",
  negocio: "Business",
  desde: "From",
  hasta: "To",
  consultar: "Search",
  infoCasas:
    "This house consumption comes from expenses entered in the selected date range",
  exportarInforme: "Export report",
  exportarPdf: "Export as PDF",
  exportarExcel: "Export as Excel",
  exportarExcelSinSubproductos: "Export as Excel with raw materials",

  // TABLA
  fecha: "Date",
  subproductos: "Raw materials",
  subproducto: "Raw material",
  unidades: "Units",
  partes: "Parts",
  precio: "Price",
  total: "Total",
  infoConsumo:
    "This house consumption comes from expenses entered in the selected date range",
  noHay: "There are no",
  gastos: "Expenses",
  rangoDeFechas: "in this date range.",
  clickConsultarParaRealizarBusqueda: "Click the Consultar button to perform the search",
  avisoDatosUltimaConsulta: "This data is from the last search performed. If you changed the business, TPV or dates, click \"Consultar\" to refresh it.",
  ultimaActualizacion: "Last updated",
  negocioBloqueadoConsultasEnCurso: "There are searches still running. Wait for them to finish before switching business.",
  configuracion: "Settings",
  datosFiscales: "Tax Data",

  // DATOS FISCALES
  nombreFiscal: "Legal name",

  // FORM CASA
  nombreCasa: "House Name",
  cifNif: "CIF / NIF",
  direccion: "Address",
  provincia: "Province",
  ciudad: "City",
  codigoPostal: "Postal code",
  pais: "Country",
  telefono: "Phone",
  correoElectronico: "Email",
  iban: "IBAN",
  numeroRegistroSanitario: "Sanitary registration number",
  baja: "Inactive",
  guardar: "Save",
  cancelar: "Cancel",
  replicar: "Replicate to other businesses",
  replicarCasa: "Replicate house to other businesses",
  seleccionarTodos: "Select all",
  aceptar: "Accept",
  casaMin: "houses",

  compras: "Purchases",
  agregarCasa: "Add House",
  email: "Email",
  acciones: "Actions",
  turnos: "Shifts",
  editar: "Edit",
  enEsteNegocio: " in this business.",

  // PLACEHOLDER
  introduzcaNombre: "Enter name",
  introduzcaCifNif: "Enter CIF / NIF",
  introduzcaDireccion: "Enter address",
  introduzcaProvincia: "Enter province",
  introduzcaCiudad: "Enter city",
  introduzcaCodigoPostal: "Enter postal code",
  introduzcaTelefono: "Enter phone number",
  introduzcaCorreo: "Enter email",
  introduzcaIban: "Enter IBAN",
  introduzcaNumeroRegistroSanitario: "Enter sanitary registration number",
  buscar: "Search...",

  // PROVEEDORES
  proveedores: "Suppliers",
  agregarProveedor: "Add Supplier",
  categoria: "Category",
  proveedoresMin: "suppliers",

  // FORM
  nombreProveedor: "Supplier Name",
  acreedor: "Creditor",
  infoAcreedor:
    "(If a supplier is a creditor it will not appear in Numier POS)",
  replicarProveedor: "Replicate supplier to other businesses",
  category: "Category",
  replicarCategory: "Replicate tag to other businesses",

  // ETIQUETAS
  etiquetas: "Tags",
  etiqueta: "Tag",
  sinEtiqueta: "No tag",
  nuevaEtiqueta: "New tag",
  agregarEtiqueta: "Add Tag",
  tipo: "Type",
  etiquetaPadre: "Parent Tag",
  tipoPadre: "Parent Type",

  // FORM
  nombreEtiqueta: "Tag Name",

  // SUBPRODUCTOS
  agregarSubproducto: "Add Raw Material",
  precioCompra: "Purchase price",
  escandallo: "Cost breakdown",
  subproductosCreados: "Raw Materials Created",
  nuevaCategoria: "New category",
  materiaPrima: "Raw material",
  materiasPrimas: "Raw materials",

  // FORM
  nuevoProveedor: "New Supplier",
  nombreSubproducto: "Raw Material Name",
  codigoBarra: "Barcode",
  descripcion: "Description",
  tipoIva: "VAT Type",
  cuotaIVA: "VAT Quota",
  ivaIncluido: "(VAT included)",
  descuentoCompra: "Purchase Discount",
  porcentaje: "(% Percentage)",
  guardarEnAlmacen: "Save in Warehouse",
  stockMinimo: "Minimum Stock",
  stockOptimo: "Optimal Stock",
  gastosPorProveedoresUnidos: "Expenses by Joined Suppliers",
  caracteresRestantes: "Remaining Characters",

  // INFORME SUBPRODUCTO
  referencia: "Reference",
  uds: "Units",
  iva: "VAT",
  importe: "Amount",
  imp: "Amt.",
  sinDto: "NO DISCOUNT",
  importeConIva: "Amount with VAT",
  importeSinIva: "Amount without VAT",
  importeSinIvaDto: "Amount without VAT with Discount",
  precioUdSinIva: "Price / unit without VAT",
  dto: "Disc.",
  ttal: "Total",

  // PRODUCTS
  producto: "Product",
  precioDeCoste: "Cost Price",
  tarifa1: "Rate 1",
  tarifa2: "Rate 2",
  tarifa3: "Rate 3",
  tarifa4: "Rate 4",
  agregarProductos: "Add Product",
  noHayProductosEnEsteNegocio: "No products in this business",
  sinCategoria: "Without Category",
  cliente: "Customer",

  // FORM
  nombreProducto: "Product Name",
  codigoDeBarra: "Barcode",
  colorBoton: "Button Color",
  descuento: "Discount",
  precioCoste: "Cost Price",
  opcionesAlSeleccionarElArticulo: "Options when selecting the product",
  numeroDeOpcionales: "Number of Optional Raw Materials",
  impresoraComandasTPV: "POS Order Printer",
  impresoraComandasPDA: "PDA Order Printer",
  copiaImpresoraComandasTPV: "Copy POS Order Printer",
  copiaImpresoraComandasPDA: "Copy PDA Order Printer",
  impresionPlano: "Plan Printer",
  impresionPlanoKDS: "KDS Plan Printer",
  copiaImpresionPlano: "Copy Plan Printer",
  copiaImpresionPlanoKDS: "Copy KDS Plan Printer",
  impresionPlano1: "Plan Printer 1",
  impresionPlano2: "Plan Printer 2",
  impresionPlano3: "Plan Printer 3",
  impresionKDSTPV: "Send order from POS",
  impresionKDSPDA: "Send order from PDA",
  copiaImpresionKDSTPV: "Copy order from POS",
  copiaImpresionKDSPDA: "Copy order from PDA",
  pedirPrecio: "Ask for Price",
  pedirPeso: "Ask for Weight",
  pedirImporte: "Ask for Amount",
  promocionable: "Promotable",
  mostrarPC: "Show on PC",
  mostrarPDA: "Show on PDA",
  noImprimir: "Do Not Print",
  numeroPlato: "Default Dish Number",
  seleccionIngredientes: "Enable Ingredient Selection",
  introduzcaDescripcion: "Enter description",
  introduzcaCodigoDeBarras: "Enter barcode",
  introduzcaPrecioCoste: "Enter cost price",
  opcion1: "Option 1",
  opcion2: "Option 2",
  opcion3: "Option 3",
  opcion4: "Option 4",
  opcion5: "Option 5",
  numOpcionales: "Number of optional raw materials",

  // OPERARARIOS
  operarios: "Workers",
  agregarOperario: "Add Worker",
  apellido: "Last Name",
  nombreOperarios: "Worker Name",
  pass: "Password",
  salario: "Salary",
  passTurn: "Shift Password",
  hombre: "Male",
  mujer: "Female",
  replicarProducto: "Replicate product in other businesses",
  introduzcaEscandallo: "Enter recipe cost sheet",
  introduzcaStockMinimo: "Enter minimum stock",
  introduzcaStockOptimo: "Enter optimal stock",
  introduzcaPrecioCompra: "Enter purchase price",
  introduzcaApellido: "Enter last name",
  introduzcaPass: "Enter password",
  introduzcaEmail: "Enter email",
  introduzcaSalario: "Enter salary",
  introduzcapassTurn: "Enter shift password",
  replicarOperario: "Replicate worker in another business",
  TPV: "POS",
  precioMed: "Avg. Price",
  precioMedSinIva: "Avg. Price without VAT",
  porUnidad: "Per Unit",
  porImporte: "By Amount",
  contrasenya: "PDA Password",
  repartidor: "Delivery Person",
  buscaRepartidor: "Search Delivery Person",
  noMostrarEnVentas: "Do not show in sales",
  noHayOperariosEnEsteNegocio: "No workers in this business",
  VerDetalles: "View Details",
  codigoTurno: "Shift Code",
  operarioDatosIncompletos: "All fields are required",
  enviarQR: "Send Shift QR",
  descargarTurnoQR: "Download PDF with Shift QR",
  enviarEmailTurnoQR: "Send Shift QR by Email",
  emailEnviado: "The email has been sent successfully",
  enviado: "Sent",
  errorActualizar: "Error updating worker",
  errorEnviarEmail: "Could not send email",
  accesoDenegado: "Access Denied",
  noTienesPermisosParaRealizar: "You don't have permission to perform this action",
  emailNoValido: "The email format is not valid",
  gestionTurnos: "Worker Shifts",
  gestionTurnosSubtitle: "Consult and manage worker check-ins",
  gestionTurnosSubtitleConsulta: "Consult and manage",
  gestionTurnosSubtitleDeLos: "of the",
  gestionTurnosSubtitleFichajes: "check-ins",
  gestionTurnosSubtitleOperarios: "of the workers",

  // CLIENTES
  clientes: "Customers",
  companyia: "Campaign",
  agregarCliente: "Add Customer",
  nombreCliente: "Customer Name",
  saldo: "Balance",
  infoCliente: "In case of using balance cards",
  tarifa: "Rate",
  descuentoImporte: "Discount Amount",
  noHayClientesEnEsteNegocio: "No customers in this business",
  barCode: "Barcode",
  cuentaContableSocio: "Partner Accounting Account",
  cuentaContableLevy: "Levy Accounting Account",

  // IMPRESION
  impresionDeComandas: "Order Printing",
  copiaDeImpresionDeComandas: "Order Printing Copy",
  impresionPorPlana: "Plan Printing",
  impresionPorKDS: "KDS Printing",
  monitorDeCocina: "Kitchen Monitor",

  // INFORMES
  ventas: "Sales",
  tarjetas: "Cards",
  cheque: "Check",
  cambio: "Change",
  recuento: "Count",
  descuadre: "Mismatch",
  siguienteDia: "Next day",
  incidencias: "Incidents",
  recaudado: "Collected",
  noHayVentasEnEsteRangoDeFechas: "No sales in this date range",
  tickets: "Tickets",
  factura: "Invoice",
  noHayFormasDePagoEnEsteRangoDeFecha: "No payment methods in this date range",
  desglose: "Breakdown",
  sinBase: "Without Base",
  base: "Base",
  baseTotal: "Total Base",
  impuesto: "Tax",
  facturasEmitidas: "Issued Invoices",
  mesa: "Table",
  cifnif: "CIF/NIF",
  cobro: "Collection",
  noHayFacturasEmitidasEnEsteRangoDeFecha:
    "No invoices issued in this date range",
  estadisticasAgencias: "Agency Statistics",
  agencia: "Agency",
  comentario: "Comment",
  noHayEstadisticasDeAgenciaEnEsteRangoDeFechas:
    "No agency statistics in this date range",
  desglosesImpuestos: "Taxes per cash closure",
  desglosesImpuestosAgencia: "Taxes per agency",
  noHayFormasDePagoEnEsteRangoDeFechas: "No payment methods in this date range",
  cuentasAparcadas: "Credit Accounts",
  operacion: "Operation",
  operario: "Operator",
  noExisteDesgloseImpuestos: "No tax breakdown exists.",
  noHayCuentasAparcadasEnEsteRangoDeFechas:
    "No credit accounts in this date range",
  noHayCuentasAnuladasEnEsteRangoDeFechas:
    "No canceled accounts in this date range",
  cierreCaja: "Cash Closure",
  fechaCierre: "Closure Date",
  venta: "Sale",
  totalRecaudado: "Total Collected",
  noHayCierresDeCajaEnEsteRangoDeFecha: "No cash closures in this date range",
  cierreCajaZ: "Z Cash Closure",

  // MODAL
  n: "No.",
  apertura: "Opening",
  cierre: "Closing",
  totalVenta: "Total Sale",
  efectivo: "Cash",
  tarjetaCheques: "Card+Checks",
  totalTeorico: "Theoretical Total",
  totalEnArqueo: "Counted Total",
  cambioSig: "Next Change",
  volver: "Back",
  confirmacionImportacionHeader: "Import Confirmation",
  confirmacionImportacionText: "Are you sure you want to import?",
  confirmar: "Confirm",
  registros: "records",
  headerError: "ERROR",
  bodyError: "Please upload a file with fewer than 10,000 records",
  en: "In ",

  // OPERARIOS
  ventasPorOperarios: "Accounts collected by operator",
  invitaciones: "Invitations",
  horas: "Hours",
  sueldo: "Salary",
  categorias: "Categories",

  // CLIENTES
  ventasPorClientes: "Sales by customer",
  companya: "Company",
  consumiciones: "Consumptions",
  media: "Average",
  valorMedioDelTicket: "Average ticket value",
  todosLosClientes: "All customers",
  todosLosOperarios: "All operators",
  operariosAplicar: "Operators to apply to",
  rentabilidadInfo: "Average price minus the cost of its raw materials (product cost price)",
  sinPrecioDeCoste: "No cost price: calculate it from Tools or in the product form",
  buscarCliente: "Search customer by name, code or tax ID…",
  clientesConVentasEnElPeriodo: "with sales in the period",
  noHayClientesConVentas: "No customers with sales in the period",
  ningunClienteCoincide: "No customer matches the search",
  seleccionados: "selected",
  clientesSeleccionados: "customers selected",
  quitarFiltro: "Clear filter",
  deLosClientes: "of {total} customers",
  buscarOperario: "Search employee...",
  ninguno: "None",
  mas: "more",
  ningunOperarioCoincide: "No matching employees",
  ningunOperario: "No employees",
  deOperarios: "of {total} employees",
  eligeAlMenosUnOperario: "Choose at least one employee to apply the restrictions",
  mediaSesion: "Average session",

  // AGENCIAS
  noHayAgenciasEnEsteMomento: "No agencies at this time",
  agencias: "Agencies",
  nombreAgencia: "Agency Name",
  comision: "Commission",
  replicarAgencias: "Replicate agency",
  agregarAgencias: "Add agency",

  // MODIFICADORES
  nombreModificador: "Modifier Name",
  grupos: "Groups",
  variacion: "Variation",
  resta: "Subtract",
  suma: "Add",
  modificador: "Modifier",
  modificadores: "Modifiers",
  agregarModificador: "Add modifier",
  grupo: "Group",
  noHayModificadoresEnEsteNegocio: "No modifiers in this business",
  almacen: "Warehouse",
  todos: "All",
  precioCompraConIva: "Purchase Price WITH VAT",
  precioCompraSinIva: "Purchase Price WITHOUT VAT",
  precioDescuentoSinIva: "Discounted Price WITHOUT VAT",
  codigoIdentificacion: "Identification Code",
  replicarModificador: "Replicate modifier",

  // SOPORTE ONLINE
  soporteOnline: "Online Support",
  soporteOnlineDetails: "Online Support - Details",
  abierto: "Open",
  esperandoRespuesta: "Waiting for Response",
  respondido: "Replied",
  cerrado: "Closed",
  tecnico: "Technician",
  comercial: "Sales",
  facturacion: "Billing",
  noTicketsEnNegocio: "No tickets in this business",
  responderTicket: "Reply to ticket",
  mensaje: "Message",
  cerrar: "Close",
  enviarTicket: "Send Ticket",
  nuevoTicket: "New ticket",
  asunto: "Subject",
  estado: "Status",
  departamento: "Department",
  visitas: "Visits",
  verTicket: "View ticket",
  tarjeta: "Card",

  // FORMAS DE PAGO
  nueva: "New",
  replicarFormaDePago: "Replicate Payment Method",
  nombreFormaPago: "Payment Method Name",
  formaDePago: "Payment Method",
  formasDePago: "Payment Methods",
  agregarFormaDePago: "Add Payment Method",
  noHayFormasDePagoEnEsteNegocio: "No payment methods in this business",
  nuevo: "New",
  renovado: "Revamped",

  // EDICIÓN MASIVA
  transferirProductosDeCategoria: "Transfer products by category",
  tranferir: "Transfer",
  impresionDeProductosDeCategorias: "Category Products Printing",
  impresoraComanda: "Order Printer",
  impresoraComandaTpv: "POS Order Printer",
  impresoraComandaPda: "PDA Order Printer",
  copiaImpresionDeComanda: "Order Print Copy",
  copiaImpresoraComandasTpv: "POS Order Printer Copy",
  copiaImpresoraComandasPda: "PDA Order Printer Copy",
  impresionPorPlano: "Plan Printing",
  enviarComandaDesdeTpv: "Send order from POS",
  enviarComandaDesdePda: "Send order from PDA",
  respetarOtrasImpresiones: "Respect other prints?",
  cambioDePrecioProductos: "Product Price Change",
  opcion: "Option",
  tipoDeTarifa: "Rate Type",
  cambiarPrecio: "Change Price",
  ajustes: "Settings",
  cambiarImpresionDeGrupo: "Change group printing",
  tranferirProductosDeUnaCategoriaAOtra:
    "Transfer products from one category to another",
  cambiarPreciosAProductos: "Change product prices",

  // WIDGETS
  consumoPorHoras: "Sales by hours",
  productosMasVendidos: "Best-selling products",
  ultimosTickets: "Latest tickets",
  verTodos: "View All",
  arqueoDeCaja: "Cash Count",
  cobrado: "Collected",

  cajaCerrada: "Closed Cash",
  licenciaCaducada: "Expired License",
  cajonInteligente: "Smart Cash Drawer",
  moneda: "Currency",
  nivelReciclador: "Recycler Level",
  totalReciclador: "Total Recycler",
  nivelCasete: "Cassette Level",
  totalCasete: "Total Cassette",
  totalMonedas: "Total Coins",
  totalBilletes: "Total Bills",
  totalEnDirectoPorNegocio: "Live Sales per Business/es",
  enCuenta: "On Account",
  cajaOnline: "Online Cash Registers",
  planoDeMesas: "Table Layout",
  planoDeTaquillas: "Locker Layout",
  nombrePlano: "Layout Name",
  mesas: "Tables",
  taquillas: "Lockers",
  ocupacion: "Occupancy",
  enPlano: "In Layout",
  desgloseTicket: "Ticket Breakdown",
  precioMedio: "Average Price",
  apuntado: "Noted",
  anulado: "Cancelled",
  aparcado: "On Credit",
  indicencias: "Incidents",
  filtrarOperario: "Filter Operator",
  situacionActualDeLosNivelesDelCajonInteligente:
    "Current Status of Smart Drawer Levels",
  verDetallesDeNiveles: "View Level Details",
  noHayCajonInteligenteParaMostrar: "No Smart Drawer to Display",
  consulteConSuDistribuidor: "Consult Your Distributor",
  comparativaVentasAnteriores: "Previous Sales Comparison",
  graficaDeConsumoRespectoAHistoricoDeSesiones:
    "Consumption Graph vs. Historical Sessions",
  graficaDeConsumoAgrupadaPorTramosHorarios: "Consumption Graph by Time Slots",
  situacionActualDeOcupacionDeMesas: "Current Table Occupancy Status",
  situacionActualDeOcupacionDeTaquillas: "Current Locker Occupancy Status",
  verPlanoCompleto: "View Full Layout",
  rankingDeLaSesionActual: "Current Session Ranking",
  ultimosMovimientosDeLaCajaPorOperario: "Latest Cash Movements by Operator",
  estadoActualDeLaCaja: "Current Cash Status",
  turnosDeOperarios: "Operator Shifts",
  relacionDeHorasTrabajadasYVentasRealizadasPorOperario:
    "Hours Worked and Sales per Operator",
  horarioInicio: "Start Time",
  horaFin: "End Time",
  horasTrabajadas: "Hours Worked",
  noHayTurnosDeOperarioParaMostrar: "No Operator Shifts to Display",
  propuestaDePedido: "Order Proposal",
  pedidoAProveedor: "Supplier Order",
  atencionHayMovimientosDeAlmacenQueNoSeHanDescargadoEnElNegocio:
    "Attention: There are warehouse movements not downloaded into thebusiness",
  seleccionarNegocio: "Select Business",
  seleccionarProveedor: "Select Supplier",
  generarPedidoEnBlanco: "Generate Blank Order",
  generarPedido: "Generate Order",
  propuestaDePedidoA: "Order Proposal to ",
  buscarMateriaPrimaEnElMismoProveedor:
    "Search Raw Material from Same Supplier",
  precioIVAIncluido: "Prices VAT Included",
  ref: "Ref",
  nombre: "Name",
  existencias: "Stock",
  pedido: "Order",
  precioArticuloUnidad: "Item Price / Unit",
  precioPedido: "Order Price",
  sinIVA: "Without VAT",
  porcentajeIVA: "% VAT",
  precioIVA: "Price VAT",
  porcentajeDto: "% Discount",
  totalIVA: "Total VAT",
  observaciones: "Remarks",
  noHaySubproductosEnEsteNegocioParaRealizarElPedido:
    "No Subproducts in this Business to Order",
  recuerdeQueParaQueAparezcanLosSubproductosDebenDeEstarAsociadosAUnProveedorYConfiguradosElStockMinimoYStockOptimo:
    "Remember:Subproductsmust be linked to a supplier and have minimum and optimal stock configured to appear",
  guardarPedido: "Save Order",
  totalIVAInc: "Total VAT Inc.",
  pedidosAProveedor: "Supplier Orders",
  fechaInicio: "Start Date",
  fechaFin: "End Date",
  pedidosConvertidos: "Converted Orders",
  nuevoPedido: "New Order",
  enviarPedidos: "Send Orders",
  convertido: "Converted",
  convertirEnGasto: "Convert to Expense",
  modificar: "Modify",
  eliminar: "Delete",
  descargarComoPDF: "Download as PDF",
  descargarComoPDFSinPrecios: "Download as PDF without Prices",
  descargarComoExcel: "Download as Excel",
  descargarComoExcelSinPrecios: "Download as Excel without Prices",
  enviarPorCorreo: "Send by Email",
  eliminarListaCorreo: "Remove Mailing List",
  anyadirListaCorreo: "Add Mailing List",
  noHayPedidosAEsteProveedorEnEsteRangoDeFecha:
    "No Orders to this Supplier in this Date Range",
  enviarPedido: "Send Order",
  enviarPedidoA: "Send Order to",
  formato: "Format",
  PDF: "PDF",
  excel: "Excel",
  conPrecios: "With Prices",
  sinPrecios: "Without Prices",
  convertirPedido: "Convert Order",
  tipoDeDocumento: "Document Type",
  albaran: "Delivery Note",
  generarEntradaEnAlmacenAlVerificar: "Generate Warehouse Entry when Verifying",
  gastosDeCasas: "House Expenses",
  gastosPorCasa: "Expenses per House",
  noHayGastosPorCasasEnEsteRangoDeFechas:
    "No House Expenses in this Date Range",
  ventasDeCategorias: "Category Sales",
  ventasCategoriaDe: "Category Sales of ",
  volverAGeneral: "Back to General",
  ventasDeProductos: "Product Sales",
  filtrarPorTPV: "Filter by POS",
  filtrarTPV: "Filter POS",
  turnosDe: "Shifts of ",
  enActivo: "Active",
  ventasDeProductosDe: "Collected Accounts Products of ",
  ignorarRecuentosNegativos: "Ignore negative counts",
  ventasOperarios: "Collected Accounts",
  costesDeProductos: "Product Costs",
  totalImportesVentas: "Total Sales Amount",
  totalCoste: "Total Cost",
  costes: "Costs",
  costeUd: "Unit Cost",
  coste: "Cost",
  porcentajeCosto: "% Cost",
  varCostoMed: "Var. Avg. Cost",
  listaDeInvitaciones: "Invitation List",
  valor: "Value",
  volverALaLista: "Back to List",
  ventasDeProductosGlobal: "Global Product Sales",
  porUnidades: "By Units",
  gastosPorEtiquetas: "Expenses by Tags",
  desgloseDeGastos: "Expense Breakdown",
  referencias: "References",
  concepto: "Concept",
  gastosDeProveedores: "Supplier Expenses",
  sinProveedor: "Without Supplier",
  sinCasas: "Without Houses",
  cierreDeCaja: "Cash Closing",
  primerTicket: "First Ticket",
  ultimoTicket: "Last Ticket",
  cheques: "Checks",
  cambioSigDia: "Next Day Change",
  ventasPorAgencias: "Sales by Agencies",
  ventasPorFormasDePago: "Sales by Payment Methods",
  exportarComoHTML: "Export as HTML",
  pendiente: "Pending",
  gasto: "Expense",
  desgloseDeImpuestos: "Tax Breakdown",
  desgloseDelTicket: "Ticket Breakdown",
  cuentasAnuladas: "Cancelled Accounts",
  buscarPorHoras: "Search by Hours",
  buscarBaja: "Show Deactivated Products",
  buscarSubProductoBaja: "Show Deactivated Raw Materials",
  buscarCategoriasBaja: "Show Deactivated Categories",
  buscarEtiquetasBaja: "Show Deactivated Tags",
  mostrarClientesBaja: "Show Inactive Clients",
  deBaja: "inactive",
  mostrarVentasAcumuladasPorDia: "Show Daily Accumulated Sales",
  seleccionaUnTpv: "You must select a POS to view details",
  deshabilitarCheckboxVentasAcumuladasPorDia:
    "Disable 'Show Daily Accumulated Sales' checkbox to view details",
  graficas: "Charts",
  dias: "Days",
  semanas: "Weeks",
  meses: "Months",
  ventasPorComensales: "Sales per Diners",
  numeroDeComensales: "Number of Diners",
  precioMedioPorComensal: "Average Price per Diner",
  ventasPorRangosHorarios: "Sales by Time Ranges",
  ops: "Ops",
  comensales: "Diners",
  detalleDeOperaciones: "Operations Detail",
  operaciones: "Operations",
  operacionMedia: "Average Operation",
  detalleDeComensales: "Diners Detail",
  comensalMedio: "Average Diner",
  noHayVentasEnLosRangosDeFechasDefinidos:
    "No Sales in the Defined Date Ranges",
  transferencia: "Transfer",
  domiciliacion: "Direct Debit",
  fechaGasto: "Expense Date",
  generarEntradaDeAlmacenAlVerificar: "Generate Warehouse Entry when Verifying",
  listaDeMateriaPrima: "Raw Material List",
  preciosIVAIncluido: "Prices VAT Included",
  precioSinIVA: "Price Without VAT",
  precioIVAInc: "Price VAT Inc",
  IVA: "VAT",
  totalBase: "Base Total",
  totalDocumento: "Document Total",
  seleccioneUnaCasa: "Select a House",
  anyadirNuevoSubproducto: "Add New Subproduct",
  gestionDeGastos: "Expense Management",
  deCaja: "From Cash",
  fueraDeCaja: "Out of Cash",
  contabilizado: "Booked",
  si: "Yes",
  no: "No",
  grafica: "Chart",
  lista: "List",
  avanzado: "Advanced",
  noHayVentasDeProductosEnEsteRangoDeFechas:
    "No Product Sales in this Date Range",
  historicoDeProductos: "Product History",
  volverA: "Back to",
  general: "General",
  historialAlmacen: "Warehouse History",
  listadoDeExistencia: "Stock List",
  listadoDeAlmacen: "Warehouse List",
  listadoHastaStockOptimo: "List up to Optimal Stock",
  listadoExistenciaBajoMinimo: "List Below Minimum Stock",
  exportarValoracion: "Export Valuation",
  importeDto: "Discount Amount",
  detalleDelSubproducto: "Subproduct Detail",
  nombreNegocio: "Business Name",
  noHaySubproductosConElMismoNombreEnTusOtrosNegocios:
    "No Subproducts with Same Name in Your Other Businesses",
  detalleAlmacen: "Warehouse Detail",
  entrada: "Entry",
  inventario: "Inventory",
  salida: "Exit",
  valorDto: "Discount Value",
  noHayDatosEnEsteMovimientoDeAlmacen: "No Data in this Warehouse Movement",
  historial: "History",
  noHayMovimientoEnEstaMateriaPrima: "No Movement in this Raw Material",
  dia: "Day",
  historialDeAlmacen: "Warehouse History",
  inventarios: "Inventories",
  entradas: "Entries",
  salidas: "Exits",
  completado: "Completed",
  verificado: "Verified",
  descargado: "Downloaded",
  diaActual: "Current Day",
  movimientos: "Movements",
  enEsteRangoDeFechas: "in this Date Range",
  rangosHorarios: "Time Ranges",
  nuevoRangoHorario: "New Time Range",
  verUnInformeDeRangosHorarios: "View Time Range Report",
  noHayRangosHorariosEnEsteNegocio: "No Time Ranges in this Business",
  nombreRangosHorarios: "Time Range Name",
  vistaMosaico: "Mosaic View",
  vistaLista: "List View",
  ordenarProductos: "Sort Products",
  BAJA: "DEACTIVATED",
  frontalDeVenta: "Sales Front",
  agregarGasto: "Add Expense",
  entrAlmac: "Whse. Entry",
  contab: "Booked",
  tranferencia: "Transfer",
  verificar: "Verify",
  entradaAlmacen: "Warehouse Entry",
  preciosIVAInluido: "Prices VAT Included",
  estaEntradaNoContieneNingunSubproducto: "This Entry Contains No Subproduct",
  cajasOnline: "Online Cash Registers",
  minimo: "Minimum",
  optimo: "Optimal",
  posicionGlobal: "Global Position",
  empresa: "Company",
  todasLasEmpresas: "All Companies",
  ventasSinIVA: "Sales Without VAT",
  neto: "Net",
  fechaDeCumpleanyos: "Birthday",
  recargoEquivalencia: "Equivalence Surcharge",
  anyadirMateriaPrima: "Add Raw Material",
  partesT1: "Parts T1",
  partesT2: "Parts T2",
  partesT3: "Parts T3",
  partesT4: "Parts T4",
  costeDto: "Discounted Cost",
  agregarMateriasPrimas: "Add Raw Materials",
  frontalDeVentas: "Sales Front",
  unidadesEnOtroNegocios: "Units in Other Businesses",
  historialMateriaPrima: "Raw Material History",

  borrarRangoHorario: "Delete time range",
  detallesDeLaEntradaEnAlmacen: "Warehouse entry details",
  desgloseHorasTrabajadas: "Breakdown of hours worked",
  verProductosVendidos: "View sold products",
  verTicketsDelProducto: "View tickets for the product",
  verTicketsDeEsasInvitaciones: "View tickets for those complimentary items",
  verTicketsDeEsaAgencia: "View tickets for that agency",
  gastosPorMateriasPrimas: "Expenses by raw materials",
  alDarUnProductoDeBajaDesapareceEnElTPVParaSuVentaPeroSigueApareciendoEnLosInformesDeVenta:
    "When you deactivate a product, it disappears from the POS for sale but still appears in sales reports",
  cuandoUnProductoEsDeTipoDescuentoSuPrecioSeDescuentaDelTotalDeLaCuenta:
    "When a product is of type Discount, its price is subtracted from the bill total",
  alActivarEstaOpcionApareceLosIngredientesDelProductoParaSeleccionarlo:
    "When enabled, the product's ingredients appear so you can select them",
  alActivarEstaOpcionPuedeSeleccionarElPrecioDelProductoAlMarcarlo:
    "When enabled, you can choose the product price when selecting it",
  alActivarEstaOpcionPuedeSeleccionarElPesoDelProductoAlMarcarlo:
    "When enabled, you can choose the product weight when selecting it",
  alActivarEstaOpcionPuedeSeleccionarElImporteDelProductoAlMarcarlo:
    "When enabled, you can choose the product amount when selecting it",
  alActivarEstaOpcionElProductoNoApareceraEnNumierTPV:
    "When enabled, the product will not appear in Numier TPV",
  alActivarEstaOpcionElProductoNoApareceraEnLaPda:
    "When enabled, the product will not appear in Numier PDA",
  alActivarEstaOpcionElProductoNoSeImprimiraEnElPendienteDeCobroNiEnLaFacturaSimplificada:
    "When enabled, the product will not be printed on the pending payment or the simplified invoice",
  guardarMateriaPrima: "Save raw material",
  copiarMateriaPrima: "Copy raw material",
  seleccioneQueTipoDeMateriasPrimasQuiereCopiar:
    "Select which type of raw materials you want to copy",
  seleccioneAQueCategoriaQuiereCopiarLasMateriasPrimas:
    "Select to which categories you want to copy the raw materials",
  copiaMateriaPrima: "Raw material copy",
  notas: "Notes",
  pedidos: "Orders",
  atencionLaMediaSinContarLosDiasConVentas:
    "Attention: The average excluding days with €0 sales is:",
  verDesgloseDeImpuestos: "View tax breakdown",
  verDetallesDetTicket: "View ticket details",
  facturasNominativas: "Named invoices",
  verDetallesDeGasto: "View expense details",
  desgloseDeGastosPorEtiquetasHijas: "Expense breakdown by child tags",
  procedencia: "Origin",
  suLicenciaDeNumierOnlineEstaAPuntoDeCaducar:
    "Your Numier Online license is about to expire",
  cajasOnlineTickets: "Online Cash Registers Tickets",
  cajasOnlineDetalles: "Online Cash Registers Details",
  cajasOnlinePlano: "Online Cash Registers Layout",
  cajasOnlineProductos: "Online Cash Registers Products",
  transferir: "Transfer",
  herramientas: "Tools",
  ver: "View",
  detallesDeLaentradaEnAlmacen: "Warehouse entry details",
  ups: "Oops",
  laFechaDeInicioNoPuedeSerPosteriorALaDeFin:
    "The start date cannot be later than the end date",
  exportarContabilidad: "Export accounting",

  seleccioneUnProveedor: "Select a supplier",
  detallesDelPedido: "Order details",
  correoEnviadoCorrectamente: "Email sent successfully",
  atencion: "Attention",
  debeIntroducirUnEmailParaEnviarElPedido:
    "You must enter an email address to send the order",
  detalles: "Details",
  gastoVerificadoCorrectamente: "Expense verified successfully",
  estasSeguroDeEliminarElPedido: "Are you sure you want to delete the order?",

  // BUSINESS CENTRAL - MATERIAS PRIMAS
  noSeEncontraronMateriasPrimas: "No raw materials found",
  noSeEncontraronProductos: "No products found",
  seleccionar: "Select",
  estado: "Status",
  noDisponible: "Not available",
  downgradedProducts: "Downgraded products",
  unknownProduct: "Unknown product",
  affectedRecipes: "Affected recipes",
  noRecipesAffected: "No recipes affected",
  detalle: "Detail",
  noHayBajasQueMostrar: "No downgrades to display",
  resumenBajas: "Downgrades summary",
  eliminado: "Removed",
  consultarTodo: "View All",
  desplegar: "Display info",
  estaOperacionNoSePuedeDeshacer: "This action cannot be undone",
  siEliminarPedido: "Yes, delete order",
  pedidoEliminadoCorrectamente: "Order deleted successfully",
  laReferenciaEsObligatoria: "Reference is required",
  seleccioneLosNegociosParaHacerelPedido:
    "Select the businesses to place the order",
  noTienesNingunNegocioAsignado: "You don't have any business assigned",
  noHayProveedoresEnEsteNegocio: "There are no suppliers in this business",
  cuentasRectificadas: "Credit notes",
  noHayCuentasRectificadasEnEsteRangoDeFechas:
    "There are no credit notes in this date range",
  pedidosProveedor: "Supplier orders",
  gestionDePersonal: "Staff management",
  configuracionCarta: "Menu configuration",
  importacionExcels: "Excel import",
  carta: "Digital menu",
  camaras: "Cameras",
  perfil: "Profile",
  cerrarSesion: "Log out",
  desarrolladoPorNexodoDigitalSL: "Developed by Nexodo Digital S.L.",
  totalValores: "Total values",
  totalValoresDto: "Total values (Disc.)",
  totalValoresRecuento: "Total counted values",
  ultimoInventario: "Last inventory",
  filtrarEntreInventarios: "Filter between inventories",
  ultInventario: "Last inventory",
  primerInventario: "First inventory",
  marcaDosInventariosParaVerLosDetallesEntreEllos:
    "Select two inventories to view the details between them",
  salir: "Exit",
  anadirMovimientoAlmacen: "Add warehouse movement",
  nuevoInventario: "New inventory",
  tienesUnInventarioSinTerminarElDia: "You have an unfinished inventory today",
  pulseElBotonRealizarInventarioPara: "Click the 'Perform inventory' button to",
  volverARealizarlo: "do it again",
  siDeseas: "If you wish",
  comenzarElInventarioDeNuevo: "start the inventory over",
  comaMarqueLaCasillaEliminarDatosDeInventarioActual:
    ", check the 'Delete current inventory data' box",
  eliminarDatosDelInventarioActual: "Delete current inventory data",
  realizarInventario: "Perform inventory",
  accesoDenegado: "Access denied",
  soloPuedeComprobar2InventariosAlMismoTiempo:
    "You can only compare 2 inventories at the same time",
  cargando: "Loading...",
  configuracionAlmacen: "Warehouse configuration",
  actualizada: "updated",
  correctamente: "successfully",
  noSeAdmitenCamposEnBlanco: "Blank fields are not allowed",
  todas: "All",
  categoriaClientes: "Customer category",
  seleccionaCompania: "Select company",
  agregarCategoriaDeClientes: "Add customer category",
  categoriaPadre: "Parent category",
  elCampoNombreFiscalEsObligatorio: "Fiscal name is required",
  elCampoCifNifEsObligatorio: "CIF/NIF is required",
  datosActualizados: "Data updated successfully",
  elCampoNombreEsRequerido: "Name is required",
  creada: "created",
  rangoHorario: "Time range",
  soloPuedeCrearUnMaximoDeXRangosHorarios:
    "You can only create up to 12 time ranges",
  deAcuerdo: "OK",
  eliminado: "deleted",
  deseaEliminarEsteRangoHorario: "Do you want to delete this time range?",
  siBorrarRangoHorario: "Yes, delete time range",
  ordenarProductosAlfabeticamente: "Sort products alphabetically",
  ordenarMateriasPrimasAlfabeticamente: "Sort raw materials alphabetically",
  asignarImpresorasSeleccionadasEnBlanco: "Assign selected printers to none",
  aplicarCambios: "Apply changes",
  ordenarAlfabeticamenteProductos: "Sort products alphabetically",
  ordenar: "Sort",
  ordenarAlfabeticamenteSubproductos: "Sort raw materials alphabetically",
  seleccioneElTipo: "Select the type",
  impresionDeProductosEfectuadaCorrectamente:
    "Product printing completed successfully",
  tienesQueSeleccionarUnaCategoria: "You must select a category",
  ningunaSeleccionada: "None selected",
  transferenciaDeProductosEfectuadaCorrectamente:
    "Product transfer completed successfully",
  relleneLosCamposObligatorios: "Fill in the required fields",
  vistaFrontalTpv: "POS front view",
  editarPrecios: "Edit prices",
  cancelarEdicion: "Cancel editing",
  guardarOrden: "Save order",
  bajaConBrackets: "[INACTIVE]",
  seleccionaUnaCategoria: "Select a category...",
  cambiarImpresorasAProductos: "Change printers for products",
  igualar: "Match",
  sumar: "Add",
  restar: "Subtract",
  multiplicar: "Multiply",
  todasLasTarifas: "All price lists",
  productosEditadosCorrectamente: "Products edited successfully",
  ordenActualizadoCorrectamente: "Order updated successfully",
  componentesDeVenta: "Sales components",
  delNegocioAClientes: "from the business to customers",
  clasificacionDe: "Classification of",
  productosPorFamilia: "products by family",
  elementosQue: "Elements that",
  varianALosProductos: "modify products",
  paraLaComanda: "for the order",
  componentesComprados: "Purchased components",
  aProveedoresQueComponenProductos: "from suppliers that make up products",
  empresas: "Companies",
  proveedorasDeMateriasPrimasYServicios:
    "suppliers of raw materials and/or services",
  alNegocio: "to the business",
  fabricantesDeMateriasPrimas: "raw material manufacturers",
  aProveedores: "to suppliers",
  categoriasQueClasifican: "Categories that classify",
  materiasPrimasYProveedores: "raw materials and suppliers",
  personalCon: "Staff with",
  acceso: "access",
  alSistema: "to the system",
  baseDeDatosDe: "Database of",
  consumidores: "consumers",
  enElNegocio: "in the business",
  clasificacionDeLa: "Classification of",
  deLasVentas: "sales",
  metodosDeCobro: "Payment methods",
  enElFrontalDeVenta: "on the sales front",
  intervaloDeHorasParaConsultarVentas: "Hour range to query sales",
  configurarAlmacén: "Configure warehouse",
  relacionDeMateriasPrimasParaLaConfiguracionDelAlmacen:
    "List of raw materials for warehouse configuration",
  herramientasGenerales: "General tools",
  edicionMasiva: "Bulk editing",
  categoriasCarta: "Menu categories",
  categoriaCarta: "menu category",
  orden: "Order",
  editada: "edited",
  anadirCategoria: "Add category",
  esteNegocioNoTieneAccesoAEsteModulo:
    "This business does not have access to this module",
  paraMasInformacionContacteConSu: "For more information contact your",
  distribuidor: "distributor",
  formasDePagoCarta: "Menu payment methods",
  formaDePagoCarta: "menu payment method",
  informacionCarta: "Menu information",
  datosDelNegocio: "Business information",
  nombreMostrado: "Displayed name",
  telefonoWhatsapp: "WhatsApp phone",
  datosPedidos: "Order information",
  tiempoMedioDePreparacionRecogidaMin: "Average prep time for pickup (min)",
  tiempoMedioDePreparacionDomicilioMin: "Average prep time for delivery (min)",
  gastosDeEnvio: "Delivery fee",
  pedidoMinimo: "Minimum order",
  interfaz: "Interface",
  textoEntrega: "Delivery text",
  textoPresentacion: "Intro text",
  textoFormasDePago: "Payment methods text",
  textoHorarios: "Hours text",
  datosGuardadosCorrectamente: "Data saved successfully",
  materiasPrimasCarta: "Menu raw materials",
  materiaPrimaCarta: "menu raw material",
  referenciaMateriasPrimasTpv: "POS raw material reference",
  nombreDeLaMateriaPrimaEnElTpv: "Raw material name on POS",
  disponible: "Available",
  replicarMateriaPrima: "Replicate raw material",
  replicarMateriasPrimas: "Replicate raw materials",
  nombreTpv: "POS name",
  noDisponible: "Not available",
  replicarTodasLasMateriasPrimas: "Replicate all raw materials",
  estasSeguroDeReplicarTodasLasMateriasPrimasALosNegociosSeleccionados:
    "Are you sure you want to replicate all raw materials to theselectedbusinesses?",
  estaAccionNoSePuedeDeshacer: "This action cannot be undone!",
  siReplicar: "Yes, replicate",
  productosCarta: "Menu products",
  productoCarta: "Menu product",
  referenciaProductoTpv: "POS product reference",
  nombreDelProductoEnElTpv: "Product name in POS",
  seleccionaCategoria: "Select category",
  edicionRapida: "Quick edit",
  supraCategoria: "SupraCategory",
  supraCategoriaObligatoria: "You must select a SupraCategory to save this product.",
  seleccionaTipo: "Select type",
  nIngredientesSinCosto: "No. of ingredients without cost",
  maximoExtras: "Maximum extras",
  alergenos: "Allergens",
  nombreTarifa1: "Rate name 1",
  precioTarifa1: "Rate price 1",
  nombreTarifa2: "Rate name 2",
  precioTarifa2: "Rate price 2",
  nombreTarifa3: "Rate name 3",
  precioTarifa3: "Rate price 3",
  nombreTarifa4: "Rate name 4",
  precioTarifa4: "Rate price 4",
  imagen: "Image",
  copiarMateriasPrimas: "Copy raw materials",
  basico: "Basic",
  buscarNombreDeLaMateriaPrima: "Search raw material name",
  seleccionaTipoPunto: "Select type...",
  bases: "Bases",
  opcionales: "Optionals",
  extras: "Extras",
  cereales: "Cereals",
  crustaceos: "Crustaceans",
  huevos: "Eggs",
  pescado: "Fish",
  cacahuetes: "Peanuts",
  soja: "Soy",
  leche: "Milk",
  frutosDeCascara: "Nuts",
  apio: "Celery",
  mostaza: "Mustard",
  granosDeSesamo: "Sesame seeds",
  dioxidoDeAzufre: "Sulfur dioxide",
  altramuces: "Lupins",
  moluscos: "Mollusks",
  cartaASecas: "Menu",
  extra: "Extra",
  opcional: "Optional",

  estreProcesoBorraraLasMateriasPrimasActualesEnLasCategoriasSeleeccionadasDeLosTiposElegidos:
    "This process will delete the current raw materials in the selected categories of the chosen types",
  aceptarProceso: "Accept process",
  necesitasMarcarAlMenosUnTipoYUnaCategoria:
    "You need to select at least one type and one category",
  materiaPrimaCopiadaCorrectamente: "Raw material copied successfully",
  editado: "edited",
  agregada: "added",
  relacion: "Relation",
  noPuedeHaberDosMateriasPrimasConElMismoTipo:
    "There cannot be two raw materials with the same type",
  estasSeguroDeBorrarLaMateriaPrima:
    "Are you sure you want to delete the raw material?",
  siDeseoBorrarlo: "Yes, I want to delete it",
  seleccionaUnaCarta: "Select a menu",
  replicarProductos: "Replicate products",
  verCarta: "View menu",
  verPedido: "View order",
  verQR: "View QR",
  nombreEnTpv: "Name in POS",
  cartaYPedido: "Menu and Order",
  replicarTodosLosProductos: "Replicate all products",
  editarImagen: "Edit image",
  esteNegocioNoContieneNingunaCarta: "This business does not contain any menu",
  estasSeguroDeReplicarTodosLosProductosALosNegociosSeleccionados:
    "Are you sure you want to replicate all products to the selected businesses?",
  sustanciasQue: "Substances that",
  componenALosProductos: "compose the products",
  informacionAcercaDel: "Information about",
  negocioMinuscula: "business",
  actualizarPedidos: "Update orders",
  pendienteDeConfirmacion: "Pending confirmation",
  confirmados: "Confirmed",
  enPreparacion: "In preparation",
  finalizados: "Completed",
  recogida: "Pickup",
  domicilio: "Delivery",
  noHayPedidosPendientesDeConfirmacion:
    "There are no orders pending confirmation",
  noHayPedidosConfirmados: "There are no confirmed orders",
  noHayPedidosEnPreparacion: "There are no orders in preparation",
  noHayPedidosTerminados: "There are no completed orders",
  siBorrarPedido: "Yes, delete order",
  estasSeguroDeSuspenderElServicioEnMesas:
    "Are you sure you want to suspend table service?",
  siSuspendeElServicioEnMesasNoEntraranMasPedidosEnMesaHastaActivarloDeNuevo:
    "If you suspend table service, no more table orders will be accepted until reactivated",
  siSuspenderElServicioEnMesa: "Yes, suspend table service",
  estasSeguroDeActivarElServicioEnMesas:
    "Are you sure you want to activate table service?",
  siActivaElServicioDeMesasVolveranAEntrarPedidosDeMesa:
    "If you activate table service, table orders will be accepted again",
  siActivarElServicioEnMesa: "Yes, activate table service",
  estasSeguroDeSuspenderElServicio:
    "Are you sure you want to suspend the service?",
  siSuspendeElServicioNoEntraranMasPedidosHastaActivarloDeNuevo:
    "If you suspend the service, no more orders will be accepted until reactivated",
  siSuspenderElServicio: "Yes, suspend the service",
  estasSeguroDeActivarElServicio:
    "Are you sure you want to activate the service?",
  siActivaElServicioVolveranAEntrarPedidos:
    "If you activate the service, orders will be accepted again",
  siActivarElServicio: "Yes, activate the service",
  pedidoAceptadoCorrectamente: "Order accepted successfully",
  pedidoEnPreparacion: "Order in preparation",
  pedidoFinalizado: "Order completed",
  pedidoArchivado: "Order archived",
  servicioActualizadoCorrectamente: "Service updated successfully",
  estasSeguroDeEditarLaObservacion: "Are you sure you want to edit the note?",
  siEditarObservacion: "Yes, edit note",
  mesasActivadas: "TABLES ACTIVATED",
  mesasDesactivadas: "TABLES DEACTIVATED",
  crearNuevoProveedor: "Create new supplier",
  crearMateriaPrima: "Create Raw Material",
  eliminarMateriaPrima: "Delete Raw Material",
  sinCasaAsignada: "No assigned location",
  buscarPorRefONombreDeLaMateriaPrima: "Search by Ref. or Raw Material Name",
  mensajePorcentajeCompraDisminuido:
    "Price has decreased below the established purchase percentage",

  seleccioneEtiqueta: "Select tag...",
  unidadesStockMinimo: "Minimum stock units",
  partesStockMinimo: "Minimum stock parts",
  anadirProveedor: "Add supplier",
  amarillo: "yellow",
  cajas: "Boxes",
  botellas: "Bottles",
  barriles: "Barrels",
  palets: "Pallets",
  bolsas: "Bags",
  litros: "Liters",
  rollos: "Rolls",
  visualizar: "View",
  sinCasa: "No location",
  elProveedorEsObligatorio: "Supplier is required",
  laFechaEsObligatoria: "Date is required",
  hayUnaMateriaPrimaSinUnidades: "There is a raw material without units",
  hayUnaMateriaPrimaSinPrecio: "There is a raw material without price",
  guardandoGasto: "Saving expense...",
  actualizado: "updated",
  creado: "created",
  laLongitudDelNombreNoPuedeSerMayorDe:
    "The name length cannot be greater than ",
  relleneTodosLosDatosMarcadosConAsteriscoAntesDeEnviar:
    "Fill in all fields marked with * before submitting",
  seleccionaProveedor: "Select supplier...",
  filtrarPorFecha: "Filter by date",
  convertirAlbaranes: "Convert delivery notes",
  cancelarConversion: "Cancel conversion",
  convertir: "Convert",
  convertirAlbaranEnFactura: "Convert delivery note to invoice",
  refFactura: "Invoice ref",
  albaranesDeLaFactura: "Delivery notes of the invoice",
  finalizada: "completed",
  conversion: "Conversion",
  error: "Error",
  estaSeguroDeVerificarEsteGasto:
    "Are you sure you want to verify this expense?",
  siVerficarGasto: "Yes, verify expense",
  estasSeguroDeEliminarElGasto: "Are you sure you want to delete the expense?",
  siEliminarGasto: "Yes, delete expense",
  contabilizadoCambiadoCorrectamente: "Accounting status changed successfully",
  gastoEliminadoCorrectamente: "Expense deleted successfully",
  hacerInventario: "Perform inventory",
  seleccionarTodas: "Select All",
  inventarioRealizadoCorrectamente: "Inventory performed successfully",
  traspaso: "Transfer",
  negocioDeDestino: "Destination business",
  referenciaNecesaria: "Reference required",
  elMovimientoDeAlmacenTieneQueTenerAsignadoUnProductoOProductos:
    "The warehouse movement must have one or more assigned products",
  realizado: "completed",
  enviarInventario: "Send inventory",
  volverAlAlmacen: "Return to warehouse",
  inventarioCompletado: "Inventory completed",
  inventarioNoEncontrado: "Inventory not found",
  cargandoInventario: "Loading inventory",
  inventarioExcluidosTitulo: "Some raw materials are not counted in this inventory",
  inventarioExcluidosTexto: "Their code is duplicated, so it is not possible to know which raw material the quantity belongs to. They will not be available to count until the code is fixed.",
  inventarioExcluidoCodigoCompartido: "Code {codigo} is shared by {total} active raw materials.",
  inventarioExcluidoLineaDuplicada: "Code {codigo} appears {total} times in this inventory.",
  importacion: "Import",
  importar: "Import",
  tienesQueSeleccionarUnArchivoDeImportacion: "You must select an import file",
  importandoVentasDelNegocio: "Importing business sales...",
  nuevosProductos: "New Products",
  seHanCreadoLosSiguientesProductos: "The following products have been created",
  importandoMovimientosDeAlmacen: "Importing warehouse movements...",

  seleccionaCasa: "Select location...",
  desgloseDeVentasPorProductos: "Sales breakdown by products",
  noTienesPermisoParaVisualizarEsteInforme:
    "You do not have permission to view this report",
  historicoVentasPorCliente: "Sales history by client",
  buscarPorNombreDelCliente: "Search by client name",
  importeSinDto: "Amount without discount",
  seleccioneUnClienteValido: "Select a valid client",
  seleccioneUnNegocioParaVerLosTickets: "Select a business to view tickets",
  ventasDeCategoriasPorClientes: "Category sales by clients",
  desgloseDeVentasDeLaCategoria: "Sales breakdown of the category",
  verImporteEnCategoriasHijas: "View amount in subcategories",
  gestionDePedidos: "Order management",
  cargandoGastos: "Loading expenses...",
  cargandoDatos: "Loading Data",
  tiempoMedioCocina: "Average kitchen time",
  nComandas: "No. Orders",
  eliminada: "deleted",
  tiempoMedio: "Average time",
  noHayComandasEnviadasAlKdsEnEsteRangoDeFechas:
    "No orders sent to KDS in this date range",
  tiempoMedioProducto: "Average product time",
  nProductos: "No. Products",
  informePersonalizado: "Custom report",
  nombreDelDispositivo: "Device name",
  dispositivo: "Device",
  registrosHorarios: "Time logs",
  marshallEjecutadoCorrectamente: "Marshall executed successfully",
  mes: "Month",
  seleccionaUnaSemana: "Select a week",
  seleccioneUnaFechaValida: "Select a valid date",
  noMayuscula: "NO",
  siMayuscula: "YES",
  editarObservacion: "Edit note",
  anadirObservacion: "Add note",
  editarHoraInicioYHoraFin: "Edit start and end time",
  verLocalizacionEnMapa: "View location on map",
  noSeHaEncontradoLocalizacion: "Location not found",
  inicioJornada: "Shift started",
  finJornada: "Shift ended",
  geolocalizacionJornada: "Shift geolocation",
  editarHorario: "Edit schedule",
  editarHorarioDeTurno: "Edit shift schedule",
  observacion: "Note",
  turnosOperarios: "Operators shifts",
  compartirEnlaceTurnos: "Share shifts link",
  hazClicConsultar: "Click the Consult button to search.",
  calculo: "Calculation",
  alMinuto: "Per minute",
  redondear: "Round",
  alSegundo: "Per second",
  horaCompleta: "Full hour",
  haciaArriba30m: "Round up (30m)",
  haciaArriba45m: "Round up (45m)",
  verInfoCalculos: "View calculation info",
  infoCalculoTurnosTitulo: "Shift Calculation Information",
  infoCalculoIntroP1: "The system allows calculating time and salary in three ways. When rounding is applied,",
  infoCalculoIntroDestacado: "the actual time worked will always appear in parentheses and in grey",
  infoCalculoAlMinutoTitulo: "1. Per minute",
  infoCalculoAlMinutoDesc: "Discards seconds. If an operator works 1h 30m 45s, it counts as",
  infoCalculoAlMinutoSueldo: "Salary is calculated exactly on those minutes.",
  infoCalculoRedondearTitulo: "2. Round",
  infoCalculoRedondearDesc: "Adjusts time according to the selected rule:",
  infoCalculoHoraCompletaDesc: "Does not count minutes. If working 1h 55m, pays",
  infoCalculoHaciaArribaDesc: "If minutes exceed the threshold, rounds up to the next hour.",
  infoCalculoRedondearNota: "* Salary will be calculated on this already rounded time.",
  infoCalculoAlSegundoTitulo: "3. Per second",
  infoCalculoAlSegundoDesc1: "Maximum precision. Counts the exact time (e.g.",
  infoCalculoAlSegundoDesc2: ") and salary includes the last cent generated by those seconds.",
  enlaceGeneradoExito: "Link generated successfully",
  enlaceCopiadoAlPortapapeles: "Link copied to clipboard",
  enlaceExternoTurnosTitle: "External link for shift consultation",
  enlaceExternoTurnosLabel:
    "Through this link you can check operators' shifts. It will expire in 24 hours.",
  errorComunicacionBackend: "Communication error with the server.",
  errorNoSeHaPodidoGenerarElEnlace:
    "Sorry, the link could not be generated, please try again",
  enlaceExternoTurnosOperariosTitle: "Operators' shifts of ",
  enlaceExternoTurnosCaducadoTitle: "The link has expired",
  enlaceExternoTurnosCaducadoLabel:
    "To check the operators' shifts, contact the business administrator to generate a new link.",
  ventasDeProductosMinusculas: "product sales",
  pedidosGuionPasarelaDePago: "Orders - Payment Gateway",
  numPedidos: "No. Orders",
  costoPorPedido: "Cost per order",
  totalComisiones: "Total commissions",
  totalSinComisiones: "Total without commissions",
  errorEnLaPeticion: "Request error",
  rentabilidad: "Profitability",
  buscarPorNombreDelRepartidor: "Search by delivery person name",
  verDesgloseDeTarifas: "View rate breakdown",
  ventasPorMeses: "Sales by months",
  ventasHoras: "Sales by hours",
  ventasPorHorasYMesas: "Sales by hours and tables",
  tarifasDelProducto: "Product rates",
  cantidad: "Quantity",
  fechaDesde: "Date from",
  fechaHasta: "Date to",
  seleccionaProcedencia: "Select origin...",
  verDesgloseFacturas: "View invoices breakdown",
  verDesgloseMateriasPrimas: "View raw materials breakdown",
  seleccionaUnaEtiqueta: "Select a tag",
  buscarPorNombreDeLaMateriaPrima: "Search by raw material name",
  ventasDeMateriasPrimas: "Raw materials sales",
  seleccionaTpv: "Select POS...",
  deVentas: "of sales",
  totalComision: "Total commission",
  totalSinComision: "Total without commission",
  desgloseFacturas: "Invoices breakdown",
  facturasDelProveedor: "Supplier invoices",
  retiradas: "Withdrawn",
  buscarTicket: "Search ticket...",
  baseMayusculas: "BASE",
  numServ: "No. Serv.",
  ticketMed: "Ticket Med.",
  necesitasElegirUnTpvParaPoderVerLosDetallesDeEste:
    "You need to choose a POS to view its details",
  ventasMinusculas: "sales",
  totales: "Totals",
  noTienesNingunRangoDeFechaCreadoDeseasCrearUnRangoDeFecha:
    "You don't have any date range created. Do you want to create one?",
  siCrearUnRangoHorario: "Yes, create a time range",
  detalleDe: "Detail of ",
  cierresDeCaja: "cash closings",
  ventasNegocioPorZonaHoraria: "Business sales by time zone",
  porZonaHoraria: " by time zone",
  detalleDeVentasSegun: "Sales details by",
  comensalesMinuscula: " diners",
  desgloseDe: "Breakdown of ",
  ticketsCobrados: "paid tickets",
  segunTipoDeIVA: "by VAT type",
  facturasEmitidas: "Invoices issued",
  aClientes: " to clients",
  desgloseDeVentasSegun: "Sales breakdown by ",
  formasDePagoMinusculas: "payment methods",
  agenciasMinusculas: "agencies",
  cuentasACredito: "credit accounts",
  sumatorioDe: "Total of ",
  impuestos: "taxes",
  porFechas: " by dates",
  cuentasAnuladasMinusculas: "voided accounts",
  delNegocio: " of the business",
  cuentasRectificadas: "Corrective invoices",
  cuentasRectificadasMinusculas: "corrective invoices",
  retiradasMinusculas: "withdrawn",
  ventaDeProductosPorNegocio: "Product sales by business",
  rankingDe: "Ranking of",
  costeDeProductos: "Cost of products",
  margenDeCostes: "Cost margin",
  segunVentasPorRangoDeFecha: "by sales over date range",
  historicoDeProducto: "Product history",
  rankingAgrupadoDe: "Grouped ranking of",
  enTodosLosNegocios: "in all businesses",
  ventasDeCategoriasPorNegocio: "Category sales by business",
  agrupacionDe: "Grouping of",
  ventasDeCategoriasMinusculas: "category sales",
  deProductos: "of products",
  invitacionesMinusculas: "invitations",
  ventasPorMateriasPrimas: "Sales by raw materials",
  ventasDeMateriasPrimasMinusculas: "raw materials sales",
  comprasDeMateriasPrimas: "Raw materials purchases",
  porRangoDeFecha: "by date range",
  comprasAProveedores: "Purchases from suppliers",
  comprasAUnProveedor: "Purchases from a supplier",
  porRangoDeFechaEn: "by date range in",
  todosLosNegocios: "all businesses",
  comprasAgrupadasPorEtiquetas: "Purchases grouped by tags",
  comprasAFabricantes: "Purchases from manufacturers",
  comprasAUnFabricante: "Purchases from a manufacturer",
  ranking: "Ranking",
  detallesDe: "Details of",
  turnos: "shifts",
  ventasPorClientesPlural: "Sales by clients",
  deVentasPorClientes: "of sales by clients",
  consultaDeVentasPorCliente: "Sales query by client",
  historico: "History",
  deVentasPorCliente: "of sales by client",
  numierPedidos: "Numier Orders",
  informeDePasarelaDePago: "Payment Gateway Report",
  desgloseDiarioDeLosPagosATraves: "Daily breakdown of payments through",
  pasarelaDePagoStripe: "Stripe payment gateway",
  clicParaMasInformacion: "Click for more information",
  cantidadMinusculas: "quantity",
  totalMinusculas: "total",
  tarjetaYCheques: "Card and cheques",
  seleccionaOperario: "Select operator...",
  necesitasSeleccionarUnProveedorParaPoderHacerUnPedido:
    "You need to select a supplier to place an order",
  estePedidoNoEsValido: "This order is not valid",
  quieresRestablecerElPedido: "Do you want to reset the order?",
  siRestablecerPedido: "Yes, reset order",
  datosPersonales: "Personal data",
  datosDeAcceso: "Access data",
  contrasenaAntigua: "Old password",
  contrasenaNueva: "New password",
  confirmarContrasena: "Confirm password",
  quieresDarDeAltaUnUsuario: "Do you want to register a user?",
  quieresDarDeBajaUnUsuario: "Do you want to deactivate a user?",
  licencias: "Licenses",
  fechaCaducidad: "Expiration date",
  ilimitado: "UNLIMITED",
  lasContrasenasNoCoinciden: "Passwords do not match",
  seleccionaUsuario: "Select user...",
  usuario: "User",
  negocios: "Businesses",
  balance: "Balance",

  teHaParecidoUtilEsteArticulo: "Did you find this article useful?",
  graciasPorTuOpinion: "Thank you for your feedback",
  asignarTurno: "Assign shift",
  vacaciones: "Vacation",
  descargarPDF: "Download PDF",
  enviarHorario: "Send schedule",
  incidenciasEnElMes: "incidents this month",
  diasDeVacacionesEnElMes: "vacation days this month",
  diasDeVacacionesEnElAno: "vacation days this year",
  nuevoTurno: "New shift",
  clonarTurno: "Clone shift",
  nombreDelTurno: "Shift name",
  diasDeLaSemana: "Days of the week",
  editarTurno: "Edit shift",
  borrarTurno: "Delete shift",
  evento: "Event",
  nombreEvento: "Event name",
  hayUnaIncidenciaEnEsteTurno: "There is an incident in this shift",
  fechaInicioTurno: "Shift start date",
  fechaFinTurno: "Shift end date",
  numHorasTurno: "No. shift hours",
  fechaInicioTrabajada: "Worked start date",
  fechaFinTrabajada: "Worked end date",
  numHorasTrabajadas: "No. hours worked",
  noIniciado: "Not started",
  noFinalizado: "Not completed",
  fechaInicioVacaciones: "Vacation start date",
  fechaFinVacaciones: "Vacation end date",
  turnoHorario: "Shift schedule",
  nombreTurno: "Shift name",
  campoRequerido: "Required field",
  introduzcaLosDiasDeLaSemana: "Enter days of the week",
  crearTurnoHorarioDeOperario: "Create operator shift schedule",
  introduzcaLosOperarios: "Enter operators",
  laboral: "Workday",
  vacacional: "Vacation",
  seleccionaTurno: "Select shift...",
  seleccionaLosNegociosALosQueQuiereClonarElTurno:
    "Select businesses to clone the shift to",
  seleccionaLaFechaEnLaQueDeseasCopiarLosHorarios:
    "Select the date to copy the schedules",
  seleccioneUnaSemana: "Select a week",
  lunes: "Monday",
  martes: "Tuesday",
  miercoles: "Wednesday",
  jueves: "Thursday",
  viernes: "Friday",
  sabado: "Saturday",
  domingo: "Sunday",
  laFechaSeleccionadaNoEsValida: "The selected date is not valid",
  turnoClonadoCorrectamente: "Shift cloned successfully",
  correoEnviadoCorrectamente: "Email sent successfully",
  estasSeguroDeBorrarElTurnoSeleccionado:
    "Are you sure you want to delete the selected shift?",
  siBorrarTurno: "Yes, delete shift",
  necesitasCrearAlgunTurnoParaPoderCrearCuadrantes:
    "You need to create a shift to create schedules",
  estasSeguroDeEditarElTurno: "Are you sure you want to edit the shift?",
  siEditarTurno: "Yes, edit shift",
  hoy: "Today",
  turno: "Shift",
  turnoBorradoCorrectamente: "Shift deleted successfully",
  informacion: "Information",
  elDiaNoCorrespondeConLaConfiguracionDelTurnoElegido:
    "The day does not match the selected shift configuration",
  turnoCopiadoCorrectamente: "Shift copied successfully",
  turnoDeOperarioAgregadoCorrectamente: "Operator shift added successfully",
  turnoDeOperarioEliminadoCorrectamente: "Operator shift removed successfully",
  turnoDeOperarioEditadoCorrectamente: "Operator shift edited successfully",
  tecnicoConsultasTecnicasIncidencias:
    "Technician (Technical inquiries, incidents...)",
  comercialActivacionDeProductosInformacionServicios:
    "Sales (Product activation, Information, Services...)",
  administracionFacturacionReclamaciones: "Administration (Billing, Claims...)",
  elAsuntoEsObligatorio: "Subject is required",
  elMensajeEsObligatorio: "Message is required",
  soporteOnlineEnviadoCorrectamente: "Online support sent successfully",
  todosLosNegociosMayusculas: "All businesses",
  recordarMisDatos: "Remember my data",
  paraCualquierIncidenciaOMasInformacionPuedePonerseEnContactoConNosotros:
    "For any incident or more information, you can contact us",
  iniciarSesion: "Log in",
  haOlvidadoSuContrasena: "Forgot your password?",
  haHabidoUnErrorAlConectarPruebeDeNuevo:
    "There was an error connecting. Please try again",
  elEmailNoPuedeEstarEnBlanco: "Email cannot be blank",
  elEmailNoEsValido: "Email is not valid",
  laContrasenaNoPuedeEstarEnBlanco: "Password cannot be blank",
  estaPaginaNoSeEncuentraEnElSistema: "This page is not found in the system",
  volverAlInicio: "Return to home",
  obtenerContrasena: "Get password",
  disculpeLasMolestiasEstamosDeMantenimiento:
    "Sorry for the inconvenience, we are under maintenance",
  funcionEnMantenimiento: "Function under maintenance",
  getDataCompanyMantenimiento: "This function is temporarily under maintenance. Sorry for the inconvenience.",
  vuelvaAIntentarloMasTarde: "Please try again later",
  acepto: "I accept",
  categoriasDeClientes: "Client categories",
  categoriaDeCliente: "Client category",
  nombreCategoria: "Category name",
  noSeleccionada: "Not selected",
  cobradoMayusculas: "PAID",
  envioProgramadoPara: "Scheduled delivery for",
  eliminarPedido: "Delete order",
  aceptarPedido: "Accept order",
  pedidoConfirmado: "Order confirmed",
  archivarPedido: "Archive order",
  detallesPedido: "Order details",
  nota: "Note",
  precioUd: "Unit price",
  gratis: "FREE",
  guardarYAceptarPedido: "Save and accept order",
  seleccionaGrupo: "Select group...",
  todosMayusculas: "ALL",
  nombreOperario: "Operator name",
  apellidos: "Surname",
  claveAcceso: "Access key",
  codigoDeTurnos: "Shift code",
  claveAccesoPDA: "PDA access key",
  seleccionaIVA: "Select VAT",
  calcularCostoAPartirDeMateriasPrimas: "Calculate cost from raw materials",
  seleccionaImpresoraDeComandasTPV: "Select POS order printer",
  seleccionaImpresoraDeComandasPDA: "Select PDA order printer",
  buscarMateriaPrima: "Search raw material",
  buscarProducto: "Search product",
  nuevaMateriaPrima: "New raw material",
  ordenarSubproductos: "Sort subproducts",
  seleccionaEtiqueta: "Select tag...",
  clonarProducto: "Clone product",
  clonarProductoCarta: "Clone product",
  buscarSinPuntos: "Search",
  sinProveedores: "No suppliers",
  agregadas: "added",
  modificadas: "modified",
  materiaPrimaEliminadaCorrectamente: "Raw material deleted successfully",
  asociacion: "association",
  materiaPrimaOrdenadaCorrectamente: "Raw material sorted successfully",
  productosCopiadosCorrectamente: "Products copied successfully",
  menuCopiadoCorrectamente: "Menu copied successfully",
  responder: "Reply",
  administracion: "Administration",
  soporteTecnico: "Technical support",
  horaInicioMayusculas: "Start time",
  horaFinal: "End time",
  personaDeContacto: "Contact person",
  motivoVisita: "Visit reason",
  servicioBajoMantenimiento: "Service under maintenance",
  desplazamiento: "Travel",
  ticketEnviadoCorrectamente: "Ticket sent successfully",
  precioCompraConDescuento: "Purchase price with discount",
  introduzcaLasPartesDelStockMinimo: "Enter minimum stock parts",
  actualizarStockMinimoYOptimo: "Update minimum and optimal stock",
  subproductoDeVerdad: "Subproduct",
  entregado: "Delivered",
  retirada: "Withdrawn",
  subtotal: "Subtotal",
  pagosACuenta: "Payments on account",
  horaDeApertura: "Opening time",
  horaInicio: "Start time",

  condicionesDeNumierOnline: "Numier Online Terms",
  descripcionDelServicio: "Service Description",
  terminosIntroduccionParte1:
    "The Numier cloud service offered by NEXODO DIGITAL S.L. (hereinafter NEXODO) provides its clients with online access to updated information about their businesses.",
  terminosIntroduccionParte2:
    "To do this, Numier point-of-sale applications will send details of sales and other information that may be of interest to their clients via the internet.",
  terminosIntroduccionParte3:
    "Access to this service will be through the website https://www.numier.com/clientes, where you can consult the information sent by your points of sale.",
  terminosIntroduccionParte4:
    "NEXODO reserves the right to improve, modify, or cancel the service at any time.",
  politicaDePrivacidad: "Privacy Policy",
  privacidadParte1:
    "1. NEXODO has issued the following privacy statement to express its firm commitment to protecting your privacy. Please read this privacy policy carefully before using this service, as it implies that NEXODO collects and processes your personal data in accordance with this policy. NEXODO reserves the right to modify the privacy policy at any time. In such a case, NEXODO commits to contacting you to inform you of changes that affect you.",
  privacidadParte2:
    "2. NEXODO respects your privacy choices. If you provide any information, it will be handled according to this policy.",
  privacidadParte3:
    "3. NEXODO recommends discretion when providing information to operators or site owners. Keep in mind that sharing personal information in public areas, such as chat rooms, means anyone with internet access may have access to your information. We recommend not entering any information you do not want others to see in these public areas.",
  privacidadParte4:
    "4. If you register in NUMIER ONLINE, you may need to provide personal data. It is important to register your information correctly on the registration date. If your personal information changes after registration, you must update it immediately. Failure to do so may prevent you from receiving some services or information from NEXODO.",
  privacidadParte5:
    "5. NEXODO may use your personal information to improve this site.",
  privacidadParte6:
    "6. NEXODO collects this data to obtain information to enhance its services and products. The information you provide may also be used to send offers via email or postal mail that may be of interest to you.",
  privacidadParte7:
    "7. To unsubscribe from such emails, you must contact NEXODO to inform them of your decision. Otherwise, NEXODO will maintain the user's information until the subscription is canceled or until any legally required period expires.",
  privacidadParte8:
    "8. NEXODO will not disclose your data to any third party without your consent, unless we believe in good faith that the law requires it.",
  privacidadParte9:
    "9. You have the right to delete all subscription data in our database. To do so, you must contact the company and submit your request.",
  privacidadParte10:
    "10. NEXODO has taken measures to ensure that information is only accessible to the user who initially entered it.",
  privacidadParte11:
    "11. Information can only be accessed once the password has been entered.",
  privacidadParte12:
    "12. This site may contain links to other sites not associated with NEXODO. These sites have their own privacy policies, for which NEXODO is not responsible. Accessing these linked sites is at your own risk.",
  privacidadParte13:
    "13. NEXODO guarantees the security of information regarding its users, except in the following cases:",
  privacidadParte13dos: "- If NEXODO has your consent.",
  privacidadParte13tres:
    "- If NEXODO is legally required to provide the information by law, court order, or other legal procedure.",
  privacidadParte13cuatro:
    "- If disclosing this data is necessary to protect the rights and property of NEXODO.",
  privacidadParte13cinco:
    "- If disclosing your data is necessary to improve our clients' services and products, including yours.",
  privacidadParte14:
    "14. NEXODO ensures proper maintenance of your information on a secure, encrypted server accessible only to authorized third parties.",

  cartaDigital: "Digital menu",
  horarios: "Schedules",
  zonas: "Zones",
  modificarHorariosDeLaCarta: "Edit menu schedules",
  modificarZonasDeLaCarta: "Edit menu zones",
  diaDeLaSemana: "Day of the week",
  esteNegocioNoTieneCarta: "This business has no menu",
  tipoDeEnvio: "Delivery type",
  nuevoHorario: "New schedule",
  elCampoDiaDeLaSemanaEsRequerido: "The day of the week field is required",
  borrarHorario: "Delete schedule",
  laHoraInicioNoPuedeSerMayorQueLaHoraFin:
    "Start time cannot be later than end time",
  noHayHorariosEnEsteNegocio: "No schedules in this business",
  deseaEliminarEsteHorario: "Do you want to delete this schedule?",
  siBorrarHorario: "Yes, delete schedule",
  seleccioneDiaDeLaSemana: "Select day of the week",
  seleccioneTipoDeEnvio: "Select delivery type",

  importacionSage: "Sage Import",
  importacionContable: "Accounting Import",
  enlaceContable: "Accounting Link",
  ejercicio: "Fiscal Year",
  codigoEmpresa: "Company Code",
  asiento: "Entry",
  cargoAbono: "Debit/Credit",
  codigoCuenta: "Account Code",
  fechaAsiento: "Entry Date",
  comentario: "Comment",
  importeAsiento: "Entry Amount",
  numeroPeriodo: "Period Number",
  delegacion: "Branch",
  canal: "Channel",
  ejercicioFactura: "Invoice Year",
  serie: "Series",
  factura: "Invoice",
  suFacturaNo: "Your Invoice No",
  fechaFactura: "Invoice Date",
  importeFactura: "Invoice Amount",
  tipoFactura: "Invoice Type",
  codigoCuentaFactura: "Invoice Account Code",
  codigoRetencion: "Retention Code",
  baseRetencion: "Retention Base",
  porRetencion: "Retention %",
  importeRetención: "Retention Amount",
  baselva1: "Tax Base 1",
  porlva1: "Tax % 1",
  cuotaIva1: "VAT Amount 1",
  porRecargoEquivalencia1: "Equivalence Surcharge % 1",
  recargoEquivalencia1: "Equivalence Surcharge 1",
  codigoTransaccion1: "Transaction Code 1",
  descargarComoTxt: "Download as .txt",

  noHayAsientosContablesEnEsteTpvEnEsteRangoDeFecha:
    "No accounting entries for this POS in this date range",
  cargandoAsientosContables: "Loading accounting entries",
  fechaDeAperturaDeCaja: "Cash Opening Date",
  fechaDeCierreDeCaja: "Cash Closing Date",
  descargarVentas: "Download Sales",
  descargarGastos: "Download Expenses",
  noHasCerradoEstaCaja: "You have not closed this cash register",
  numeroDeCierres: "Number of Closures",
  introduzcaElUltimoNumeroDeAsientoContableQueTieneEnSAGE:
    "Enter the last accounting entry number you have in SAGE",
  porFavorRelleneElAsientoContable: "Please fill in the accounting entry",
  descargar: "Download",
  elAsientoContableDebeSerUnNumero: "The accounting entry must be a number",
  elAsientoContableNoPuedeSerMayorA10Digitos:
    "The accounting entry cannot exceed 10 digits",
  TengaEnCuentaQueUtilizaremosLosSiguientesNumerosAEsteParaCompletarLosDatos:
    "Please note we will use the following numbers after this one to complete the data",
  noExistenVentasEsteDia: "No sales on this day",
  noExistenGastosEsteDia: "No expenses on this day",
  enSage: "in SAGE",
  proyecto: "Project",
  codigoEmpresaHelp:
    "Remember that the company data is shared among all businesses of the same company",
  cuentasDelTpvSeleccionado: "Accounts of the selected POS",
  nuevaCuenta: "New Account",
  nombreDeCuenta: "Account Name",
  codigoCuentaMinuscula: "Account code",
  tipoDeCuenta: "Account Type",
  noHayCuentasCreadasConElTpvSeleccionado:
    "No accounts created with the selected POS",
  crearNuevaCuenta: "Create New Account",
  codigoDeLaCuenta: "Account Code",
  codigoDeLaSubcuenta: "Subaccount Code",
  configuracionCuentasIva: "VAT Account Configuration",
  configuracionCuentasEspeciales: "Special Account Configuration",
  cuenta: "Account",
  subcuenta: "Subaccount",
  editarCuenta: "Edit Account",
  sage200: "SAGE 200",
  exportarCAPTE: "Export CAPTE",
  losCamposNombreCodigoDeCuentaYCodigoDeSubcuentaDebenEstarRellenos:
    "Name, account code and subaccount code fields must be filled",
  estaSeguroDeQueDeseaEliminarEstaCuenta:
    "Are you sure you want to delete this account?",
  siBorrarCuenta: "Yes, delete account",
  cuentaEditadaCorrectamente: "Account edited successfully",
  cuentaCreadaCorrectamente: "Account created successfully",
  configuracionSAGE: "Sage Configuration",
  sinCuentaAsociada: "No associated account",
  loSientoSuNegocioNoTieneContratadoSAGE:
    "Sorry, your business does not have SAGE contracted",
  loSientoSuNegocioNoTieneContratadoEsteModulo:
    "Sorry, your business does not have this module contracted",
  paraMasInformacionContacteConComerciales:
    "For more information contact sales",
  laLongitudMaximaDeLasSubCuentas:
    "Maximum subaccount length must be 12 characters",

  preparados: "Prepared",
  enReparto: "Out for Delivery",
  noHayPedidosPreparados: "No prepared orders",
  noHayPedidosEnReparto: "No orders out for delivery",
  pedidoListo: "Order ready",
  pedidoEnReparto: "Order out for delivery",

  codigo: "Code",
  crearNuevoCodigoCuenta: "Create new account code",
  editarNuevoCodigoCuenta: "Edit account code",
  seleccioneUnaFormaDePagoParaElGasto:
    "Select a payment method for the expense",
  hasSeleccionadoAlbaranesConDiferentesFormasDePagoPorFavorSeleccioneUna:
    "You have selected invoices with different payment methods, please select one",
  seleccioneUnaFormaDePago: "Select a payment method",
  zonasActualizadasCorrectamente: "Zones updated successfully",
  zonaCreadaCorrectamente: "Zone created successfully",
  zonaEditadaCorrectamente: "Zone edited successfully",
  guardarCambios: "Save changes",
  laZonaNoPuedeTenerElNombreEnBlanco: "Zone name cannot be blank",
  zonasDeReparto: "Delivery Zones",
  editarZona: "Edit zone",
  color: "Color",
  costeDeReparto: "Delivery cost",
  pedidoMinimo: "Minimum order",
  crearNuevaZona: "Create new zone",
  estasSeguroDeQueQuieresEliminarLaZona:
    "Are you sure you want to delete this zone?",
  estaZonaDejaraDeEstarDisponibleInmediatamenteYNoSePodranHacerPedidos:
    "This zone will immediately be unavailable and no orders can be placed from it",
  siEliminarZona: "Yes, delete zone",
  zonaEliminadaCorrectamente: "Zone deleted successfully",
  ventasExportadas: "Sales exported",
  gastosExportados: "Expenses exported",
  todosLosCierresDeEsteDiaHanSidoExportados:
    "All closures of this day have been exported",
  faltanVentasPorExportarEsteDia: "Sales remaining to export this day",
  todosLosGastosDeEsteDiaHanSidoExportados:
    "All expenses of this day have been exported",
  faltanGastosPorExportarEsteDia: "Expenses remaining to export this day",
  exportar: "Export",

  // 10-02-2021
  otros: "Others",
  restriccionHorarios: "Time Restriction",
  restriccionHorariosDesc:
    "Restrict certain time slots (closed, full, no delivery...)",
  borrar: "Delete",
  restriccion: "Restriction",
  nMaximoPedidos: "Max. Number of Orders",
  cerrarFranja: "Close Slot",
  limitePedidos: "Order Limit",
  loSentimosSuNegocioNoTieneContratadoEsteModulo:
    "Sorry, your business does not have this module contracted",
  numeroPedidosPermitidos: "Allowed Number of Orders",
  estaSeguroDeQueDeseaEliminarEstaRestriccion:
    "Are you sure you want to delete this restriction?",
  siBorrarRestriccion: "Yes, delete restriction",
  loSentimosParaAccederAEsteModuloNecesitaActivarLaConfiguracion:
    "Sorry, to access this module you need to activate the configuration",
  costeSinIVA: "Cost without VAT",

  // 11.3.2021
  importeIVA: "VAT Amount",

  // 17.3.2021
  pasarAPreparacion: "Move to Preparation",
  pasarAPreparados: "Move to Prepared",
  pasarAEnReparto: "Move to Out for Delivery",
  finalizarPedido: "Complete Order",

  // Tener en cuidado con los espacios, ya que son los espacios Braille
  domicilioActivado: "‏‏‎HOME DELIVERY⠀ACTIVATED",
  domicilioDesactivado: "HOME DELIVERY⠀DEACTIVATED",
  recogerActivado: "PICKUP⠀ACTIVATED",
  recogerDesactivado: "PICKUP⠀DEACTIVATED",

  conDetalles: "with details",
  zonasRepartoActivadas: "ACTIVATED⠀",
  zonasRepartoDesactivadas: "DEACTIVATED⠀",
  siEliminarCategoria: "Yes, delete category",
  confirmaEliminarCategoria: "Are you sure you want to delete this category?",
  pedidoPreparado: "Order prepared",
  configuracionParaLaImportacionExportacionDeDatosDeSage:
    "Configuration for Sage data import/export",
  enEstaPantallaSeConfiguranLosCodigosDeLasCuentas:
    "In this screen you configure the account codes",
  formadosPor3Digitos: "composed of 3 digits",
  estosSonNecesariosParaConfigurarLasCuentasContables:
    "These are necessary to configure the accounting accounts",
  alEditarUnCodigoRelacionadoConUnaCuentaContableYaExistente:
    "When editing a code related to an existing accounting account",
  todoCambioQueSeProduzcaSobreEsteAfectaraTambienALaPropiaCuenta:
    "any change will also affect the account itself",
  aContinuacionSeListaranLasCuentasDeTipo:
    "Next, the accounts of type will be listed",
  gastoMinuscula: "expense",
  paraQue: "so that",
  asocieMinuscula: "associate",
  ventaMinuscula: "sale",
  unaParaSuPosterior: "one for its subsequent",
  relacionEnSage: "relation in SAGE",
  relacionEnContabilidad: "relation in accounting",
  seleccioneUnaCuenta: "Select an account",
  aDomicilio: "Home delivery",
  aRecoger: "Pickup",
  tipoDeZona: "Zone type",
  seleccioneUnTipo: "Select a type",
  kilometrosDelArea: "Km of the area",
  codigoEmpleado: "Employee code",
  exportarReservas: "Export reservations",
  importacionSinqro: "Sinqro Import",
  configuracionParaLaImportacionDeDatosDeSinqro:
    "Configuration for Sinqro data import",
  pasarelaDePago: "Payment gateway",
  importeSinDescuento: "Amount without discount",
  desactivarZona: "Deactivate zone",
  activa: "ACTIVE",
  inactiva: "INACTIVE",
  exportarPdfConMateriasPrimasAsociadas:
    "Export PDF with associated raw materials",
  exportarExcelConMateriasPrimasAsociadas:
    "Export Excel with associated raw materials",

  // Pedidos archivados 18/05/21
  informePedidosDetalle: "Order breakdown",
  informePedidos: "Order report",
  tipoPago: "Payment method",
  tipoPedido: "Order type",
  domicilio: "Home delivery",
  recoger: "Pickup at store",
  pagoLocal: "Payment in store",
  otro: "Other",

  // 25/05/2021
  configuracionTurnos: "Shift configuration",

  // 2021/05/20
  estasSeguroDeImportarTusProductosASinqro:
    "Do you want to import your products to Sinqro?",
  esteProcesoPuedeTardarVariosMinutos: "This process may take several minutes.",
  siImportarConSinqro: "Yes, import to Sinqro",
  estasSeguroDeDarDeBajaElProducto: "Do you want to deactivate the product?",
  podraDarloDeAltaEnUnFuturo: "You can activate it in the future",
  siDarDeBaja: "Yes, deactivate",
  estasSeguroDeDarDeAltaElProducto: "Do you want to activate the product?",
  podraDarloDeBajaEnUnFuturo: "You can deactivate it in the future.",
  siDarDeAlta: "Yes, activate",
  laImportacionTardara: "Importing... this process may take several minutes",
  importacionFinalizada: "Import completed successfully",
  completo: "Completed",
  vale: "Okay",
  importarSinqro: "Import Sinqro",
  importandoProductos: "The import is currently in progress...",
  generandoCarta: "One moment, please. Generating your menu.",
  procesoFin: "The process has been successfully completed",
  procesoCompletado: "Process completed",
  yaFaltaPoco: "Almost done...",
  estamosEnEllo:
    "We are working on the import. Please do not refresh the browser.",
  finProgres: "Progress finished successfully.",
  textoInfo: "This column shows the purchase price without VAT",
  textoInfoImporteDTO:
    "This column shows the total purchase price with discount (calculated from the price without VAT)",
  correosEnviados: "Emails sent",
  correosEnviadosCorrectamente: "The emails were sent successfully.",
  errorAlEnviar: "Error sending",
  noSePudieronEnviarTodosLosCorreos: "Not all emails could be sent:",
  errorInesperadoEnvioCorreos:
    "An unexpected error occurred. Please try again later",

  // 07/06/2021
  valorRecuento: "Count value",

  // 08/06/2021
  obligatorioEmail: "Email is required",
  datosCliente: "Customer data",

  // 11/06/2021
  recuerdeQueElHacerCobrosAvanzadosPuedeGenerarPequenosDescuadres:
    "Remember that making advanced payments may generate small discrepancies",
  yQue: "and that",
  losDescuentosDeLasVentasEstanAlCeroPorcientoDeIva:
    "sales discounts are at 0% VAT",

  // 16/06/2021
  totalValoresNegativos: "Total negative values",
  solamenteSeTieneEnCuentaValoresPositivos:
    "Only positive values are considered",
  totalValoresDiferencia: "Total difference values",
  totalValoresDiferenciaDto: "Total difference values with discount",
  valorDiferencia: "Difference value",
  valorDifereciaDto: "Difference value with discount",
  precioDto: "Discounted price",

  // 24/06/2021
  exportarMateriasPrimasAsociadasAEsteProducto:
    "Export raw materials associated with this product",
  sinIVA: "Without VAT",
  errorAlIntentarObtenerLosTpvs: "Error trying to get the TPVs",

  // 01/07/2021
  deseaguardarelproductoencarta:
    "Next, the names and prices of the rates greater than €0 will be replicated, as well as the deactivation field. These changes will affect all NumierORDERS products related to this product.",
  leidoyacepto: "I understand!",
  replicarencarta: "Are you sure?",
  aceptarreplicarencarta: "Accept and replicate in menu",
  guardaryreplicar: "Save and replicate in menu",

  // Modal seleccionar categoría al crear en carta
  enlazarACategoria: "Link to a category",
  deseaEnlazarProductoCategoria: "Do you want to link the new product to an existing category in the menu?",
  categoria: "Category",
  seleccionarCategoria: "Select category",
  omitirYCrear: "Skip and create",
  aceptarYAgregar: "Accept and add",

  // 01/07/2021
  porRangosHorarios: " by time ranges",

  // 22/07/2021
  recuerdeQueLasLineasDeDescuentoNoSeSumanAlTotal:
    "Remember that discount lines are not added to the total",

  // 16/07/21
  destacado: "Featured",
  sugerido: "Suggested",

  // 23/07/2021
  totalSinDescuento: "Total without discount",

  // MENÚS
  menus: "Menus",
  descripcionMenus: "Group of products sold together",
  numeroDePlatos: "Number of dishes the customer can choose per dish:",
  platosTip1: "On this screen you can create the different dishes that",
  platosTip2: "make up the menu for later assignment with products.",
  productosPlatosTip:
    "On this screen you can link dishes and products for later display in the menu.",
  plato: "Dish",
  platos: "Dishes",
  primerPlato: "First dish",
  segundoPlato: "Second dish",
  tercerPlato: "Third dish",
  cuartoPlato: "Fourth dish",
  quintoPlato: "Fifth dish",
  sextoPlato: "Sixth dish",
  seleccionaUnPlato: "Select a dish",
  noPuedeDejarEnBlancoElNombreDeUnPlato: "You cannot leave the dish name blank",
  estaSeguroDeQueQuiereBorrarEstePlato:
    "Are you sure you want to delete this dish?",
  seBorraranTodasLasAsociacionesDeProductosConElMismo:
    "All product associations with it will be deleted",
  siEstoySeguro: "Yes, I am sure",
  estaSeguroDeQueQuiereDesvincularEsteProductoDelPlatoSeleccionado:
    "Are you sure you want to unlink this product from the selected dish?",
  dejaraDeFormarParteDelMenuDeFormaInstantanea:
    "It will instantly stop being part of the menu",
  noMostrarSuelto: "Do not show separately (only available in menus)",
  clonarMenu: "Clone menu",
  // 29/07/2021
  totalPedidosDevueltos: "Number of returns",
  totalImportesDevueltos: "Total amount returned",

  // 06/08/2021
  NoMostrarRecargasSaldo: "Do not show balance top-ups",
  // 10/08/2021
  noMostrarDescuento: "Do not show discounts",
  // 17/08/2021
  operarioApertura: "Opening operator",
  aperturasPorOperarios: "Accounts opened by operator",
  aperturasPorOperariosMinuscula: "accounts opened by operator",
  aperturasOperarios: "Accounts opened",
  productosPorAperturaDe: "Products by opening of",
  productosPorApertura: "Products by opening",
  facturasEmitidasMinuscula: "invoices issued",

  // 18/08/21
  restriccionesProductos: "Product restrictions",
  restriccionesProductosDesc: "Configure time restrictions for product sales",
  // 19/08/21
  noHayRestriccionesParaProductos:
    "There are no time restrictions for products in this business.",
  alcohol: "Alcohol",
  // 20/08/21
  inforestriccionesproducto:
    "Once you have created the time sale restriction, you can assign it in the product settings.",
  noMostrarDescuento: "Do not show discounts",

  // 17/08/2021
  rangosDeMesas: "Table ranges",
  agrupacionesDeMesasParaConsultarVentas: "Table groupings to consult sales",
  verUnInformeDeRangosDeMesas: "View table ranges report",
  nuevoRangoMesa: "New table range",
  mesaInicial: "Initial table",
  mesaFinal: "Final table",
  noHayRangosDeMesasEnEsteTpv: "There are no table ranges in this POS",
  nombreRangoDeMesas: "Table range name",
  borrarRangoMesas: "Delete table range",
  deseaEliminarEsteRangoDeMesas: "Do you want to delete this table range?",
  siBorrarEsteRangoDeMesas: "Yes, delete this table range",
  ventasPorRangoDeMesas: "Sales by table range",
  porRangoDeMesas: " by table range",
  numeroDeOperaciones: "Number of transactions",
  precioMedioPorOperacion: "Average price per transaction",
  propuestoParaCierre: "Proposed for closing",
  esteTicketHaSidoPropuestoParaSuCierreComaEstaUstedDeAcuerdo:
    "This ticket has been proposed for closing, do you agree?",
  siCerrarTicket: "Yes, close ticket",
  propuestaDeCierreDeTicket: "Ticket closing proposal",
  noEstoyDeAcuerdo: "I do not agree",
  ultimaRespuestaDelEquipoTecnico: "Last response from technical team",
  escribaAquiSuRespuesta: "Write your response here",
  enviarRespuesta: "Send response",
  tienesTicketsPendientesDeCerrar: "You have tickets pending closure",

  // 27/08/2021
  cuandoUnProductoEsDeTipoMenuSeCreaUnProductoMenuEnElTPV:
    "When a product is of type Menu, a Menu is created that syncs with the POS",
  platosDelMenu: "Menu dishes",
  productosDelMenu: "Menu products",
  paraConfigurarUnProductoComoTipoMenu:
    "To configure a product as Menu type, you must first save the product",
  ocultarSaldo: "Hide products related to balance",

  // 26/08/21
  resActiva: "Active",
  resInactiva: "Inactive",

  // 26/08/2021
  exportarExcelDeTodosLosTickets: "Export Excel of all tickets",
  soloPuedesSacarInformesDeUnMesComoMaximo:
    "You can only generate reports for a maximum of one month",
  loSentimos: "We are sorry",
  noTienesNingunRangoDeMesasCreadoDeseasCrearUnRangoDeMesas:
    "You do not have any table range created. Do you want to create a table range?",
  siCrearUnRangoMesas: "Yes, create a table range",

  // 07/08/2021
  usuarioSinAcceso: "Your user does not have access to this module",

  // 08/09/21
  pedidosHoras: "Orders by hours",
  graficaPedidosHoras:
    "Graph showing number of orders grouped by time slot for today",

  // 20/09/21
  personalizacionCarta: "Online Menu Customization",
  personalizacion: "Customization",
  conLasOpcionesQueTeOfrecemos: "with the options we offer",
  opcionesConfiguracion: "Configuration options",
  vistaPrevia: "Preview",
  imagenCargando: "Loading image",

  // 21/09/21
  diagnosis: "Diagnosis",
  diagnosticoProductos: "Product diagnosis",
  comprobacionProducts: "Product check",
  diagnosticarProductos: "Diagnose products",
  productosSinRelacionEnElTpv: "All correct!",
  pulseElBoton: "Press the desired button",
  paraRealizarDiagnosis: "to perform the diagnosis",
  productoRelacionadoConTpv: "Linked in POS with",
  noTieneRelacion: "Not linked",
  hayProductosSinRelacion: "There are products not linked in the POS",

  // 20/09/21
  destacadosTitulo: "Featured title",
  nuevoTitulo: "New title",
  tituloActual: "Current title",

  // 22/09/21
  textos: "Texts",

  // 21/09/21
  facturas: "Invoices",
  facturasMinusculas: "invoices",
  facturacionGeneral: "General billing",
  deTodasLasSeries: " of all series",

  // 29/09/21
  permisoBusinessGestion:
    "Sorry. You do not have permission to use this tool in the current business",
  permisoUsuarioGestion:
    "Sorry. This business does not have this module activated.",
  traduccion: "Translation",
  traduccionDe: "Translation of",
  idioma: "Language",
  losDescuentosDeLasVentasEstanAlCeroDeIva: "Sales discounts are at 0% VAT",
  recuerdeQueAlRealizarCobrosAvanzadosLosComensalesSeAsignaranALaFormaDePagoEfectivo:
    "Remember that when making advanced payments, diners will be assigned to cash payment",
  mapasYZonas: "Maps and zones",
  idiomas: "Languages",
  permisoControlIdiomas:
    "Sorry, this business does not have language control activated.",
  idiomasCartaTip1:
    "To activate or deactivate a language, you can click the switches.",
  idiomasCartaTip2:
    "To order the languages in the menu, you can use the order field.",
  idiomasCartaTip3: "Languages with a lower order will appear first.",
  menu: "Menu",

  // 30/11/21
  totalVentasDevueltos: " total sales and returns",

  // 24/11/21
  tpvOrigen: "Origin POS",
  validez: "Validity (days)",
  dateConsumo: "Consumption date",
  dateCreacion: "Issue date",
  nombreTpvDestino: "Redeem POS",
  nombreTpvOrigen: "Origin POS",
  hash: "CODE (hash)",
  proveedor: "Supplier",

  // 14/12/2021
  apuntes: "Entries",
  apunte: "Entry",
  cuentaContableGastos: "Expense account",
  cuentaContableApuntes: "Entry account",
  retrocederEstado: "Revert state",

  // 23/12/2021
  excluirDeSage: "Exclude from Sage",
  costeDeProductosPorAgencias: "Product cost by agencies",
  agrupadoPorAgencias: " grouped by agencies",

  // 27/10/21
  selectCategory: "Select categories for import",
  errorCategorySelect: "WARNING",
  txtErrorCategorySelect:
    "The import was canceled because the selected categories only contain menus.",

  // 24/01/22
  consultarPorAperturaDeCuenta: "Consult by account opening",
  consultarPorCierreDeCuenta: "Consult by account closing",
  informeAperturaCuentas: "Account opening report",
  informeCierreCuentas: "Account closing report",
  activado: "Activated",
  desactivado: "Deactivated",
  rango: "Range",
  pedidosPlataformaDePagoSinCompletar: "Payment platform orders not completed",
  estaAccionAnadiraUnPedidoEstaSeguro:
    "This action will add an order, are you sure it has been paid?",
  estaAccionNoSePuedeDeshacerEstaSeguro:
    "This action cannot be undone, are you sure?",
  haHabidoUnPedidoConEsteTelefonoEnLasUltimas12Horas:
    "There has been an order with this phone in the last 12 hours",
  interrogacionQuiere: "Do you want to ",
  elPedidoTemporalInterrogacion: " the temporary order?",
  aceptarMinuscula: "accept",
  eliminarMinuscula: "delete",
  excluirPrecioMedioMenu: "Exclude from average price products sold in menus",

  // 28/01/22
  categoriasPadre: "Parent categories",
  quieresConvertirLaCategoria: "Do you want to convert the category",
  quieresQueLaCategoria: "Do you want the category",
  enUnaCategoriaPadre: "into a parent category?",
  dejeDeSerUnaCategoriaPadre: "to stop being a parent category?",
  porFavorAnadaUnaCategoriaPadreAntesDeActivarLaConfiguracion:
    "Please add a parent category before activating the configuration",
  deseaActivarLasCategoriasPadreParaLaCartaDigital:
    "Do you want to activate parent categories for the digital menu?",
  deseaDesactivarLasCategoriasPadreParaLaCartaDigital:
    "Do you want to deactivate parent categories for the digital menu?",
  recuerdeQueLasCategoriasQueNoEstenRelacionadasAUnaCategoriaPadreNoApareceranEnLaCartaDigital:
    "Remember that categories not linked to a parent category will not appear in Numier Pedidos",
  activadas: "ACTIVATED",
  desactivadas: "DEACTIVATED",
  categoriasPadreTextoExplicativo:
    "Parent categories are used to group Numier Pedidos categories into larger groups. Example: You can have a parent category 'Starters' containing Meat, Fish, and Vegetarian",
  lasImagenesSoloSeraVisibleEnLasCategoriasPadre:
    "Images will only be visible in parent categories",

  // 09/02/2022
  consultarInventarioPorSectores: "Consult inventory by sectors",
  inicioReal: "Actual start",
  precarga: "Preload",
  mermas: "Waste",
  finalBarra: "End bar",
  porSectores: "by sectors",
  buscarPorRefONombreDelProducto: "Search by barcode or product name",
  textoAyudaProductoCompleto:
    "When this option is unchecked, raw materials will be used",
  accion: "Action",

  metodoLiquidacionSinqro: "Sinqro liquidation method",
  metodoLiquidacionSinqroInfo:
    "Modification of this field must be requested from technical support.",
  horaRepartidorAsignado: "Assigned delivery time",
  envioProgramado: "Scheduled delivery",
  tiempoEstimado: "Estimated time",
  gastosEnvio: "Shipping costs",
  buscarPedidoPorCliente: "Search order by customer...",
  obligatorioApellidos: "Both surname fields are mandatory",

  // 13/06/2022
  introduzcaElPorcentajeDeLaPrimeraCuentaContable:
    "Enter the percentage of the first accounting account",
  porcentajeContable: "Accounting percentage",

  // 7/7/2022
  incidenciaOperario: "Incidents by operator",
  deIncidenciaOperario: "of incidents by operator",
  verIncidenciaOperario: "View incidents",
  Incidencia: "Incident",

  // 11/07/2022
  nTickets: "Ticket Nº",
  propina: "Tip",
  serviceCharge: "Service Charge",

  // 15/07/2022
  totalCompleto: "Total complete",

  // 31/08/2022
  sinConsumir: "Unused",

  // 06/09/2022
  integraciones: "Integrations",
  GStock: "G-Stock",

  // 13/09/2022
  estasSeguroDeExportarLasVentas:
    "Are you sure you want to export sales to G-Stock?",
  ventasExportadasExsitosamente: "Sales exported successfully",
  rangoFechasExcedidoMaximo: "The date range cannot exceed 3 months",
  rangoSolicitadoMayorAlPermitido: "The requested range exceeds the allowed limit (maximum 3 months)",
  respuestaInvalida: "Invalid server response",

  // 04/10/2022
  referenciaYaExiste: "The reference matches another expense",
  continuar: "Continue?",
  guardarGasto: "Save expense",
  maximoOpcionales: "Maximum optional items",

  // 04/11/2022
  totalImpuestoIva: "Total VAT tax",

  // 09/11/2022
  enviarFacturaECorreo: "Send electronic invoice by email",

  // 10/11/2022
  baseImponible: "Tax base",
  cuotaIVA: "VAT amount",
  baseSinDto: "Base without disc.",
  importeTotalSinDto: "Total amount without disc.",

  // 17/11/2022
  identificador: "Accounting identifier",

  // 13/12/2022
  cambiarAgencia: "Change agency",
  facturaEditadaCorrectamente: "Invoice edited successfully",
  editarNumeroComensales: "Edit number of diners",
  buscarPorNombreDeAgencia: "Search by agency name",

  // 10/01/2023
  exportadoSage: "Exported to SAGE",
  updateExportadoSageCorrectamente: "Exported SAGE updated successfully",
  titleModificarExportadoSage: "Modify exported to SAGE",
  askUpdateExportadoSageTrue:
    "Are you sure you want to mark the expense as exported?",
  askUpdateExportadoSageFalse:
    "Are you sure you want to mark the expense as NOT exported?",

  // 01/02/2023
  ProgramacionCarta: "Menu Planner",
  guardados: "Saved",
  publicados: "Published",
  dePublicacion: "of Publication",
  sinPublicar: "Unpublished",
  publicado: "published",
  publicar: "Publish",
  Ocultar: "Hide",
  Publicado: "Published",
  aliasMayuscula: "Alias",

  // 03/02/2023
  porcentajeRespectoTotal: "% of total",

  // 13/02/2023
  ultimoPrecioCompra: "Last purchase price",

  // 21/02/2023
  basePropina: "Tip Base",
  impuestoPropina: "Tip Tax",
  baseServiceCharge: "Service Charge Base",
  impuestoServiceCharge: "Service Charge Tax",

  // 02/03/2023
  socios: "Partner",
  noSocios: "Not a partner",

  // 20/04/2023
  productoCartaSinRelacionar: "Unlinked",

  // 21/04/2023
  precioTarifa: "Price / Rate 1",

  resetearDias: "Reset Days",
  resetearButton: "Reset",
  fechaIni: "Start Date",
  fechaFin: "End Date",
  reseteoExitoso: "Reset completed successfully",
  reseteoError: "There was an error performing the reset",

  productosNoRelacionados: "Products without PLU",
  productosNoRelacionadosDescripcion: "Tool to find products without PLU",

  // 23/05/2023
  verDetallesDeCuentaAnulada: "View canceled account details",
  desgloseDeCuenta: "Account breakdown",

  // 29/03/2023
  exportarExcelValderrama: "Export complete Excel",

  // 20/04/2023
  productoCartaSinRelacionar: "Unlinked",

  // 21/04/2023
  precioTarifa: "Price / Rate 1",

  // 29/05/2023
  pendientePago: "Pending payment",
  fechaVencimiento: "Due date",
  pendientePagoCambiadoCorrectamente: "Pending payment changed successfully",
  numeroTickets: "Number of tickets",

  // 06/06/2023
  mensajePorcentajeCompraAumento:
    "Price increased from the set purchase percentage",
  avisoPorcentajeCompra: "Purchase percentage warning",

  // 19/06/2023
  conIvaDesglosado: "with VAT broken down",

  // 21/06/2023
  ventasPorProductos: "Sales by products",
  sinRecoger: "Not picked up",
  sinDomicilio: "No delivery",
  recogerEnPedidos: "Pick-up",
  domicilioEnPedidos: "Delivery",
  informeDeVentasDeProductosDePedidos: "Report of product sales from orders",

  // 22/06/2023
  numeroPedidosDomicilio: "Number of delivery orders",
  numeroPedidosRecoger: "Number of pick-up orders",

  // 25/07/2023
  exportarSage200Fechas: "Export Sage200 by dates",
  fechas: "Dates",
  soloExportarGastos: "Only export expenses",

  // 05/09/2023
  noMostrarInformeSectores: "Do not show sector report",
  totalCargar: "Total to load",
  deshabilitar: "Disable",
  noMostrar: "Do not show",

  // 19/09/2023
  verificarTodo: "Verify all",
  estaSeguroDeVerificarTodosLosGastos:
    "Are you sure you want to verify all expenses?",
  gastosVerificadosCorrectamente: "Expenses verified successfully",

  // 26/09/2023
  siVerificarGastos: "Yes, verify expenses",
  seleccionarTodosDelMismoProveedor: "Select all from the same supplier",

  // 28/09/2023
  mostrarSinIva: "Show without VAT",
  modificarPrecio: "Modify price",

  // 05/10/2023
  nDeComensales: "Number of diners",

  // 13/10/2023
  archivoEnFormatoExcel: "File in Excel format",
  importarExcelClientes: "Import clients Excel",
  importarExcelSaldoClientes: "Import clients balance Excel",
  importarClientes: "Import clients",

  // 31/10/2023
  ticketMedioRecoger: "Average ticket pick-up:",
  ticketMedioDomicilio: "Average ticket delivery:",

  // 23/11/2023
  ultimoPrecioCompraSinIva: "Last purchase price without VAT",

  // 08/01/2024
  ventaDeProductosPorRangoDeMesas: "Product sales by table range",
  filtradoPorRangoDeMesas: " filtered by table range",
  vecesQueSeHaVendidoDentroDeMenus: "Times sold within menus",
  delMenu: "of the menu",
  cEnMenus: "C. in Menus",
  cFueraDeMenus: "C. Outside Menus",
  rangoDeMesas: "Table range",

  // 10/01/2024
  // ToolTip
  tolTipLogo:
    "Add your restaurant logo to appear on the home screen and your QR card. Recommended size is 90 x 90 px.",
  tolTipFondo:
    "Add a high-quality photo to appear as the cover on your QR menu. Recommended size is 1280 x 1024 px.",
  tolTipImagenProducto:
    "Add a high-quality image to showcase your product visually. For menu products, create a new one with ideal resolution 500 x 500 px or 12 cm x 12 cm.",
  tolTipNombreMostrado: "Enter the name you want to display for your business.",
  tolTipEmail: "Provide a contact email for your customers.",
  tolTipTelefono: "Provide a contact phone number.",
  tolTipDescripcion:
    "Briefly describe your restaurant: concept and experience offered.",
  tolTipDireccion: "Provide the restaurant address related to this menu.",
  tolTipPresentacion:
    "Write a call-to-action to encourage customers to open your card on the home screen.",
  tolTipHorario:
    "Present your hours or share extra information (holidays, out of service...).",
  tolTipMostrarCategoriaDeBaja:
    "If checked, deactivated categories will be shown but not in your menu.",
  tolTipMostrarProductoDeBaja:
    "If checked, deactivated products will be shown but not in your menu.",
  tolTipTraducirCategoria:
    "Translate the category titles into the desired language",
  tolTipConvertirCategoriaPadre: "Convert to parent category",
  tolTipOrdenCategorias:
    "To display this category first, set number to '1', and so on according to order.",
  tolTipBajaCategoria:
    "Activating this option will hide the selected category in your digital menu. All products under it will also become invisible.",
  tolTipVerQr: "Access and download your menu QR code",
  tolTipDisponibleProducto:
    "Mark product availability: indicates if a product is available or not in your menu.",
  tolTipIdiomaProducto: "Choose the language to present the product in.",
  tolTipOrdenProducto:
    "Choose the order in which the product appears within the selected category.",
  tolTipProductoDestacado:
    "Select this option to highlight the product at the top of the menu. Show special items or promotions.",
  tolTipBaja: "This product will not appear in your menu if activated.",
  tolTipDisponible:
    "Activate if the product is available for sale. Deactivate if 'Out of Stock'.",
  tolTipImagenCarga: "Image displayed while your menu loads.",
  tolTipTituloDestacado:
    "Define the text for the featured products section, e.g., 'Chef's Suggestions', 'Top Sales', or 'Must-Try'.",
  tolTipIdiomaMateriaPrima:
    "Choose the language to present the raw material in.",
  guiaUsuario: "User guide",

  // 14/02/24
  pedidosPorRepartidores: "Orders by delivery staff",
  nombreRepartidor: "Delivery staff name",
  cantidadDePedidos: "Number of orders",

  // 13/02/2024
  herramientaControlStockControlComprasInventarios:
    "Tool for stock, purchases, and inventory control",
  fidelizacion: "Loyalty",
  cheerfy: "Cheerfy",
  plataformaGestionPromocionesClientes:
    "Customer promotions management platform",
  nuevaPromocion: "New promotion",
  noHayPromocionesEnEsteTpv: "No promotions in this POS",
  tolTipDisponiblePromocion:
    "Mark promotion availability: indicates if the promotion is active or not.",
  promocion: "promotion",
  fechaCreacion: "Creation date",
  activo: "Active",
  inactivo: "Inactive",
  borrarPromocion: "Delete promotion",
  promociones: "Promotions",
  codigoPromocion: "Promotion code",
  elCampoCodigoEsRequerido: "The code field is required",
  deseaEliminarEstaPromocion: "Do you want to delete this promotion?",
  siBorrarEstaPromocion: "Yes, delete this promotion",

  // 12/03/24
  basesFree: "Extra bases free",
  extrasFree: "Bases / Extras free",
  tooltipBaseExtra:
    "If the base is enabled, it does not count as free. If the extra is enabled, it will not count as free when added.",

  // 09/04/24
  permisoControlModulos:
    "Sorry. This business does not have this module activated.",
  calcularCosteTodosLosProductos: "Calculate cost of all products",
  trabajarSinIva: "Work without VAT",
  filtrarPorAgencias: "Filter by agency",
  seleccioneLaTarifaParaMostrarSuNombre: "Select the rate to show its cost",
  conIVA: "With VAT",
  calcular: "Calculate",
  productosIncluidosConEsteMenu: "Products included with this menu",
  abonarFacturaQr: "Pay QR Invoice",
  deseasAbonarEstaFacturaQR: "Do you want to pay this QR invoice?",
  abonarFactura: "Pay invoice",

  exportar: "Export",
  codigoBarras: "Barcode",
  codBarras: "B.Code",

  // 18/08/24
  listadoTicketRepartidor: "Tickets per delivery person",

  // WALLET
  passbooks: "Passbooks",
  sharePassbooks: "Share wallets",
  copyToClipboard: "Copy to clipboard",
  shareViaEmail: "Send via email",
  shareViaWhatsapp: "Send via Whatsapp",
  copied: "Copied to clipboard",
  selectBusinessForWallet:
    "Select the business for which you want to send the Wallets",
  sendMethod: "Sending method",
  share: "Send",
  sendAndSaveButton: "Yes, send and save",
  sendAndNoSaveButton: "No, send and do not save",
  titleSaveInfoModalText:
    "Customer information has changed. Do you want to save it?",
  verifyNumberText: "Verify phone",
  verifyEmailText: "Verify email",
  selectOption: "Select an option",
  clipboardCopied: "Copied to clipboard",
  clipboardFailedToCopy: "Clipboard API is not available in this browser.",
  enviarWallet: "Send Wallet",
  confirmacionEnvioWallet: "Wallet Send Confirmation",
  confirmacionTextoEnviarWallet:
    "Are you sure you want to send the wallet to all customers?",
  mensajeConfirmacion:
    "This action cannot be undone and will only be sent to customers who have an email and a barcode.",
  enviar: "Send",
  noHayCorreosElectronicos: "No emails available.",
  ningunClienteConCorreoElectronico:
    "No customer with a configured email was found.",
  clientHasNoBarcode: "Customer has no barcode set.",
  exportarCarta: "Export Menu",
  exportarSimplifiedExcel: "Export as Excel (No headers)",

  // GESTIÓN DE IMPUESTOS
  taxes: "Taxes",
  tax: "Tax",
  gestionImpuestos: "Tax Management",
  administracionTiposTasas: "Administration",
  administracionTiposTasasImpositivas: " of tax types and rates",
  agregarImpuesto: "Add Tax",
  taxRate: "Applied Tax",
  taxDescription: "Description",
  taxType: "Tax Type",
  taxBoldType: "taxes",
  impuestoAplicadoEsCero: "Applied Tax cannot be less than ",
  impuestoYaCreado: "This tax already exists and cannot be created again",

  // IMPORTAR CLIENTES
  previewClientData: "Client Preview",
  editarCliente: "Edit client",
  importarData: "Import data",
  importandoDatos: "Importing data",
  preview: "Preview",
  importacionRealizada: "Import completed",
  datosImportados: "Data imported successfully",
  confirmarImportacion: "Confirm import",
  seguroContinuarImportacion:
    "Are you sure you want to continue? This action is irreversible",

  // 18/11/24 - Update Logo
  inserteImagen: "Insert an image",
  seleccioneArchivoImagen: "Select an image file",
  archivoDemasiadoGrande: "The file is too large. Maximum allowed size is 5MB.",
  dimensionesExcedenLimite:
    "Image dimensions exceed allowed limit (2000x2000px).",
  mensajeconfirmacion:
    "You are about to replace the existing image. Do you want to save?",
  botonGuardar: "Save",
  botonCancelar: "Cancel",
  Guardado: "Saved",
  guardarOvisualizarLogo: "View or save logo",
  configurarLogoNegocio: "Configure business logo",
  seleccionLogo: "Click to select a logo",
  volver: "Back",
  noExisteLogoNegocio: "No logo exists for the business.",
  informacion: "Information: ",
  tamaño: "Size: ",
  dimensiones: "Dimensions: ",
  restriccionesLogo: "Logo restrictions:",
  tamañoMaximo: "Max size: ",
  dimensionesMaximas: "Max dimensions: ",

  // 13/12/24 - ProductosNoRelacionados
  mensajeAviso:
    "Are you sure you want to automatically generate PLUs? This process will generate a code for each unconfigured product and rate, and will be saved automatically.",
  mensajeAvisoSubProducto:
    "Are you sure you want to automatically generate PLUs? This process will generate a code for each unconfigured raw material and will be saved automatically.",
  generarPlu: "Automatically generate PLUs",
  botonAceptar: "Accept",
  PLUsGenerados: "PLUs generated successfully!",
  errorGenerandoPLUs: "Error generating PLUs",

  // 21/01/2025
  nosmudamos: "We moved!",
  noscambiamosaselfi:
    "Your business has taken a big step: now your menu is part of the Selfibar family. From now on, all configurations and management related to the menu can be done directly in Selfibar.",
  esteNegocioEsSelfi: "This business is Selfibar",
  paraContinuar:
    "To continue, click on Selfibar and log in with your Selfibar account",
  irASelfibar: "Go to Selfibar",
  barcodeUnico: "Unique barcode",
  barcodeNecesarioSeActualizara:
    "The barcode is required for this action and will be updated for this customer when sending or copying to clipboard.",
  emailenviado: "Email Sent",

  // ListadomateriaPrima-Proveedor
  // 14/01/25
  verListado: "Raw material list",
  listadoMateriaPrimaProveedor: "Raw material list by supplier",
  noTiene: "Does not have ",
  esteProveedor: " this supplier",
  precioAcordado: "Agreed price with supplier",
  porcentajeAcordado: "Agreed percentage",
  filtrarPorEtiqueta: "Filter by tag: ",
  precioAcordadoGuardadoCorrectamente: "Price set. Saved successfully!",
  fijarprecio: "Set price",
  preciofijado: "(Set raw material price)",
  mensajePrecioFijado: "The raw material price is ",
  explicacionFijarPrecio:
    "When enabled, the raw material price and discount percentage will remain fixed. A new expense will not modify price or discount.",
  porcentajeAcordado: "Notice percentage",
  porcentajeAcoradoGuardado: "Agreed percentage. Saved successfully!",
  losSubproductosSeHanIncrementado:
    "An increase in price was detected for the following raw materials compared to the agreed percentage with the supplier",
  errorverificar: "Error verifying",
  mensajeErrorVerificarTodo:
    "The following expenses detected an increase in raw material price compared to the agreed percentage with the supplier",
  explicacionPorcentajeAcordado:
    "This is the agreed percentage with the supplier, for controlling raw material prices when making an expense.",
  generarBusinessHash: "Generate URL for employees",
  enlaceFicharTurnosOperario: "Access to clock in/out and check shifts",
  enlaceFicharTurnosOperarioDescripcion:
    "Business workers can log in with the same credentials as in the POS to record shift start and end, and consult the last 14 shifts with their times.",

  // KIOSKOS
  kioskos: "Kiosks",
  stockBreak: "Out of stock",
  kiosksMenu: "Kiosks menu",
  barcode: "BARCODE",

  sort: "Sort",
  productSorted: "Product sorted successfully",
  subproductSorted: "Raw material sorted successfully",
  categorySorted: "Category sorted successfully",

  saldoAnterior: "PREV. BALANCE",
  saldoActual: "CURRENT BALANCE",

  // 31/01/2025
  guardarOreplicar:
    "This product exists in a menu. Do you want to save changes to the product or save and replicate them in the menu?",
  guardarYreplicar: "Save and replicate in menu",
  CrearProductoEnCarta: "Save and create product in menu",
  tienesProductosSinActualizar:
    "You have products and/or raw materials in the menu not linked or inactive in the POS",
  porFavorDirijaseADiagnosticoParaActualizar:
    "Please go to Digital Menu > Menu Configuration > Diagnosis > Diagnostics to review pending products and raw materials",
  irAdiagnosis: "Go to Diagnosis",
  realizarDespues: "Do later",
  actualizarProductos: "Remaining to review ",
  activoEnCarta: "Active in menu",
  activoEnTPV: "Active in POS",
  relacionarProducto: "Link menu product with POS",
  editarProductoCarta: "Edit menu product",
  editarProductoTpv: "Edit POS product",
  editarMateriaPrimaCarta: "Edit menu raw material",
  editarMateriaPrimaTpv: "Edit POS raw material",
  sinErroresProductos: "No potential errors found in menu products ",
  sinErroresMateriasPrimas: "No potential errors found in menu raw materials ",

  // Sinqro refactor
  seleccionePrecioAgenciaSinqro: "Agency price you want to synchronize",
  iniciandoImportacion: "Starting import",
  limpiandoSinqro: "Removing Sinqro records",
  obteniendoCategorias: "Fetching categories",
  obteniendoProductos: "Fetching products",
  obteniendoSubproductos: "Fetching subproducts",
  sincronizandoConSinqro: "Synchronizing with Sinqro",
  finalizandoSincro: "Finalizing synchronization",
  errorSincronizacion: "Error synchronizing with Sinqro",
  estamosTrabajandoEnEllo: "We are working on it, please wait...",
  creandoCategoriasSinqro: "Creating categories in Sinqro",
  errorSincronizacionPruebeOtraVez:
    "Error synchronizing with Sinqro. Please try again.",
  losentimos: "We are sorry!",
  estamosPreparandoTuCarta: "Preparing your menu",
  borrandoCartasObsoletas: "Deleting obsolete menus",
  creandoCarta: "Creating menu in Sinqro",
  ultimoPasoCasiTerminado: "Last step, almost finished",

  exportarPdfSinDesglose: "Export as PDF (No breakdown)",
  exportarPdfConDesglose: "Export as PDF (With breakdown)",
  exportarExcelSinDesglose: "Export as Excel (No breakdown)",
  exportarExcelConDesglose: "Export as Excel (With breakdown)",

  // 14/07/2025
  replicarPLUs: "Replicate PLUs",
  pluReplicadosExitosamente: "PLUs replicated successfully",
  replicarPLUPRod: "Replicate product PLUs in POSs",
  replicarPLUSubPRod: "Replicate raw material PLUs in POSs",
  replicarPLUsaBusinesses: "Replicate product PLUs across businesses",
  replicarPLUaBusinesses: "Replicate raw material PLUs across businesses",
  noSeActualizoNingunProducto: "No product was updated",
  productosActualizadosCorrectamente: "Product updated successfully",

  importarExcelTarjetas: "Import Excel Cards",
  importarTarjetas: "Import Cards",
  editarTarjeta: "Edit Card",
  previewTarjetasData: "Preview Cards Data",

  estaSeguroPLU: "Are you sure you want to replicate the PLU?",
  conEstaAcciónPLU:
    "With this action, the PLU will be replicated in all selected businesses.",

  porDiaNatural: "by natural day",
  actualizados: "Updated",
  conErrores: "With Errors",
  estasSeguro: "Are you sure?",
  conEstaAccionPLUTpvs:
    "With this action, the PLU will be replicated in all POSs related to this business",
  advertenciaPLUTexto1Prod:
    "This PLU replication process between businesses uses the product name as reference.",
  advertenciaPLUTexto2Prod:
    "If there are duplicate product names, this process cannot be executed for them.",
  advertenciaSubPLUTexto1:
    "This raw material PLU replication process uses the raw material name as reference.",
  advertenciaSubPLUTexto2:
    "If there are duplicate raw material names, this process cannot be executed for them.",

  advertenciaPLUsDuplicadosProductos:
    "⚠️ PLUs of products with duplicate names could not be replicated because the name is used as reference in this process.",
  advertenciaPLUsDuplicadosSubproductos:
    "⚠️ PLUs of raw materials with duplicate names could not be replicated because the name is used as reference in this process.",

  productosActualizadosResumen: "Updated Products",
  productosNoEncontradosResumen: "Products Not Found",
  productosSinCambiosResumen: "Products Unchanged",

  subproductosActualizadosResumen: "Updated Raw Materials",
  subproductosNoEncontradosResumen: "Raw Materials Not Found",
  subproductosSinCambiosResumen: "Raw Materials Unchanged",

  seRepite: "repeats",

  ordenarProductosAlfabeticamenteDesc:
    "Sort products alphabetically in ascending order.",
  ordenarMateriasPrimasAlfabeticamenteDesc:
    "Sort raw materials alphabetically in ascending order.",
  configurarFechaCaducidadFacturas: "QR INVOICE Expiration Date",
  configurarFechaCaducidadFacturasDesc:
    "Set the time customers have to pay their QR INVOICES before they expire.",
  configurarLogoNegocioDesc:
    "Set the business logo that will appear on invoices.",
  cambiarPreciosAProductosDesc: "Change product prices in bulk.",
  calcularCostoProductos: "Product Cost",
  calcularCostoProductosDesc: "Calculate the cost of products by POS.",
  gestionAvanzadaHerramientas: "Advanced Tool Management",
  gestionAvanzadaHerramientasDesc:
    "Advanced configuration of printers, categories, and kitchen monitor for your business.",
  hora: "Time",
  cancelaciones: "Cancellations",
  totalNeto: "Net Total",
  identificadorPostit: "Post-it Identifier",

  // VentasNegocios internationalization
  totalMesasPostit: "Total Post-it Tables",
  noHayVentasDisponibles: "No sales available for the selected floor plan",
  intentaSeleccionarOtroPlano:
    "Try selecting another floor plan or check the data for the selected period",
  loSentimos: "We're sorry",
  esteNegocioNoCuentaConModulo:
    "This business does not have this module activated",
  mesasDePostit: "Post-it Tables",
  totalConsolidado: "Consolidated Total",
  totalMesa: "Table Total",
  pagosaldo: "Balance Payment",
  desgloseVentasPorMesasHoras: "Sales Breakdown by Tables and Hours",

  configurar: "Configure",
  configurarLogoFacturas: "Invoice Logo",
  configurarFechaDeVencimientoDeFacturas: "Configure Invoice Due Date",
  introduzcaElNumeroDeDiasEnElQueVenceranLasFacturas:
    "Enter the number of days until the invoices are due.",
  datoInformativo:
    "This date is informative for the customer and does not affect the system.",
  calcularCostoDeTodosLosProductos: "Calculate cost of all products",

  // Business Central
  summary: "Product Downgrade Summary",
  productDowngrades: "Product downgrades found",
  subproductDowngrades: "Raw material downgrades found",
  totalDowngrades: "Total downgrades",
  totalAffectedRecipes: "Total affected recipes",
  downgradedProducts: "Downgraded Products",
  downgradedSubproducts: "Downgraded Raw Materials",
  noRecipesAffected: "No recipes affected",

  actualizar: "Update",
  crear: "Create",
  terminar: "Finish",

  departamentosSeleccionados: "Selected Departments",

  seleccionarProducto: "Select\nproduct",
  seleccionarDepartamentos: "Select\ndepartments",
  completarCampos: "Complete\nfields",
  asignarMateriasPrimas: "Raw\nMaterials",
  seleccionaMateriasPrimasBusinessCentralAlertInfo:
    "This is the list of sellable raw materials from Business Central pending creation or update in Numier. Select a raw material from the list to continue. <strong>You have {PRODUCT_LIST_LENGTH} pending raw materials.</strong>",
  seleccionaProductosBusinessCentralAlertInfo:
    "This is the list of products from Business Central pending creation or update in Numier. Select a product from the list to continue. <strong>You have {PRODUCT_LIST_LENGTH} pending products.</strong>",
  seleccionaDepartamentosBusinessCentralAlertInfo:
    "<strong>Where should the product {PRODUCT_NAME} be available?</strong> Select the departments where you want {PRODUCT_NAME} to be available.",
  completarCamposProductosBusinessCentralAlertInfo:
    "Next, <strong>complete the fields and prices</strong> for {PRODUCT_NAME}.",
  asignarMateriasPrimasProductosBusinessCentralAlertInfo:
    "The following raw materials have been detected for <strong>{PRODUCT_NAME}</strong>. They will be automatically added to the product once the process is completed.",
  estasMateriasPrimasSeAnadiranAlProducto:
    "The following raw materials have been detected for <strong>{PRODUCT_NAME}</strong>. They will be automatically added to the product once the process is completed.",
  completarTarifasBusinessCentralAlertInfo:
    "<strong>{PRODUCT_NAME} may have different categories, VAT, and prices depending on the department</strong>. For example, a price of €2.50 for Rate 1 in Department 1 and €3.00 in Department 2. If the 'replicate values' checkbox is checked and a value is entered, it will fill the entire column with that value.",
  CategoriayTarifasPorDepartamento: "Category, VAT, and Rates per department",
  replicarValoresTarifasEnTodaLaColumnaCheckbox:
    "Replicate rate values across the column",
  sincronizado: "synchronized",
  swalSalirFromProductosBusinessCentralTitle: "Before continuing...",
  swalSalirFromProductosBusinessCentralText:
    "If you leave now, you will lose your current progress.",
  swalSalirFromProductosBusinessCentralButtonConfirm: "Yes, leave",
  swalCamposObligatoriosFromProductosBusinessCentralText:
    "You must complete all fields marked with *",
  swalNombreProductoObligatorioFromProductosBusinessCentralText: "Product name",
  swalColorObligatorioFromProductosBusinessCentralText: "Button color",
  swalCategoriaObligatorioFromProductosBusinessCentralText:
    "Category in each department",
  swalTipoIvaObligatorioFromProductosBusinessCentralText:
    "VAT in each department",
  noPuedenCoincidirLosValoresDeLosCodigosDeBarrasEntreDiferentesFormatos:
    "The values of the barcodes between different formats cannot match.",
  yaExisteUnProductoConEseCodigoDeBarras:
    "A product with this barcode already exists.",

  swalProductoSincronizadoTitle: "Product synchronized!",
  swalProductoSincronizadoTextNPendientes:
    "Do you want to continue synchronizing products or finish for now?",
  swalProductoSincronizadoText0Pendientes:
    "All products have been synchronized.",
  swalProductoSincronizadoButtonSeguir: "Continue synchronizing",
  swalProductoSincronizadoButtonTerminar: "Finish",
  swalProductoActualizadoTitle: "Product updated!",
  swalProductoActualizadoText0Pendientes: "All products have been updated.",
  swalSuplementoTarifa1ObligatoriaFromProductosBusinessCentralText:
    'Missing SUPPLEMENT price (Rate 1) in department/POS "{tpv}".',

  modalUnidadesMedidaTitle: "ℹ️ IMPORTANT",
  modalUnidadesMedidaTextIntro:
    "{PRODUCT_NAME} has {UD_COUNT} units of measure in Business Central ({UD_LIST}). There are 2 options:",
  modalUnidadesMedidaOpcionMultiples:
    "🔹 Create {UD_COUNT} products → Ideal if they are different raw materials (e.g., Water BOT500ML and Water BOT1L are different raw materials).",
  modalUnidadesMedidaOpcionUnico:
    "🔹 Create 1 product and use up to 4 rates → Best if it's the same raw material with different quantities (e.g., use 'Tapa' and 'Ración' rates for Ensaladilla).",
  modalUnidadesMedidaRecomendacion:
    "Recommendation: If it's the same base (e.g., Ensaladilla in different quantities), use 1 product. If they are different raw materials, create {UD_COUNT} products.",
  modalUnidadesMedidaButtonMultiples: "Create {UD_COUNT} products",
  modalUnidadesMedidaButtonUnico: "Create 1 product",

  modalConfirmarDatosTitle: "ℹ️ CONFIRM PRODUCT DATA",
  modalConfirmarDatosIntro:
    "{PRODUCT_NAME} was previously synchronized and saved in Numier but has been modified in Business Central.",
  modalConfirmarDatosExplicacion:
    "Next, we will load the data we have in Numier for this product so you can confirm and click continue if correct.",
  continuar: "Continue",

  cargandoListaProductos: "Loading product list...",
  seHaDetectadoCambioUdmEsNecesarioActualizarPorFormato: "A change in units of measure has been detected. It is necessary to update prices by format for this new unit of measure.",
  productoYaCreadoMateriasPrimasIguales: "The product already exists in Numier, so the raw materials will be the same.",
  seHanDetectadoMasUdmQueSoportaNumierSeCrearanProductosIndividuales: "More units of measure have been detected in Business Central than those supported by Numier. Individual products will be created for each unit of measure.",
  error: "Error",
  serverError: "There was a problem communicating with the server",
  errorRecetasBC: "Could not fetch recipes from Business Central.",
  erroresAddTipoMateriaPrima: "You must select the type for each raw material.",
  erroresAddTodasMateriasPrimas: "You must add all raw materials",
  redirigidoIntegracionesBC:
    "You have been redirected to the starting point to confirm the selected company is correct.",
  redirigidoFaltanDatos:
    "You were redirected because required data was missing.",
  unknownProduct: "Unknown product",

  // BussinessCentral MateriasPrimas
  nombreMateriaPrima: "Raw Material Name",
  descripcion: "Description",
  codigoDeBarra: "Barcode",
  seleccionaCategoria: "Select Category",
  seleccionaTipo: "Select Type",
  precioCompraSinIva: "Purchase Price (without VAT)",
  baja: "Inactive",
  escandallo: "Recipe",
  quieresSeguirSincronizando: "Do you want to continue syncing?",
  seguirSincronizando: "Continue syncing",
  seleccionar: "Select",
  materiaPrimaGuardada: "Raw material saved!",
  seleccionarMateriaPrima: "Select\nraw material",
  completarCamposMateriaPrima: "Complete\nfields and assign\nraw materials",
  queQuieresHacerAhora: "Do you want to continue syncing raw materials?",
  seguirEditando: "Continue editing",
  materiaPrimaSincronizadaCorrectamente:
    "Raw material synchronized successfully",
  estaMateriaPrimaTieneMateriasPrimasRelacionadasAlertInfo:
    "The raw material <strong>{MATERIA_PRIMA_NAME}</strong> has other associated raw materials. Add them to complete synchronization.",
  finalizar: "Finish",
  seleccionaLosDepartamentos: "Select the departments",
  noHayEtiquetasTPV: "No tags for this POS",
  aniadir: "Add",
  aniadirTodas: "Add all",
  listo: "ready",
  errorDesconocido: "Unknown error",
  nombreMateriaPrimaObligatorio: "The raw material name is required.",
  submateriasPrimasObligatorio: "You must add all the sub-raw materials.",

  actualizacionMateriaPrima: "Raw Material Update",
  mensajeCambioMateriaPrimaInfo:
    "Changes have been detected in this raw material from Business Central.",
  antesContinuarMateriaPrimaInfo:
    "Before continuing, check the departments where this raw material should be available in case of changes.",
  accionNecesariaMateriaPrimaInfo:
    "This action is necessary to keep the information updated correctly.",
  entendido: "Understood",
  noVolverAMostrarEsteAviso: "Don't show this notice again",
  cerrarYNoVolverAMostrar: "Close and don't show again",
  preferenciasGuardadas: "Preferences saved successfully",
  errorAlGuardarPreferencias: "Error saving preferences",
  seleccioneCategoria: "Select category...",

  // Formulario combinado de productos
  precioRequerido: "Price required",
  introduzcaPrecio: "Enter the supplement price",
  errorValidandoCodigosBarras: "Error validating barcodes",
  asignaPreciosMateriasPrimas: "Assign prices to raw materials",
  rateNameRequired: "It is mandatory to indicate the rate name no.: ",
  categoryRequiredForDept: "It is mandatory to select a category for the department: ",
  validationError: "Field validation error",
  pleaseFillRequiredFields: "Please fill in all required fields.",
  configuracionPorDepartamento: "Configuration by department",
  productoNormal: "Normal Product",
  productoCON: "WITH Product",
  productoSUPL: "SUPPL Product",
  esProductoCON: "Is WITH Product",
  esProductoSUPL: "Is SUPPL Product",
  categoriaNormal: "Normal",
  categoriaCON: "WITH",
  categoriaSUPL: "SUPPL",
  suplemento: "SUPPLEMENT",
  mensajeProductoCON:
    "You are creating a WITH product. 2 products will be generated: one normal and one WITH.",
  mensajeProductoSUPL:
    "You are creating a SUPPL product. 2 products will be generated: one normal and one SUPPL.",
  mensajeProductosCONySUPL:
    "You are creating both WITH and SUPPL products. 3 products will be generated: one normal, one WITH and one SUPPL.",
  completeCamposObligatorios: "Please fill in all required fields.",
  completeNombreProductoCON: "Please enter the name for the WITH product.",
  completeNombreProductoSUPL: "Please enter the name for the SUPPL product.",
  productosGuardadosCorrectamente: "Products have been saved successfully.",
  errorAlGuardarProductos: "An error occurred while saving the products.",

  dataNegocioVisualizar: "Departments",
  formaPagoFiltrado: "Filter by payment method",
  fechaExportacionDisponible: "Detected export date",
  todasLasFormasPago: "All payment methods",
  seleccioneSubtipoFormaPago:
    "Please select a specific payment method (e.g., Visa, Mastercard, or check type).",
  noCambiosFormaPago: "No changes were made in the payment method",
  finalizarProcesoActualizar: "Finish raw material update process",
  actualizarFinalizarText:
    "To complete the process and update the raw material correctly, click the 'Update and finish' button below.",
  cambiosDepartamentosMateriaPrimaInfo:
    "If changes were made in the departments where this raw material should be active—whether to add or remove—it will be applied automatically during update.",
  actualizarFinalizar: "Update and finish",
  verDetallesFormaPago: "View payment method details",
  detallesFormaPago: "Payment method details",
  formaDePago: "Payment method",
  medioDePago: "Payment medium",
  medioPagoFiltrado: "Filter by payment medium",
  advertenciaExportacionVentas: "Sales export warning",
  seExportaranTodosLosDepartamentos:
    "Sales from ALL departments will be exported",
  advertenciaExportacionTodosLosDepartamentos:
    "By continuing, sales from all departments, including their respective payment methods, will be exported, not just the current department.",
  noHayVueltaAtras: "Once exported, this action cannot be undone.",
  reviseYEditeFormasPagoAntes:
    "Check and edit payment methods before proceeding.",
  eleccionModoExportacion: "The export mode only determines whether sales are sent in batches or all together. In all cases, sales from all points of sale will be included.",
  estaSeguroDeExportar: "Are you sure you want to continue with the export?",
  todosLosMediosPago: "All payment media",
  tpv: "POS",
  department: "Department",
  productoEspecialDetectado: "Special product detected",
  productoEspecialDetectadoMensaje: "A special product has been detected.",
  seCrearanTresProductos: "{cantidad} products will be created in Numier: one normal, one WITH and one SUPPLEMENT.",
  seCrearanDosProductosCon: "{cantidad} products will be created in Numier: one normal and one WITH.",
  seCrearanDosProductosSuplemento: "{cantidad} products will be created in Numier: one normal and one SUPPLEMENT.",
  relleneFormularios: "Please fill in the corresponding forms below.",
  categoriaEnlazada: "Linked category",
  dadoDeBaja: "Inactive",
  refrescar: "Refresh",
  errorAlRefrescar: "The data could not be refreshed. Please try again.",
  sinPermisoExportacionBC: "You do not have permission to access the Business Central sales export. Contact your administrator.",
  productoDeBajaTitulo: "Inactive product",
  productoDeBajaTexto: "This product is inactive and cannot be added as a menu dish. Activate it in Business Central and sync again: Numier will reactivate it on the next synchronization.",
  categoriaFijadaPorTipo: "Set by the {TIPO} type",
  categoriaFijadaPorTipoAviso: "The category cannot be chosen: a {TIPO} is always created in the category it has in the source business. If it does not exist in the target, it is created.",
  sinNegociosParaReplicar: "There are no other businesses available to replicate this product.",
  negocioSinCategorias: "No categories created",
  resultadoReplicacion: "Replication result",
  replicados: "Replicated",
  replicaFamiliaAviso: "This product is part of a family. The following will be replicated:",
  replicaTipoDetectado: "Detected product type:",
  productosPorNegocio: "products per business",
  faltaCategoriaEnNegocios: "Select a category for these businesses:",
  seleccionaAlMenosUnNegocio: "Select at least one business.",
  seleccionaPreviamenteCategoria: "Please select a category first.",

  // Producto solo con/suplemento
  crearProductoSinNormal: "Create normal product as inactive",
  crearProductoSinNormalExplicacion: "If you enable this option, the normal product will be created but with 'inactive' status. This is useful when the product only makes sense to sell as WITH or SUPPLEMENT, since it won't be sold as an individual product by itself. It will only be visible in the POS if you activate it manually.",
  crearProductoSinNormalDetalle: "The normal product will always be created, but with this option enabled it will appear disabled. The products WITH and SUPPLEMENT will be active for immediate use.",
  crearProductoSinNormalImportante: "IMPORTANT: You must select a category before checking this box, as it's required to maintain data integrity even if the product is inactive.",
  productoNormalOculto: "Normal product hidden",
  productoNormalOcultoExplicacion: "This form is hidden because the normal product will be created as inactive",
  activarProducto: "Activate product",

  // Business Central - Exportación de ventas
  exportacionVentasBC: "Export sales",
  noHayDiasParaExportar: "No days to export",
  dailyExportCardTitle: "Daily sales export",
  dailyExportCardSubtitle: "Review sales and export to Business Central",
  todoExportadoCorrectamente:
    "All sales have been exported successfully or there are no sales for this department.",
  hayVentasPendientesExportar: "There are sales pending export.",
  debesExportarPrimeroDiasAnteriores:
    "You must first export previous days to maintain sequence.",
  fechaExportacion: "Export date",
  formapago: "Payment method",
  noPuedeCambiarFechaSinExportarPrimero:
    "Cannot export a new date without first exporting the oldest pending day.",
  trabajador: "Employee",
  exportData: "Export sales",
  exportacionExitosa: "Export completed successfully",
  errorExportarDatos: "Error exporting data",
  falloExportarDatos: "Failed to export data",
  exportacionRealizada: "Export completed",
  exportacionRealizadaParcial: "Export completed partially",
  exportacionExitosaConErrores: "Export completed successfully with some errors",
  editarFormaPago: "Edit payment method",
  noExistenDatosNoPudieronCargar: "No data exists or could not be loaded",
  mensajeEfectivoSeleccionado:
    "Cash selected as payment method. No further details needed.",
  guardarFormaPago: "Save payment method",
  tipoFormaPago: "Payment type",
  seleccioneUnTipo: "Select a type",
  formaPagoTarjeta: "Card payment",
  formaPagoCheque: "Check payment",
  updatePagoCorrecto: "Payment method updated successfully",
  noSePudoActualizarFormaPago: "Could not update payment method",
  errorAlGuardarFormaPago: "Error saving payment method",
  noHayVentasConEstaFormaPago: "No sales with this payment method",
  formaPagoNoEncontrada: "Payment method not found for this department",
  totalCash: "Total cash",
  totalCard: "Total card",
  totalCheque: "Total check",
  totalPagosaldo: "Total balance payment",
  totalAvanzado: "Total advanced",
  avanzadoEfectivo: "Advanced cash",
  avanzadoTarjeta: "Advanced card",
  avanzadoCheque: "Advanced check",
  avanzadoPagosaldo: "Advanced balance payment",
  avanzadoOtros: "Advanced others",
  cashPaymentMethod: "Cash payment method",
  cardPaymentMethod: "Card payment method",
  chequePaymentMethod: "Check payment method",
  importeTotal: "Total amount",
  sinDatos: "NO DATA",

  // Integración Business Central > Business Central
  businessCentral: "Business Central",
  sincronizacionBusinessCentralSubtitle:
    "Real-time synchronization of products, departments, and more",
  sincronizaMateriasPrimasBusinessCentralSubtitle:
    "You have <strong>{MATERIAS_PRIMAS_LENGTH}</strong> raw materials pending update",
  noHayParaActualizar: "There is nothing pending to update or synchronize",
  obteniendoDatos: "Loading data...",
  relacionesProcesadas: "Relationships processed",
  exportacionDeshabilitada: "Export disabled",
  sincronizaProductosBusinessCentralSubtitle:
    "You have <strong>{NUMERO_PRODUCTOS_PENDIENTES}</strong> products pending synchronization",
  sincronizaFormasDePagoBusinessCentralSubtitle:
    "You have <strong>{NUMERO_FORMAS_PAGO_PENDIENTES}</strong> payment methods pending synchronization",
  productoFormCompleto: {
    info: "Editing product: {productName}",
  },
  completaProductosBussinessCentralSubtitle:
    "Complete raw materials synchronization first to start with products",

  seleccionaMateriaPrimaBusinessCentralAlertInfo:
    "This is the list of raw materials in Business Central pending creation or update in Numier. Select the raw material to continue. <strong>You have {PRODUCT_LIST_LENGTH} pending raw materials.</strong>",
  seleccionaDepartamentosMateriasPrimasBusinessCentralAlertInfo:
    "<strong>Where should the raw material {PRODUCT_NAME} be available?</strong> Select the departments where {PRODUCT_NAME} should be available.",
  completarCamposMateriasPrimasBusinessCentralAlertInfo:
    "To finish, complete the fields for {PRODUCT_NAME}.",
  materiaPrimaDisabledByPendingsChildrenTooltip:
    "This raw material is a recipe whose ingredients are still pending synchronization.",

  swalMateriaPrimaSincronizadaTitle: "Raw material synchronized!",
  swalMateriaPrimaSincronizadaTextNPendientes:
    "Do you want to continue synchronizing raw materials or finish for now?",
  swalMateriaPrimaSincronizadaText0Pendientes:
    "All raw materials have been synchronized.",
  swalMateriaPrimaSincronizadaButtonSeguir: "Continue synchronizing",
  swalMateriaPrimaActualizadaTitle: "Raw material updated!",
  swalMateriaPrimaActualizadaText0Pendientes:
    "All raw materials have been updated.",

  // Integración Business Central > Empty entidades pendientes
  esteNegocioNoTieneProductosParaSincronizar: "All products synchronized",

  // Integración Business Central > Formas de pago
  formasDePagoBC: "Payment methods",
  swalTipoObligatorioFormasDePago:
    "You must select a type for each payment method before finishing.",
  formasDePagoBusinessCentralAlertInfo:
    "Link Business Central payment methods with Numier types: Cash, Card, or Check. <strong>Only one type can be selected as Cash; the rest as Card and Check.</strong>",
  noHayFormasDePagoPorConfigurar: "No payment methods pending configuration.",
  formasDePagoConfiguradasCorrectamente:
    "All payment methods have been set correctly.",
  formaPagoGuardada: "Payment methods saved!",
  todasFormasPagoConfiguradas: "All payment methods have been configured",
  formasPagoDarDeBajaMensaje:
    "The following payment methods must be deactivated in Numier because they are no longer available in the Business Central system",
  pulsaDarDeBaja: "Click deactivate to confirm",
  darDeBaja: "Deactivate",
  dandoDeBajaFormasPago: "Deactivating payment methods...",
  formasPagoDadasDeBaja: "Payment methods deactivated successfully.",
  errorDarDeBajaFormasPago: "Error deactivating payment methods.",
  errorServidorDarDeBaja:
    "Error communicating with the server while deactivating.",

  // Verifactu Dashboard
  verifactu: "VERI*FACTU",
  verifactu2: "Verifactu",
  declaracionesResponsables: "Responsible declarations",
  conectaNumierConHacienda: "Connect Numier with the Tax Agency in just a few clicks.",
  solicitar: "Request",
  esperandoRespuestaNumier: "Waiting for Numier response",
  seleccionarCertificado: "Select certificate.",
  enviarCertificado: "Send certificate.",
  subeTuCertificadoParaConectarConHacienda: "Upload your certificate to connect your business with the Tax Agency.",
  seleccionarArchivo: "Select file.",
  ustedYaHaGuardadoElCertificadoDigital: "You have already successfully saved the digital certificate for this business.",

  paraComenzarVerifactuSeleccionaNegocio: "To start with VERI*FACTU, please <strong>select a business</strong> from the dropdown below.",
  bienvenidoA: "Welcome to",
  verifactuDescripcion: "<strong>Verifactu</strong> is the system of the Spanish Tax Agency (AEAT) that allows automatic invoice verification, ensuring authenticity and integrity before the Tax Authority.",
  informacionSobreVerifactu: "Information about VERI*FACTU",

  importanteEmpresasSII: "Important: Companies under SII",
  siTuEmpresaEstaAdscritaSII: "If your company is registered under the Immediate Supply of Information (SII) system, you are exempt from using VERI*FACTU.",
  masInformacionAqui: "More information here",

  automatizacionInteligente: "Smart Automation",
  automatizacionInteligenteDesc: "Automatic invoice verification without manual intervention. The system processes and validates each document instantly.",
  automatizacionInteligenteDetalle: "Save up to 8 hours of manual work per week",
  automatizacionInteligenteStat: "100% Automatic",

  cumplimientoNormativo: "Regulatory Compliance",
  cumplimientoNormativoDesc: "Full compliance with tax regulations. Automatic updates according to legislative changes.",
  cumplimientoNormativoDetalle: "Compatible with all current AEAT regulations",
  cumplimientoNormativoStat: "AEAT Compliant",

  controlDeCalidad: "Quality Control",
  controlDeCalidadDesc: "Eliminate human errors and prevent fraud through advanced data validation.",
  controlDeCalidadDetalle: "Automatic detection of inconsistencies and anomalies",
  controlDeCalidadStat: "-95% Errors",

  seguridadAvanzada: "Advanced Security",
  seguridadAvanzadaDesc: "Maximum protection in all your transactions with bank-level encryption.",
  seguridadAvanzadaDetalle: "SSL certificates and two-factor authentication",
  seguridadAvanzadaStat: "SSL Encryption",

  configuracionDeVerifactu: "Verifactu Configuration",
  paraComenzarNecesitasCertificado: "To start working with VERI*FACTU, you need to upload your <strong>digital certificate.</strong>",
  certificadoPermiteAutenticacion: "This certificate allows secure authentication with AEAT.",
  formatosSoportados: "Supported formats: <code>.pfx</code>, <code>.p12</code>.",
  aunNoTienesCertificado: "Don’t have a digital certificate yet?",
  puedesObtenerCertificadoEn: "You can obtain your digital certificate at:",
  fabricaNacionalMonedaTimbre: "Spanish Royal Mint (FNMT)",
  yaTienesCertificadoListo: "Already have your digital certificate ready?",
  hazClickAbrirSelector: "Click here to open the file selector.",
  tengoUnCertificado: "I have a certificate",
  hazClickSeleccionarCertificado: "Click and select your certificate",
  formatosMaximo: "Formats: .pfx, .p12 (max. 60KB)",
  subirCertificado: "Upload certificate",
  debeSeleccionarFechaInicioVerifactu: "You must select a start date for VERI*FACTU before continuing.",
  porFavorSeleccionaFechaInicioNuevamente: "An error has occurred. Please select the start date again.",
  porFavorSeleccionaCertificadoNuevamente: "Please select the certificate again.",

  certificadoConfiguradoCorrectamente: "Certificate Configured Successfully!",
  certificadoValidadoConfigurado: "Your digital certificate has been validated and configured.",
  certificadoValidoHasta: "Certificate valid until",
  noSeHaPodidoVerificarFecha: "Could not verify the certificate validity date",
  facturasComplianNormativa: "Your invoices will comply with VERI*FACTU regulations.",
  sistemaListoVerificacion: "System ready for automatic verification.",
  comoFuncionaVerifactu: "How does VERI*FACTU work?",

  generacionAutomatica: "Automatic Generation",
  generacionAutomaticaDesc: "Invoices will be automatically generated following VERI*FACTU format and requirements",

  codigoQRenTickets: "QR Code on Tickets",
  codigoQRenTicketsDesc: "Each receipt will include a QR code to verify the invoice on AEAT’s website",

  comprobacionInstantanea: "Instant Verification",
  comprobacionInstantaneaDesc: "The status of each invoice can be verified by scanning the QR from any device",

  seguridadGarantizada: "Guaranteed Security",
  seguridadGarantizadaDesc: "All transactions are recorded and protected with advanced electronic signature",

  contrasenaCertificado: "Certificate Password",
  introduceContrasenaDesc: "Please enter your digital certificate password to process it correctly.",
  contrasena: "Password:",
  introduceContrasenaPlaceholder: "Enter the certificate password",
  contrasenaRequerida: "Password is required",
  procesando: "Processing…",
  continuar: "Continue",
  cancelar: "Cancel",

  exito: "Success",
  seleccionaArchivoAntes: "Please select a file before sending.",
  errorNegocioNoValido: "Error: No valid business selected.",

  // Textos para negocio exento
  negocioExentoVerifactu: "VERI*FACTU Exempt Business",
  negocioRegistradoComoExento: "This business is registered as exempt from VERI*FACTU.",
  noRequiereVerifactu: "Does not require certificate or additional configuration.",
  facturacionNormalContinua: "Your billing will continue to operate normally.",
  queSignificaExento: "What does this mean?",
  queSignificaExentoDesc: "Your business is not required to comply with VERI*FACTU requirements. This may be because it is registered under the SII system or meets other exemption criteria set by tax regulations.",
  siHayAlgunError: "Was there an error?",
  siHayAlgunErrorDesc: "If you believe this classification is incorrect or encountered a problem, please contact our support team for assistance.",
  noSePudoObtenerIdUsuario: "User ID could not be retrieved.",
  verificandoCertificado: "Verifying certificate...",
  certificadoEnviadoCorrectamente: "Certificate sent successfully",
  respuestaInesperadaServidor: "Unexpected server response",

  verifactuError449: "Incorrect password or invalid file.",
  verifactuError552: "An unexpected error occurred. Please try again.",
  errorAlEnviarCertificado: "Error sending certificate",
  noSeRecibioRespuestaServidor: "No response received from server",
  errorDeConfiguracion: "Configuration error:",
  noSeSeleccionoArchivo: "No file selected.",
  formatoArchivoNoValido: "Invalid file format. Use .pfx or .p12",
  archivoDemasiadoGrande: "File is too large. Maximum allowed size: 60KB",

  // Selector de fecha de inicio Verifactu
  cuandoDebeComenzarTuNegocio: "When should your business start with VERI*FACTU?",
  antesDeConfigurarDebesIndicar: "Before configuring VERI*FACTU, you must indicate the mandatory start date according to your business type.",
  consultarInformacionOficial: "Check official information",
  paraContribuyentesSociedades: "For Corporate Taxpayers",
  restoNegociosAutonomos: "Other businesses and freelancers. To facilitate adaptation to the new system.",
  miNegocioAdscritoSII: "My business is registered in the Immediate Information System",
  estoyExentoSII: "I’m exempt (SII)",
  seleccionar: "Select",
  fechaInicioSeleccionada: "Selected start date",
  exentoSII: "Exempt (SII)",
  cambiar: "Change",
  negocioExentoVerifactu: "VERI*FACTU Exempt Business",
  tuNegocioNoRequiereVerifactu: "Your business does not require VERI*FACTU configuration as it is under the SII system.",
  alEstarEnSIINoNecesitas: "Since you are in SII, you don’t need to implement VERI*FACTU",
  confirmacionExencionSII: "SII Exemption Confirmation",
  antesDeConfirmar: "Before confirming, make sure that:",
  miNegocioEstaAdscritoSistemaInmediato: "My business is registered in the Immediate Information System (SII)",
  tengoDocumentacionQueLoAcredita: "I have documentation that proves it",
  entiendoQueNoDebereUsarVerifactu: "I understand that I should not use VERI*FACTU if I am under SII",
  siNoEstasSegurotConsultaAsesor: "If you’re not sure, consult your tax advisor",
  confirmarExencion: "Confirm exemption",
  negocioMarcadoComoExento: "Business marked as VERI*FACTU exempt",
  errorAlMarcarExencion: "An error occurred while marking the exemption. Please try again later.",

  certificadoExpiradoAlerta: "<strong>Attention:</strong> The digital certificate for this business has <strong>expired</strong>. You must renew it urgently to maintain VERI*FACTU compliance.",
  certificadoProximoExpirarAlerta: "<strong>Warning:</strong> The digital certificate for this business is <strong>about to expire</strong>. We recommend renewing it soon to avoid interruptions.",
  certificadoExpirado: "Expired Certificate",
  certificadoProximoExpirar: "Certificate About to Expire",
  certificadoExpiroEl: "The certificate expired on",
  certificadoExpiraEl: "The certificate expires on",
  certificadoYaNoValido: "The digital certificate is no longer valid. It must be renewed urgently.",
  certificadoProntoVencera: "The digital certificate will expire soon. Renewal is recommended as soon as possible.",
  sinCertificadoNoEsPosibleVerificar: "Without a valid certificate, automatic invoice verification is not possible.",
  EsperarAExpiracionPuedeProvocarErrores: "Failure to renew on time may cause errors in automatic verification.",
  pongaseEnContactoConSoporteParaProceder: "If any error occurs, please contact support for guidance on how to proceed.",
  renovarCertificado: "Renew your Certificate",

  // unidades de medida dadas de baja
  unidadesMedidaDadasDeBaja: "Product deactivations found",
  bajasDeProductos: "Product deactivations",

  // 21/05/2025 - Listado productos por operario
  listadoDeProductosPorOperario: "Product sales by operator",
  listadoProductosOperario: "Sales by operator",

  // 29/10/2025 - Bajas
  bajaEntidades: "Entity deactivations",
  checkBajaEntidades: "View and apply deletions of deleted entities in Business Central",

  bajaProductos: "Product deactivations",
  bajaSubproductos: "Raw material deactivations",
  bajaFormasPago: "Payment method deactivations",
  bajaUdMedida: "Unit of measure deactivations",
  bajaLineaProd: "Product line deactivations",

  checkBajaProductos: "View product deactivations",
  checkBajaSubproductos: "View raw material deactivations",
  checkBajaFormasPago: "View payment method deactivations",
  checkBajaUdMedida: "View unit of measure deactivations",
  checkBajaLineaProd: "View product line deactivations",

  loadingBajaProductos: "Fetching product deactivations...",
  loadingBajaSubproductos: "Fetching raw material deactivations...",
  loadingBajaFormasPago: "Fetching payment method deactivations...",
  loadingBajaUdMedida: "Fetching unit of measure deactivations...",
  loadingBajaLineaProd: "Fetching product line deactivations...",

  emptyBajaUdMedida: "No deactivated units of measure found.",
  errorUnidadMedidaNoConfigurada: "Product cannot be created because it has no unit of measure configured from Business Central.",
  errorUnidadMedidaMateriasPrimas: "The following raw materials do not have unit of measure configured from Business Central",

  configurarVerifactuUrgente: "Numier TPV is already certified with VERI*FACTU",
  debesConfigurarVerifactuAntes15Nov: "We have everything ready to connect your business with <span><i>VERI*FACTU</i></span>.<br />To do so, we only need you to upload your <strong>digital certificate in each of your businesses</strong>, so that when the time comes we will have your version updated to the new <strong>mandatory AEAT regulation</strong>.<br />If you need more information, visit our <i><a href='#/novedades' style='color: #1E22AA; text-decoration: underline; font-weight: 600;'>News</a></i>.",
  subirCertificadoVerifactu: "Upload certificate <i class='fas fa-file-upload ml-1'></i>",
  verNovedades: "View News",
  verifactuAplazadoTitulo: "VERI*FACTU postponed until 2027",
  verifactuAplazadoMensaje: "Due to the <strong><a style='text-decoration: underline; font-weight: 600;' href='https://sede.agenciatributaria.gob.es/Sede/iva/sistemas-informaticos-facturacion-verifactu/nota-informativa-ampliacion-plazo-adaptacion-facturacion.html' target='_blank' rel='noopener noreferrer'>postponement of the VERI*FACTU regulation</a></strong> until 2027, all digital certificates hosted on <b><i>Numier</i></b> servers have been <strong>deleted</strong> for logistical reasons.<br/><br/>The new implementation dates will be:<br/><strong>• January 1, 2027</strong> for taxpayers and companies.<br/><strong>• July 1, 2027</strong> for other businesses and self-employed.<br/><br/>As we approach the new dates, we will communicate any <b>news</b> or <b>important changes</b>.",

  verifactuProximoTitulo: "Get ready for VERI*FACTU 2027",
  verifactuProximoMensaje: "The implementation date for <span><i>VERI*FACTU</i></span> is approaching. In <strong>January</strong> and <strong>July 2027</strong> the new mandatory electronic invoicing regulation will come into effect.<br/><br/>To ensure your business operates correctly, it is essential that you <strong>upload digital certificates</strong> in each of your locations as soon as possible.<br/><br/>If you need help, do not hesitate to <strong>contact support</strong>.",

  errorVariasUdsMedidasProductoConSuplemento:
    "The product cannot be created because the base product has multiple units of measure configured from Business Central.",

  //17/11/25 Diagnostico PLU
  diagnosticoPLU: "PLU Diagnosis",
  todosPluIguales: "All PLUs the same",
  pluDiferentes: "Different PLU",
  noExiste: "Does not exist",
  productoNoDisponible: "Product not found",
  subproductoNoDisponible: "Raw material not found",
  productoNoEncontrado: "Product not found in this business",
  coincide: "Same PLU",
  noCoincide: "Different PLU",
  //12/12/25
  tipoRol: "Role type",
  updatedPaymentMethod: "The following payment methods have been updated:",
  paymentMethodNameChanged: "The name of the payment method has changed from <strong>{oldName}</strong> to <strong>{newName}</strong>.",

  updatedPaymentMethod: "The following payment methods have been updated:",
  noEsProductoValidoParaMutarProductoConSuple: "This product does not meet the requirements to be accepted as a WITH product or a SUPPLEMENT product.",

  paymentMethodDowngrades: "Se han encontrado bajas en formas de pago",
  downgradedPaymentMethods: "Formas de pago dadas de baja",
  unknownPaymentMethod: "Forma de pago desconocida",
  configuracionRol: "(This configuration only applies to Numier SHIFTS)",
  sinIdDeProducto: "Without details",

  addSupplementPriceTitle: "Set supplement price",
  addSupplementPriceText: "It has been detected that the product <strong>{PRODUCT_NAME}</strong> now allows being a supplement, whereas it previously did not. To complete the update, it is necessary to specify the price variation that will be applied when selecting this product as a supplement. This is used to calculate the final product price including the supplement.",
  addSupplementPriceInputLabel: "Price variation: ",
  productComputedInfo: "The selected product has been detected with more than one unit of measure and, at the same time, is of type WITH or SUPPLEMENT, which is not allowed. Therefore, the units of measure will be ignored and a product of type with/supplement will be created. You may continue filling in the form or change it from Business Central.",
  materiaPrimaComputedInfo:
    "The selected sellable raw material has been detected with more than one unit of measure and, at the same time, it is of type CON or SUPPLEMENT, which is not allowed. Therefore, the units of measure will be ignored and a product of type con/supplement will be created. You can continue filling in the form or modify it from Business Central.",

  ocultarDTOInvitaciones: "Hide discounts and complimentary items",

  modalUnidadesMedidaOpcionUnicoMasDeCuatro:
    "⚠️ Attention → It is mandatory to create a separate product for each unit of measure, as the system allows a maximum of 4 price rates per product.",

  exportarPorLotesTPV: "Export by POS batches",
  modoExportacion: "Export mode",
  exportacionNormal: "Normal export",
  exportarDatos: "Export data",
  descripcionExportacionNormal: "Exports all sales together in a single operation",
  descripcionExportacionTPV: "Exports sales grouped by point of sale (POS)",
  importeSinDto: "Amount w/o discount",

  //28/07/26
  actualizandoCartaSinqro: "Updating product catalog in Sinqro...",
  cartaActualizadaSinqro: "Product catalog updated correctly in Sinqro.",

  businessCentralCode: "Business Central code",
  errorCargandoDatos: "Error loading data",
  noSeHaPodidoConsultarIntenteloMasTarde: "Could not query results, please try again later.",
  listaPresentaMateriasPrimasNoSincronizadas: "The list contains raw materials that have not been synchronized with your POS. Please try again later.",

  noTieneProveedor: "No supplier assigned. It will be selected while saving the order.",
  seleccionarProveedorMateriasPrimas: "Select supplier for subproducts",
  lasSiguientesMateriasPrimasNoTienenProveedor: "The following subproducts do not have a supplier assigned. Please select a supplier for each one before saving the order:",
  seleccioneUnProveedor: "Select a supplier",
  guardarYEnviar: "Save and send",
  dividirPedidoEntreProveedores: "Split order between suppliers",
  modalTextMp0: "You have raw materials with units and parts set to 0. Do you want to exclude them from the order?",
  pedidoSinMp: "The order became empty after excluding the raw materials.",
  excluir: "Exclude",

  materiaPrimaNoSincronizada: "This subproduct has not yet been synchronized with your POS",

  noHayProductosAutoEditables: "There are no products that can be synchronized automatically right now",
  confirmarSincronizacionMasivaTitle: "Synchronize all automatic products?",
  confirmarSincronizacionMasivaText: "{COUNT} products will be automatically synchronized without reviewing them one by one. Do you want to continue?",
  siSincronizar: "Yes, synchronize",
  sincronizando: "Synchronizing",
  sincronizacionMasivaCompletadaTitle: "Bulk synchronization completed",
  sincronizadosCorrectamente: "Successfully synchronized",
  // errorDesconocido already exists in this file
  sincronizarTodosAuto: "Synchronize all ({COUNT})",
  sincronizarTodos: "Synchronize all",
  sincronizarTodosAutoTooltip: "Synchronize at once every product whose changes do not require filling in the form.",
  // Business Central sales export: unified table, summaries and warnings
  exportacionPorLotesFija: "The export is sent in POS batches.",
  resumenPorMedioPago: "By payment method",
  resumenPorTpv: "By POS",
  resumenPorTipoDocumento: "By document type",
  documento: "Document",
  verDetalle: "View detail",
  facturaQR: "Invoice generated from a QR order: it does not belong to any cash day",
  rectificaA: "Corrects document",
  socio: "Member",
  variasFormas: "Several methods",
  verDetallesVenta: "View sale details",
  editarMedioPago: "Edit payment method",
  desglosePagos: "Payment breakdown",
  valesRegalo: "Gift vouchers",
  valesDelDocumentoOriginal: "from the corrected document",
  avisos: "Warnings",
  totalDeVenta: "Sales total:",
  ticket: "Receipt",
  rectificativa: "Credit note",
  origenImporteVales: "voucher amount",
  origenImporteValesOriginal: "voucher from the corrected document",
  origenImporteCobrosAvanzados: "advanced payment total",
  seleccioneUnMedioPago: "Select a payment method",
  importesNoEditables: "Amounts cannot be changed from here.",
  buscarClientePorNombreCodigoODni: "Search by name, member code or ID number",
  medioPagoRequiereClienteTexto: "This payment method is charged to a customer, so one must be assigned.",
  medioActual: "Current method",
  detallesVenta: "Sale details",
  tipoDocumento: "Document type",
  dni: "ID / VAT number",
  codigoSocio: "Member code",
  pago: "Payment",
  edicion: "Editing",
  ventaSinCliente: "The sale has no customer assigned.",
  ventaNoEditable: "This sale does not allow changing the payment method.",
  errorCargandoFormasPago: "Payment methods could not be loaded.",
  avisoFacturaSinNombre: "Invoice without customer name",
  avisoFacturaSinDocumento: "Invoice without ID / VAT number",
  avisoSocioSinCodigo: "Member without code: the export will reject it",
  avisoSocioSinCodigoSalesforce: "Member without code: it will be requested from Salesforce on export",
  avisoMedioPagoSinCliente: "Payment method with no customer assigned",
  avisoCuentaCasaClienteGenerico: "House account without customer: it will be exported with the generic house-account customer",
  avisoValeSinRegistro: "Gift voucher with no record in the vouchers table",
  avisoVentaSinImporte: "Sale with no amount: it would travel without any payment",
  avisoRectificativaSinOriginal: "The corrected document cannot be found",
  avisoProductoSinMapeoBC: "Product without integration code",
  avisoProductoSinUnidadMedida: "Product without unit of measure",
  motivoVentaAvanzada: "Advanced payment sale: the amount split is not edited from here.",
  motivoVentaConVale: "Sale paid with a gift voucher: the voucher is already used and recorded.",
  motivoRectificativa: "Credit note: it must be charged the same way as the document it corrects.",
  motivoDestinoVale: "A sale cannot be moved to gift vouchers: the voucher is redeemed at the POS.",
  debeCambiarFormaPagoParaGuardar: "You must change the payment method or the customer before saving.",
  // Exportacion BC: resumen de avisos, filtros y paginacion de la tabla
  evCargandoVentas: "Loading sales pending export...",
  evDocumentosPendientes: "Pending documents",
  evDelDiaDeCaja: "from the cash day",
  evConAvisos: "With warnings",
  evNoSeExportaran: "Will not be exported",
  evSinAvisos: "No warnings",
  evFiltrarPorAviso: "Click a warning to show only those sales in the table.",
  evVerDetalles: "Show details",
  evOcultarDetalles: "Hide details",
  evErrorCargaVentas: "Sales could not be loaded",
  evErrorCargaVentasTexto: "We don't know whether there are pending sales: the request failed. Try again in a few seconds.",
  evYOtros: "and {n} more",
  evBuscarVenta: "Search by document or customer",
  evFiltroTodas: "All",
  evFiltroListas: "Ready to export",
  evFiltroConAvisos: "With warnings",
  evFiltroBloqueantes: "Will not be exported",
  evTodosLosTpv: "All POS",
  evQuitarFiltros: "Clear filters",
  evFiltroAviso: "Warning",
  evSinCoincidencias: "No documents match the filters.",
  evMostrandoRango: "{desde}–{hasta} of {total}",
  evPorPagina: "per page",
  evIrAlDocumento: "Go to document",
  evOriginalYaExportado: "exported",
  evOriginalYaExportadoTexto: "The original document (from {fecha}) has already been exported",
  evRectificadaPor: "Corrected by",
  evNivelBloqueante: "Will not be exported",
  evNivelRevisar: "Review",
  evNivelBloqueanteTexto: "This sale will not be sent: it will stay pending until it is fixed.",
  evNivelRevisarTexto: "The sale is exported, but it should be reviewed.",
  evConNotasInformativas: "With informational notes",
  evCuentasSinCobrar: "Unpaid bills",
  evCuentasSinCobrarTitulo: "Unpaid bills on this cash day",
  evCuentasSinCobrarTexto: "They add up to {importe}. They are not exported while they remain unpaid.",
  evNivelInfo: "Info",
  evNivelInfoTexto: "Informational only: the sale is exported normally.",
  evExportando: "Exporting…",
  evExportandoTexto: "Exporting sales. It may take a few minutes: do not close this page.",
  evExportarUnTpv: "Export one POS",
  evExportarUnTpvDesc: "Exports only the sales of the POS you choose",
  evEligeTpv: "Choose a POS",
  evPrimeraPagina: "First page",
  evUltimaPagina: "Last page",
  evSoloSeExportaraTpv: "Only POS {tpv} will be exported.",
  evQueSeEnviara: "What will be sent",
  evSeEnviaran: "Will be sent",
  evQuedaranPendientes: "They will stay pending until fixed",
  evCifrasDelTpv: "Figures for POS {tpv}.",
  evCifrasDelDepartamento: "Figures for this department; the company's other departments are exported too.",
  evFiltrosNoAfectanExportacion: "Table filters do not affect the export: everything pending is sent.",
  evExportados: "Exported",
  evRechazadosPorBC: "Rejected by BC",
  evOmitidosPorValidacion: "Skipped by BC",
  evResultadoPendientesTexto: "Whatever was not exported stays pending and shows in the table with its warnings.",
  evResultadosExportacion: "Export results",
  evDescargarInformeExcel: "Download Excel",
  evInformeEstaTanda: "Latest export",
  evActualizarInformes: "Refresh",
  evSinInformes: "No reports yet. If the export is still running, the report will show up here when it finishes.",
  evSinRespuestaTanda: "No response was received from the server. The export may still be running: the sales states and the Excel report will appear when it finishes. Refresh the list in a few minutes.",
  evDepartamentos: "Departments",
  evEligeDepartamentos: "Choose departments",
  evTodosLosDepartamentos: "All departments",
  evTpvsAExportar: "POS to export",
  evTpvsAyuda: "In brackets, documents not yet exported.",
  evAperturasAExportar: "Cash sessions to export",
  evAperturaMasAntigua: "The oldest pending session",
  evAperturaMasAntiguaCadaTpv: "The oldest pending session of each POS",
  evIncluirFacturasQR: "Include QR invoices",
  evPendientesCorto: "pending",
  evRechazadosCorto: "rejected by BC",
  evOmitidosCorto: "skipped",
  evExcluidosCorto: "excluded",
  evSeExportaraSeleccion: "The following data will be exported",
  evResumenSeleccion: "Departments: {departamentos}. POS: {tpvs}. Sessions: {aperturas}. {qr}.",
  evConFacturasQR: "With pending QR invoices",
  evSinFacturasQR: "Without QR invoices",
  evExportacionTpvATpv: "Sent POS by POS and in chunks; whatever is rejected or skipped stays pending with its reason in the run's Excel.",
  evCifrasDeLaSeleccion: "Figures for the current selection.",
  evEstadoRechazadoBC: "Previously rejected",
  evEstadoOmitido: "Previously Skipped",
  evEstadoExcluido: "Excluded",
  evExcluirDeExportacion: "Exclude from export",
  evIncluirEnExportacion: "Include in export again",
  evVentaExcluida: "Sale excluded from export",
  evVentaIncluida: "Sale included in export again",
  evVentasIncluidasN: "{n} sales included again in the export",
  evVentasExcluidasN: "{n} sales excluded from the export",
  evIncluirSoloEste: "Include this one",
  evIncluirTambienAsociados: "Include related",
  evExcluirSoloEste: "Exclude this one",
  evExcluirTambienAsociados: "Exclude related",
  evAsociadosIncluirPregunta: "Do you want to include the related documents too, or only this one?",
  evAsociadosExcluirPregunta: "Do you want to exclude the related documents too, or only this one?",
  evAsociadosIncluirTexto: "Document {doc} has {n} related documents excluded from the export:",
  evAsociadosExcluirTexto: "Document {doc} has {n} related documents not yet exported that cannot be exported without it:",
  evAsociadosTitulo: "Related documents",
  evFechaDoc: "Doc. date",
  avisoOriginalNoExportado: "The referenced document is not exported; it will be sent once the original goes in",
  avisoExcluidaManual: "Excluded from the export",

  evCargarVentas: "Load sales",
  evSeleccionCambiada: "Selection changed, press to refresh the list.",
  evCambiosSinCargar: "You changed the selection and the list is not up to date. Press Load sales before exporting.",
  evModoAvanzadasTitulo: "How to count sales with several payments (split)",
  evAvanzadasTodas: "All sales",
  evAvanzadasSolo: "Split payments only",
  evAvanzadasSin: "Without split payments",
  evMasEnExcel: "… and {n} more. The full detail is in the export Excel file.",
  evMensajeEjemploParcial: "Partial send: some sales skipped by validation and others rejected (sample data)",
  evPrevisualizarRespuesta: "Preview response",
  evExcluidaTexto: "Excluded by the user: it will not be exported until it is included again.",
  evActualizandoVentas: "Refreshing sales with the new selection...",
  evActualizarVentas: "Refresh sales",
  evTramoNotaDefecto: "In both options the export runs in batches of 100 documents, unless another size is set below.",
  evDocumentosCada: "documents (minimum 50)",
  evTramoDeN: "In batches of",
  evTramoTodoDeUnaVez: "All at once",
  evPersonalizarTramos: "Set the batch size per send",
  evTramoNotaTodo: "The whole export will go in a single batch.",
  evTramoNota: "In both options the export runs in batches of {n} documents.",
  evQrNoIncluidas: "Not included",
  evQrIncluidas: "Included in the export",
  evFacturasQR: "QR invoices",
  evCargandoInformes: "Loading reports...",
  evConteoNoDisponible: "Count not available",
  evVentasExportadasN: "{n} sales exported",
  evEnvioTodoJuntoDesc: "Sales from all selected POS are sent together, in the order they were made.",
  evEnvioTodoJunto: "All TPVs together",
  evEnvioPorTpvDesc: "Goes through the selected POS one by one: each POS is sent and resolved separately.",
  evEnvioPorTpv: "Per TPV",
  evModoEnvio: "Sending",
  evInformesExportacion: "Latest export reports",
  evLineasVenta: "Sale lines",
  evCargandoLineas: "Loading lines…",
  evErrorCargandoLineas: "The lines could not be loaded.",
  evVolverAIntentar: "Try again",
  evSinLineas: "The sale has no lines.",
  evCodigoBC: "BC code",
  evUds: "Qty",
  evUnidadBC: "Unit",
  evMenu: "Menu",
  evIncluidoEnMenu: "Included",
  evTotalLineas: "Total",
  evImporteDeLaVenta: "Sale amount",
  evDescuento: "Disc.",
  // Cash closing (Z) report
  cierreCajaZDescripcion: "Full reconciliation of every Z: sales, payment methods, taxes, products and receipts",
  todaLaEmpresa: "Whole company",
  estadoZ: "Z status",
  zCerradas: "Closed only",
  zAbiertas: "Open only",
  zAbierta: "Open",
  zCerrada: "Closed",
  consultarRangoFechas: "Query a date range",
  ocultarFilasSinDatos: "Hide rows without data",
  zEnElInforme: "Z sessions in the report",
  ocultarDetalle: "Hide details",
  quitarFranja: "Clear time range",
  documentos: "Documents",
  buscarDocumento: "Search document (number, client, worker, table)",
  limpiar: "Clear",
  sector: "Sector",
  seleccionaSector: "Select a sector",
  desplazarIzquierda: "Scroll left",
  desplazarDerecha: "Scroll right",
  verIncidencias: "View issues",
  incidenciasTexto: "Prices, quantities and lines changed or removed on the POS during the Z",
  todasLasIncidencias: "All issues",
  todasLasZ: "All Z sessions",
  caja: "Register",
  sinIncidencias: "No issues match that filter",
  bloqueResumen: "Summary",
  bloqueAnalisisVentas: "Sales analysis",
  fechaCaja: "Register date",
  propinas: "Tips",
  ventasSinPropinas: "Sales excluding tips",
  formaPagoTipoSaldo: "Balance payment",
  incidenciasPrecioModificado: "Price changed",
  incidenciasLineaEliminada: "Line removed",
  incidenciasCantidadModificada: "Quantity changed",
  incidenciasDescuentoModificado: "Discount changed",
  incidenciasOtras: "Other issues",
  rangoNoDisponibleSectores: "With sectors only one day can be queried: a sector groups many POS terminals and a date range would make the report unmanageable. To narrow by POS use the view toolbar filter once the report is loaded.",
  analisisNegocio: "Business analysis",
  analisisNegocioDescripcion: "Sales, payment methods, issues and profitability compared across months and years",
  anPeriodo: "Period",
  anModoMes: "Month",
  anModoRango: "Range",
  anModoAnio: "Year",
  anMes: "Month to analyse",
  anCompararCon: "Compare with",
  anMesAnteriorYAnioAnterior: "Previous month and same month last year",
  anMesAnterior: "Previous month",
  anMismoMesAnioAnterior: "Same month last year",
  anSinComparar: "No comparison",
  anPeriodoA: "Period A",
  anPeriodoB: "Period B",
  anPeriodoC: "Period C",
  anAnio: "Year to analyse",
  anAnioAnteriorMismaFecha: "Previous year up to the same date",
  anRecalcular: "Recalculate",
  anRecalcularAyuda: "Recalculate ignoring cached data. Use it if a POS has re-uploaded its data. At most once an hour and three times a day.",
  anRecalcularEspera: "Data was recalculated recently. You can do it again in {tiempo}.",
  anRecalcularEsperaDia: "Three recalculations have already been made in the last 24 hours. You can recalculate again in {tiempo}.",
  anRecalcularConfirmacion: "Cached data for the queried POS terminals and months will be deleted and recalculated. It may take a few seconds.",
  anCalculandoPeriodos: "Calculating the selected periods…",
  anSinDatos: "No sales in the period",
  anSinDatosTexto: "There are no cash sessions or documents for the selected scope and period.",
  anPeriodosDistintaLongitud: "Periods of different length: compare the averages",
  anPestanaVentas: "Sales",
  anPestanaFormasPago: "Payment methods",
  anPestanaIncidencias: "Issues",
  anPestanaRentabilidad: "Profitability",
  anProximamente: "Available in the next phase",
  anEvolucionMensual: "Monthly trend",
  anUltimos13Meses: "last 13 months",
  anMediaDiaria: "Daily average",
  anCalculandoMesesAntiguos: "Calculating earlier months…",
  anVentasPorDia: "Sales by day",
  anAlinearPorDiaSemana: "Align by weekday",
  anVentasPorDiaSemana: "Sales by weekday",
  anMediaPorDiaConVentas: "average per day with sales",
  anVentasPorHora: "Sales by hour",
  anPorNegocioYTpv: "By business and POS",
  anVariacion: "Change",
  sesiones: "Sessions",
  anCompletaPeriodo: "Fill in the period to query",
  anPeriodoInvertido: "The period ends before it starts",
  anMaximo12Meses: "Each period can span at most 12 months",
  anCalculadosAhora: "{n} of {total} POS·months calculated now; the rest from saved data",
  anDatosDeCache: "Saved data (calculated on {fecha})",
  anHasta: "until",
  anNotaDistintaLongitud: "The periods differ in length: look at the averages",
  anNotaAlineadoSemana: "Aligned by weekday: day 1 is the first Monday of each period",
  anNotaBisiesto: "{periodo} includes 29 February {anio}, which has no counterpart in the other period",
  anDia: "Day",
  anFormasPagoMesesCompletos: "Payment-method breakdown is computed on full months: the period's day cutoff does not apply here.",
  anRepartoPorTipo: "Breakdown by payment type",
  anTiposPorPeriodo: "Payment types by period",
  anEvolucionFormasPago: "Payment methods trend",
  anEnPorcentaje: "As percentage",
  anPorTipoYMedio: "By payment type and method",
  formaPago: "Payment method",
  anPorcentajeMediosNota: "Each type's % is over the period total; each method's %, over its type.",
  anRatioIncidencias: "{n} issues per 100 documents",
  anRatioFrenteA: "ratio vs",
  anTipoPredominante: "Main type",
  anEvolucionIncidencias: "Issues trend",
  anBarrasTotalLineaRatio: "bars: total · line: per 100 documents",
  anIncidenciasPorDia: "Issues by day",
  anPulsaDiaParaCierreZ: "click a day to open its Z cash closing",
  anIncidenciasPorTipo: "Issues by type",
  anIncidenciasPorOperario: "Issues by worker",
  anIncidenciasPorProducto: "Issues by affected product",
  anAQueSeDeben: "what they are due to",
  anPor100Docs: "Per 100 docs.",
  anVariacionRatio: "Ratio change",
  anCoberturaCoste: "{conCoste} of {total} sold items have a recipe cost ({pct} % of net sales); only those are classified.",
  anCosteActualNota: "Cost is each product's current recipe cost, not the one it had in the period.",
  anRentabilidadMesesCompletos: "Profitability is computed on full months: the day cutoff does not apply here.",
  anPorProductoYTarifa: "Product × tariff",
  anPorProducto: "Product",
  anTodasLasCategorias: "All categories",
  anTodosLosCuadrantes: "All quadrants",
  anSinCoste: "No cost",
  anItems: "items",
  anMargenContribucion: "Contribution margin",
  anUmbrales: "Period thresholds",
  anIndicePopularidadMedio: "Average popularity index",
  anRentabilidadMedia: "Average profitability (CM per unit)",
  anMediaCoste: "Average cost",
  anMatrizPopularidadMargen: "Popularity × margin matrix",
  anMatrizExplicacion: "each bubble is an item; size is its total margin; lines are the thresholds",
  anMargenPorCuadrante: "Total margin by quadrant",
  anTopMargen: "Highest total margin",
  anCambiosCuadrante: "Quadrant changes",
  anTablaIngenieriaMenu: "Menu engineering",
  anNumeroVentas: "Sales",
  anCosteProducto: "Cost",
  anPrecioVentaSinIva: "Price excl. VAT",
  anIndicePopularidad: "Popularity index",
  anCosteProductoPct: "% cost",
  anTotalCoste: "Total cost",
  anTotalVentas: "Total sales",
  anMargenContribucionTotal: "Total CM",
  anClasifRentabilidad: "Profitability",
  anClasifPopularidad: "Popularity",
  anClasifFinal: "Classification",
  anTarifaNoIdentificada: "Tariff not identified: assigned to tariff 1",
  anNuevo: "new",
  anAlta: "High",
  anBaja: "Low",
  anSinUnidades: "No net units",
  anPrincipiosOmnes: "Pricing: Omnes principles",
  anTodaLaCarta: "Whole menu sold",
  anDispersionPrecios: "Price dispersion",
  anDispersionTexto: "Highest price {max} / lowest {min}",
  anDispersionIdeal: "Ideal between 2.5 and 3 for ranges of more than 12 dishes",
  anDispersionNoAplica: "The 2.5–3 rule applies to ranges of more than 12 dishes",
  anAmplitudGama: "Range breadth",
  anAmplitudTexto: "Equal-width bands; cuts at {bajo} and {alto}. Ideal 25 / 50 / 25 %.",
  anRelacionCalidadPrecio: "Value-for-money ratio",
  anPrecioMedioSolicitado: "Average price demanded",
  anPrecioMedioOfertado: "Average price offered",
  anSimularCambioPrecios: "Simulate price change",
  anBandaBaja: "Low band",
  anBandaMedia: "Middle band",
  anBandaAlta: "High band",
  anActual: "Current",
  anIdeal: "Ideal",
  anRecomendableSubir: "Raising prices is advisable (ratio > 1.00)",
  anRecomendableBajar: "Lowering prices is advisable (ratio < 0.90)",
  anRecomendableMantener: "Prices are right: keep them (ratio 0.90–1.00)",
  anCuadranteLider: "Leader",
  anCuadrantePopular: "Popular",
  anCuadranteRentable: "Profitable",
  anCuadranteRevisar: "To review",
  anCuadranteLiderAyuda: "High popularity and high margin: the dishes that carry the business. Keep and promote.",
  anCuadrantePopularAyuda: "Sells a lot but leaves little margin: review cost or price.",
  anCuadranteRentableAyuda: "Good margin but low sales: give it visibility or reposition it on the menu.",
  anCuadranteRevisarAyuda: "Neither sells nor leaves margin: candidate to change or remove.",
  anExportarPdfAyuda: "Export the current tab to PDF (charts and tables)",
  anExportarExcelAyuda: "Export the current tab to Excel (one sheet per block)",
  verAnalisisNegocio: "View analysis",
  verAnalisisNegocioAyuda: "Open 'Business analysis' with this company, these businesses and the month of the queried date",
  proximamente: "Coming soon",
  verAnalisisNegocioProximamente: "The 'Business analysis' report will be available soon",
  anPeriodosReordenados: "Periods are shown from most recent to oldest: {reciente} is the main period and the variation shows how much it changed compared with {antiguo}.",
  anVariacionDireccion: "Change from {antiguo} to {reciente}: how much the recent period changed compared with the previous one.",
  anExportarEsperaCarga: "Wait for the tab to finish loading before exporting it.",
  sinSesionesDeCaja: "No cash sessions",
  sinSesionesDeCajaTexto: "No POS in the selected scope opened a cash session on that date. A Z belongs to the day it was opened, even if it closes after midnight.",
  tpvsSinApertura: "POS not opened",
  facturasQRExcluidasTexto: "QR invoices do not belong to any Z and are not included in this report: they have their own report.",
  franjaHoraria: "Time range",
  franjaHorariaSoloAnalisis: "The time range only filters products and receipts. The reconciliation covers the whole session and is not affected.",
  aplicar: "Apply",
  productosVendidos: "Products sold",
  productosVendidosTexto: "Quantity of each product sold per Z. Excludes cancellations, stock and waste.",
  todosLosDocumentos: "All documents",
  formasPago: "Payment methods",
  invitacion: "Complimentary",
  cuentaCasa: "House account",
  valeRegalo: "Gift voucher",
  bloqueIdentificacion: "Identification",
  bloqueVentas: "Sales",
  bloqueFormasPago: "Payment methods",
  bloqueArqueo: "Cash reconciliation",
  bloqueImpuestos: "Taxes",
  numeroZ: "Z number",
  operarioCierre: "Employee",
  duracionHoras: "Duration (hours)",
  primerDocumento: "First document",
  ultimoDocumento: "Last document",
  numIncidencias: "Issues",
  numAnulados: "Voided documents",
  ventasBrutas: "Sales",
  abonos: "Credit notes",
  ventasTotales: "Total sales",
  numDocumentos: "Number of documents",
  numTickets: "Receipts",
  numFacturas: "Invoices",
  numRectificativas: "Credit notes",
  ticketMedio: "Average receipt",
  mediaPorComensal: "Average per guest",
  numInvitaciones: "Complimentary count",
  importeInvitaciones: "Complimentary amount",
  formaPagoTipoEfectivo: "Cash",
  formaPagoTipoTarjeta: "Card",
  formaPagoTipoCheque: "Cheque",
  formaPagoTipoOtros: "Other",
  totalFormasPago: "Total payment methods",
  ventaSegunTpv: "Sales according to POS",
  diferenciaConDocumentos: "Difference with documents",
  cambioInicial: "Opening float",
  gastosCaja: "Cash expenses",
  totalCalculado: "Calculated total",
  totalDeclarado: "Declared total",
  retirado: "Withdrawn",
  nuevaFianza: "New float",
  baseImponibleIva: "Taxable base VAT",
  cuotaIva: "VAT amount",
  baseImponibleTotal: "Total taxable base",
  totalImpuestos: "Total taxes",
  avisoZAbierta: "Z not closed: cannot be reconciled",
  avisoZDuracionExcesiva: "Z open longer than usual",
  avisoZConIncidencias: "Z with issues",
  avisoZSinVentas: "Z without sales",

  // --- Horario de disponibilidad Sinqro ---
  configurarHorarioSinqro: "Set availability schedule",
  horarioSinqroOnAyuda: "Pick a schedule or create a new one; the active one is what's sent to Sinqro.",
  horarioSinqroOffAyuda: "If you don't set a schedule, the menu will be available 24h in Sinqro.",
  copiarATodosLosDias: "Copy to the other days",
  anadirTramo: "Add time range",
  horarioSinqroSinTramos: "You enabled the schedule but some days have no valid ranges. Fill in the times or disable the schedule.",
  horarioSinqroRangoInvalido: "There are ranges whose end time is earlier than or equal to the start time.",

  // --- Biblioteca de horarios Sinqro ---
  seleccionaHorario: "Select a schedule",
  crearNuevoHorario: "Create new schedule",
  nombreHorario: "Schedule name",
  guardarHorario: "Save schedule",
  horarioGuardado: "Schedule saved",
  horarioEliminado: "Schedule deleted",
  confirmarEliminarHorario: "Delete this schedule? This action cannot be undone.",
  sinHorarios: "This business has no schedules yet. Create a new one.",
  nombreHorarioObligatorio: "Give the schedule a name.",
  horarioActivoAyuda: "The selected schedule is the one sent to Sinqro.",

  // --- Business tags (new screen) ---
  etiquetasDelNegocio: "Business tags",
  etiquetasClasifican: "They classify raw materials and suppliers.",
  etiquetasDosFamilias: "Two families that never mix: a raw material only carries raw material tags.",
  deMateriaPrima: "Raw material",
  deProveedor: "Supplier",
  conProblema: "With issues",
  familiasDeEtiquetas: "Tag families",
  sinTipo: "No type",
  verTodas: "View all",
  sinNombre: "(no name)",
  sinEtiquetaExplica: "raw materials with no tag assigned",
  sinEtiquetasEnEstaFamilia: "This business has no tags in this family.",
  notaEtiquetas: "Tags live on the business server POS, not one per terminal. This screen shows them all, including the ones the rest of the panel never displays.",
  estadoRaiz: "top-level tag",
  estadoDentroDe: "inside \u00ab{padre}\u00bb",
  estadoDeBaja: "deactivated",
  estadoNombreRepetido: "more than one tag has this name",
  estadoSinTipo: "neither raw material nor supplier",
  estadoBucle: "it is its own parent tag",
  estadoHuerfana: "hangs from tag {code}, which does not exist or belongs to another family",
  estadoNoSeVe: "not shown elsewhere in the panel: its branch breaks before reaching it",
  avisoEtiquetasOcultas: "<b>One raw material tag is not shown elsewhere in the panel</b>, \u00ab{nombre}\u00bb, with {m} raw materials in it. It appears in the list, but cannot be picked when editing a record. | <b>{n} raw material tags are not shown elsewhere in the panel</b>, including \u00ab{nombre}\u00bb, with {m} raw materials in them. They appear in the list, but cannot be picked when editing a record.",
  avisoMpConEtiquetaProveedor: "<b>One raw material carries a supplier tag.</b> They are two different families: that tag should not be selectable here. | <b>{n} raw materials carry a supplier tag.</b> They are two different families: those tags should not be selectable here.",
  avisoMpConEtiquetaSinTipo: "<b>One raw material carries a tag with no type.</b> It is neither raw material nor supplier, so it is not grouped anywhere. | <b>{n} raw materials carry a tag with no type.</b> They are neither raw material nor supplier, so they are not grouped anywhere.",
  avisoMpConEtiquetaDeBaja: "<b>A raw material has an inactive tag.</b> The tag exists, but the form no longer offers it, so there is no way to move the material out of it from the panel. | <b>{n} raw materials have an inactive tag.</b> The tags exist, but the form no longer offers them, so there is no way to move the materials out of them from the panel.",
  avisoMpConEtiquetaInexistente: "<b>A raw material points to a tag that does not exist.</b> The reference is broken: it does not show up in any report by tag. | <b>{n} raw materials point to a tag that does not exist.</b> The references are broken: they do not show up in any report by tag.",
  avisoEtiquetasSinTipo: "<b>There is one tag with no type.</b> It appears in no list, and neither do the tags hanging from it. | <b>There are {n} tags with no type.</b> They appear in no list, and neither do the tags hanging from them.",
  avisoMpSinEtiqueta: "<b>One raw material has no tag.</b> It is not grouped in any report by tag. | <b>{n} raw materials have no tag.</b> They are not grouped in any report by tag.",
  avisoEtiquetaRepetida: "<b>There are {n} tags named \u00ab{nombre}\u00bb</b> in {familia}. When picking one there is no way to tell which is which.",

  // --- New tag ---
  familia: "Family",
  queEsCadaFamilia: "What each family is for",
  ayudaFamiliaMateriaPrima: "classifies the raw materials in the warehouse. It is the only one that can be assigned to a raw material, and the one that groups the purchase and inventory reports.",
  ayudaFamiliaProveedor: "classifies suppliers, to group them in expense reports. It cannot be assigned to a raw material.",
  ningunaEsPrincipal: "None \u2014 it will be a top-level tag",
  ayudaEtiquetaPadre: "Only active tags from the same family are offered: a tag hanging from another family stops being shown elsewhere in the panel.",
  nombreEtiquetaObligatorio: "Give the tag a name.",
  etiquetaCreada: "Tag created.",
  noSeHaPodidoGuardar: "Could not save. Please try again.",

  // --- Editing and deactivating a tag ---
  editarEtiqueta: "Edit tag",
  reactivar: "Reactivate",
  padreCode: "code {code} (does not exist)",
  laFamiliaNoSeCambia: "The family cannot be changed: the raw materials already using it would stop meeting the rule. If you need another one, create a new tag.",
  etiquetaGuardada: "Tag saved.",
  etiquetaDadaDeBaja: "Tag deactivated.",
  etiquetaReactivada: "Tag reactivated.",
  darDeBajaEtiqueta: "Deactivate \u00ab{nombre}\u00bb",
  bajaConMateriasPrimas: "It has 1 raw material in it, which will be left pointing at a deactivated tag. | It has {n} raw materials in it, which will be left pointing at a deactivated tag.",
  bajaConHijas: "1 tag hangs from it and will be left without a valid parent. | {n} tags hang from it and will be left without a valid parent.",
  bajaSinConsecuencias: "It has no raw materials and no other tags in it. You can reactivate it at any time.",
  aQueEtiquetaVan: "Which tag do they go to?",
  bajaHijasSuben: "1 tag hangs from it and will move to {padre}. | {n} tags hang from it and will move to {padre}.",
  ningunaSeranPrincipales: "become top-level tags",
  bajaDejarSinEtiqueta: "Leave it with no tag instead of reassigning it | Leave all {n} with no tag instead of reassigning them",
  bajaMpReasignadas: "1 raw material reassigned. | {n} raw materials reassigned.",
  bajaMpSinEtiqueta: "1 raw material was left with no tag. | {n} raw materials were left with no tag.",
  bajaHijasMovidas: "1 tag moved up a level. | {n} tags moved up a level.",

  // --- Raw materials to review (tags screen modal) ---
  verYAsignar: "View and assign",
  asignarFamilia: "Assign family",
  tituloSinTipo: "Tags with no family",
  ayudaSinTipo: "They are neither raw material nor supplier, so they show up in no list, and neither does anything hanging from them. Tick the ones you want and choose the family they belong to.",
  queFamiliaLesCorresponde: "Which family do they belong to?",
  pistaMateriasPrimas: "1 raw material inside | {n} raw materials inside",
  pistaHijas: "1 tag inside, {familia} | {n} tags inside, {familia}",
  pistaNadie: "nobody uses it",
  sinTipoNadaQueVer: "Every tag has its family.",
  familiaAsignada: "Family assigned to 1 tag. | Family assigned to {n} tags.",
  tituloRevisar_sinEtiqueta: "Raw materials with no tag",
  tituloRevisar_etiquetaProveedor: "Raw materials with a supplier tag",
  tituloRevisar_etiquetaSinTipo: "Raw materials with an untyped tag",
  tituloRevisar_etiquetaDeBaja: "Raw materials with an inactive tag",
  tituloRevisar_etiquetaInexistente: "Raw materials with a missing tag",
  ayudaRevisar_sinEtiqueta: "They are not grouped in any report by tag. Tick the ones you want and choose the target tag below.",
  ayudaRevisar_etiquetaProveedor: "They carry a tag from the other family. Tick the ones you want and choose a raw material tag below.",
  ayudaRevisar_etiquetaSinTipo: "Their tag is neither raw material nor supplier, so it groups nothing. Tick the ones you want and choose a raw material tag below.",
  ayudaRevisar_etiquetaDeBaja: "Their tag is inactive, so the raw material form no longer offers it. Tick the ones you want and choose an active tag below.",
  ayudaRevisar_etiquetaInexistente: "They point to a tag that is no longer there. Tick the ones you want and choose the target tag below.",
  seleccionarNinguna: "None",
  revisarTruncado: "Showing the first of {total}. Use the search box to reach the rest. | Showing the first {n} of {total}. Use the search box to reach the rest.",
  revisarSinPermiso: "You can see the list, but you do not have permission to edit raw materials, so you cannot reassign them.",
  revisarNadaQueVer: "There are none left in this state.",
  asignarEtiqueta: "Assign this tag",
  elegirEtiquetaDestino: "Choose a raw material tag",
  etiquetasDeMateriaPrima: "Raw material tags",
  quitarEtiqueta: "Remove the tag",
  sinResultados: "No tag matches",
  dejarSinEtiqueta: "Leave with no tag",
  asignarACuantas: "Assign | Assign to {n}",
  confirmarDejarSinEtiqueta: "It will be left with no tag at all and will not be grouped in reports by tag. | All {n} will be left with no tag at all and will not be grouped in reports by tag.",
  materiasPrimasAsignadas: "Tag assigned to 1 raw material. | Tag assigned to {n} raw materials.",
  etiquetaSinNombre: "(unnamed tag)",
  destinoOculto: "Not visible in the rest of the panel",
  avisoDestinoOculto: "That tag is not visible in the rest of the panel: its branch is cut before reaching it. The raw materials will be grouped, but you still will not be able to pick it when editing a form.",
  errorInesperado: "Something unexpected happened. Please try again.",
  // Pausas en el informe de turnos (app de gestión de turnos)
  tpPausas: "Breaks",
  tpPorDias: "By day",
  tpPorTurnos: "By shift",
  tpHorario: "Schedule",
  tpDesayuno: "Breakfast",
  tpCigarro: "Smoke break",
  tpDescanso: "Rest",
  tpOtra: "Other",
  tpEnCurso: "in progress",
  tpTurnoDe: "shift of",
  tpJornadaPartida: "Split shift",
  tpParon: "Gap between shifts",
  tpDias: "days",
  tpNota: "Click a day to see its details. Breaks are informational: they do not change hours or pay.",
  // --- Categorias del negocio (Configuracion > Categorias) ---
  terminales: "Terminals",
  desiguales: "Out of sync",
  gruposDeCategorias: "Category groups",
  vistaListado: "List view",
  vistaColumnas: "Column view",
  verLos4Grupos: "See all 4 groups",
  catDe: "of",
  pantallaDelTerminal: "POS screen {n}",
  reindexar: "Reindex",
  grupoCompleto: "Group full",
  seGuardaEnTerminales: "It will be saved on the terminal of the business. | It will be saved on all {n} terminals of the business.",
  sinCategoriaExplica: "products in this group that are not in any category",
  huecoConBajasExplica: "only discontinued products left; release it to reuse it",
  liberarRanura: "Release",
  liberarRanuraTitulo: "Release this slot?",
  liberarRanuraTexto: "Its discontinued products are left without a category and the slot becomes free for a new category or for reindexing. Active products are not touched.",
  ranuraLiberada: "Slot released",
  huecoLibreExplica: "a category used to be here; its place is still reserved",
  verProductos: "View products",
  usarEsteHueco: "Use this slot",
  nombreCategoriaNueva: "New category name",
  seCrearaAlFinalDelGrupo: "It will be created empty, at the end of group {g}, on the terminal of the business. | It will be created empty, at the end of group {g}, on all {n} terminals.",
  grupoVacio: "This group is empty. Categories you create here will show on POS screen {n}.",
  fueraDeLosGrupos: "Outside the four groups",
  fueraDeLosGruposExplica: "the terminal uses them, but their key is not one of the usual 40",
  verDeUnoEnUno: "See groups one at a time",
  mostrarLos4Grupos: "Show all 4 groups",
  notaGruposTerminal: "The four groups are what the waiter sees on the terminal. A category is created inside a group and stays there; adding one places it at the end of its group, and editing or deleting does not move the others.",
  productosAsignados: "1 product assigned to «{categoria}». | {n} products assigned to «{categoria}».",
  reordenar: "Reorder",
  avisoOrdenDistinto: "<b>On 1 terminal the categories are on different keys than on the server.</b> Reorder them before anything else: until then, the other warnings may not be accurate. | <b>On {n} terminals the categories are on different keys than on the server.</b> Reorder them before anything else: until then, the other warnings may not be accurate.",
  avisoOtroNombre: "<b>One terminal calls the category «{nombre}» (group {g}) «{otro}».</b> Waiters using that terminal see a different name for the category.",
  unificar: "Unify",
  avisoNombreRepetido: "<b>There are two categories called \"{nombre}\"</b>, in group {g1} and group {g2}, with {p1} and {p2} products.",
  avisoDesiguales: "<b>One category has not reached every terminal.</b> It exists in the business but the name is missing on some, so its products are not grouped there. | <b>{n} categories have not reached every terminal.</b> They exist in the business but the name is missing on some, so their products are not grouped there.",
  avisoDesigualesSinNinguna: "Terminal {terminales} has none at all. | Terminals {terminales} have none at all.",
  aplicarATodos: "Apply to all",
  avisoTerminalesSinCategorias: "<b>One terminal has no categories at all.</b> A product created there will not appear in any. | <b>{n} terminals have no categories at all.</b> A product created there will not appear in any.",
  avisoProductosSinCategoria: "<b>One product is not in any category.</b> It still sells, but waiters can only reach it by searching. | <b>{n} products are not in any category.</b> They still sell, but waiters can only reach them by searching.",
  avisoTerminalPendiente: "<b>Terminal {terminales} is new and has not uploaded its menu yet.</b> It will copy it from the server on start-up and upload it; until then nothing is written to it from here and it does not count in these warnings. | <b>Terminals {terminales} are new and have not uploaded their menu yet.</b> They will copy it from the server on start-up and upload it; until then nothing is written to them from here and they do not count in these warnings.",
  unTerminalLaLlama: "one terminal calls it \"{otro}\"",
  pendienteEnTerminales: "pending on 1 terminal | pending on {n} terminals",
  enOtraTeclaEnTerminal: "on another key in one terminal; fixed by reordering",
  avisoSoloEnClientes: "<b>«{nombre}» (group {g}) only exists on terminal {terminales}.</b> The server doesn't have it, and the server is the master: create it there if it's right, or remove it from the terminal. | <b>«{nombre}» (group {g}) only exists on terminals {terminales}.</b> The server doesn't have it, and the server is the master: create it there if it's right, or remove it from those terminals.",
  crearEnServidor: "Create on the server",
  quitarDelTerminal: "Remove from the terminal | Remove from the terminals",
  soloEnTerminalSinServidor: "only on {terminales}; the server doesn't have it",
  crearEnServidorTitulo: "Create «{nombre}» on the server?",
  crearEnServidorExplica: "The server doesn't have it. It will be created there and on any terminal missing it.",
  bajaSoloEnClientes: "Only {terminales} has it. The server doesn't change.",
  enTodosLosTerminales: "on the only terminal | on all {n} terminals",
  nombreVacio: "The name cannot be left empty. To remove it, use Delete.",
  categoriaGuardada: "Category saved on the terminal. | Category saved on all {n} terminals.",
  categoriaCreada: "Category created on the terminal. | Category created on all {n} terminals.",
  productosMovidos: "1 product moved to the other category. | {n} products moved to the other category.",
  productosSinCategoriaAhora: "1 product is now without a category. | {n} products are now without a category.",
  categoriaEliminada: "Category deleted on the terminal. | Category deleted on all {n} terminals.",
  yaEstabanOrdenadas: "The categories in this group were already contiguous.",
  categoriasReindexadas: "1 category moved. The group has no gaps left. | {n} categories moved. The group has no gaps left.",
  categoriasReordenadas: "1 category put on its key. | {n} categories put on their keys.",
  reordenarSaltados: "Could not reorder on: {terminales}.",
  categoriasIgualadas: "1 category synced across every terminal. | {n} categories synced across every terminal.",
  categoriasSaltadas: "1 category has different names across terminals: you choose which one is right. | {n} categories have different names across terminals: you choose which one is right.",
  huecoConBajas: "Slot in use",
  huecoLibre: "Free slot",
  eliminarCategoria: "Delete \"{nombre}\"",
  eliminarConProductos: "It has 1 product inside. Choose where it goes before deleting it. | It has {n} products inside. Choose where they go before deleting it.",
  eliminarSinProductos: "It has no products inside. It will be deleted on the terminal. | It has no products inside. It will be deleted on all {n} terminals.",
  eliminarHuecoSeQueda: "The gap stays where it is: no other category is moved.",
  eligeDestino: "Choose where its products go.",
  moverProductosA: "Move its products to...",
  sinResultadosCategoria: "No category matches",
  grupoNumero: "Group {g}",
  dejarlosSinCategoria: "Leave them without a category",
  confirmarSinCategoriaTexto: "That product will stop appearing grouped on the terminal. It will still sell, but waiters will only reach it by searching for it. | Those {n} products will stop appearing grouped on the terminal. They will still sell, but waiters will only reach them by searching for them.",
  productosSinCategoriaTitulo: "Products with no category",
  productosSinCategoriaAyuda: "They are not grouped on the terminal, so waiters can only reach them by searching. Tick the ones you want and choose below which category they go to.",
  productoSinNombre: "(no name)",
  enNTerminales: "on 1 of {t} terminals | on {n} of {t} terminals",
  sinProductosSinCategoria: "No products are left without a category.",
  asignarEstaCategoria: "Assign this category",
  elegirCategoriaDestino: "Choose a category",
  reindexarTitulo: "Reindex group {g}?",
  reindexarQuitaHuecos: "1 gap removed: the categories end up together at the start of the group. | {n} gaps removed: the categories end up together at the start of the group.",
  reindexarCambiaTecla: "1 category changes key: it will show up somewhere else on the terminal. | {n} categories change key: they will show up somewhere else on the terminal.",
  reindexarProductosSeQuedan: "Products do not change category: they move with theirs.",
  reindexarComoQueda: "How it ends up:",
  reindexarSinCambios: "This group is already contiguous: there is nothing to reindex.",
  unificarTitulo: "Unify «{nombre}»?",
  aplicarTodosTitulo: "Apply the categories to every terminal?",
  unificarTodosLaLlaman: "Every terminal will call it «{nombre}».",
  unificarPorServidor: "The name on the server terminal is kept.",
  unificarPorMayoria: "The name used by most terminals is kept.",
  unificarCambiaEn: "Changes on 1 terminal: its waiters will see the new name and the old one is lost. | Changes on {n} terminals: their waiters will see the new name and the old one is lost.",
  igualarProductosSeQuedan: "Products are not touched: they stay in their category.",
  aplicarTodosEscribe: "The name of 1 category will be written on the terminals where it is missing. | The names of {n} categories will be written on the terminals where they are missing.",
  aplicarTodosSaltadas: "1 category with different names across terminals stays as it is: unify it from its warning. | {n} categories with different names across terminals stay as they are: unify them from their warnings.",
  igualarQueCambia: "What changes:",
  unificarOtroNombreBueno: "If the right name is a different one, cancel and rename it with the pencil: the name you enter will be saved on every terminal.",
  aplicarTodosFaltaEn: "missing on {terminales}",
  aplicarTodosNada: "Nothing to apply: the pending categories have different names across terminals and must be unified first.",
  igualarSeCrea: "missing",
  igualarSinNombre: "no name",
  reordenarTitulo: "Reorder the categories like on the server?",
  reordenarMandaServidor: "The order of the server «{servidor}» wins: on the other terminals, each category moves to the key it has there.",
  reordenarCambianTecla: "1 category changes key: it will appear somewhere else on its terminal. | {n} categories change key: they will appear somewhere else on their terminal.",
  reordenarApartadas: "1 category the server does not have is moved aside to another key to make room. | {n} categories the server does not have are moved aside to another key to make room.",
  reordenarProductosSeVan: "Products move with their category: none changes category.",
  reordenarNombresNoSeTocan: "No name is changed. If a name difference remains afterwards, fix it with Unify.",
  reordenarSinSitio: "This terminal is not reordered: there is no free key left to move the blocking categories to.",
  reordenarSeAparta: "moved aside",
  reordenarAmbiguos: "Not moved because their name is repeated: {nombres}.",
  reordenarSinCambios: "The categories are already on the same keys as on the server.",
  ordenPrimeroTitulo: "Better reorder first",
  ordenPrimeroTexto: "Some terminals have their categories on different keys than the server. It is best to reorder them before doing this: otherwise wrong changes may happen —for example, a name written over a different category— and correct behaviour afterwards is not guaranteed.",
  continuarIgualmente: "Continue anyway",
  reordenarPrimero: "Reorder first",
  // The "How do I fix it?" of the warnings. Fixed text: rendered with v-html.
  comoLoSoluciono: "How do I fix it?",
  consejoOrdenAvisos: "Fix them from top to bottom: each fix can change or clear the warnings below it. Reload the page after each one.",
  consejoOrdenDistinto: "<p>This usually happens when someone has created or moved categories on the POS itself: the same category is on one key on the server and on another key on that terminal.</p><ol><li>Press <b>Reorder</b>. It shows, terminal by terminal, which category moves to which key.</li><li>Confirm. Products go with their category: there's no need to place them again.</li><li>Wait for the terminal to sync and check on it that each key has its products.</li><li>Reload the page and carry on with the other warnings: they are accurate now.</li></ol><p>If a terminal shows as «could not be reordered», all its 40 keys are taken. Delete the categories it doesn't need and reorder again.</p><p>While this warning is up, don't unify names: you would put the name on the wrong key.</p>",
  consejoOtroNombre: "<p>Almost always, someone renamed it on the POS. The server is the master.</p><ul><li><b>If the server's name is right:</b> press <b>Unify</b> and every terminal will use that name.</li><li><b>If the terminal's name is right:</b> edit it with the pencil and type that name. It's saved on every terminal.</li><li><b>If the two names look like different categories</b> (for example, «BOTTLES» and «SHOTS»), it isn't a renamed category but crossed keys: reorder first.</li></ul><p>Until it's fixed, that group can't be reindexed.</p>",
  consejoSoloEnClientes: "<p>It was created on a client terminal and not on the server. Before deciding, check how many products it has and, if in doubt, ask the venue whether they use it.</p><ul><li><b>If they use it:</b> press <b>Create on the server</b>. It's created there and on the terminals that lack it, on the same key.</li><li><b>If it's not needed:</b> press <b>Remove from the terminal</b> and choose which category its products go to, so they aren't left without one.</li></ul>",
  consejoNombreRepetido: "<p>Two keys with the same name confuse the waiter, and Reorder doesn't move them because it can't tell which is which.</p><ul><li><b>If both are needed:</b> edit one with the pencil and give it a distinct name (for example, «WHITE WINES»).</li><li><b>If one isn't needed:</b> delete it with the X and move its products to the other.</li></ul><p>The right one is usually the one with more products.</p>",
  consejoDesiguales: "<p>This happens with terminals that were off or offline when the category was created, or with terminals added later. On each row, the amber status says how many terminals are missing it.</p><ol><li>If there are red different-name warnings, fix those first: those categories are skipped.</li><li>Press <b>Apply to all</b>. Before writing anything, it shows which terminal gets what.</li><li>Confirm and wait for the terminals to sync.</li></ol><p>If a terminal still lacks it after syncing, check that it's on and connected.</p>",
  consejoTerminalesSinCategorias: "<p>The business has no categories to send it yet. Create them with <b>Add category</b> in each group: they're created on every terminal at once.</p><p>If that terminal is no longer used, ask for it to be deactivated so it stops counting here.</p>",
  consejoProductosSinCategoria: "<p>They usually come from deleting a category without choosing a destination, or from products created on the POS without a category. They can still be sold, but waiters only reach them by searching.</p><ol><li>If the category they belong in doesn't exist, create it first with <b>Add category</b>.</li><li>Press <b>View products</b>, tick the ones that go together and choose the category.</li><li>Press <b>Assign this category</b>. They move on every terminal.</li><li>Repeat with the rest.</li></ol><p>The ones in a specific group can also be seen from the eye on its «Without category» row.</p>",
  consejoTerminalPendiente: "<p>Nothing to do here. Turn the terminal on with a connection: it will copy the server's menu and, once it uploads it, it will count here like any other.</p><p>If time goes by and this still shows, check that the terminal has been turned on and is connected.</p>",
};



// WEBPACK FOOTER //
// ./src/language/english.js